
import React, { useState, useEffect } from "react";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import Chart from "chart.js";
import Plot from 'react-plotly.js';
import {
  Row,
  Col,
} from "reactstrap";
// import { Line } from "react-chartjs-2";
import CircularProgress from '@material-ui/core/CircularProgress';


// import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';



import { createMuiTheme, makeStyles } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';


// reactstrap components
import { Table, Container } from "reactstrap";
import Typography from '@material-ui/core/Typography';

// import "./custom.css";
// core components
// import Header from "components/Headers/Header.js";
// const _csv = require('csvtojson')

// ##############################################

import PropTypes from 'prop-types';
import PageTitle from "../../components/PageTitle/PageTitle";
// import {
//   Line as Line2, LineChart, BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer,

//   ScatterChart, Scatter, ComposedChart, Area
// } from 'recharts';
// import { scaleOrdinal } from 'd3-scale';
// import { TramOutlined } from "@material-ui/icons";


const theme = createMuiTheme({
  palette: {
    primary: green,
  },
});

const getPath = (x, y, width, height) => `M${x},${y + height}
          C${x + width / 3},${y + height} ${x + width / 2},${y + height / 3} ${x + width / 2}, ${y}
          C${x + width / 2},${y + height / 3} ${x + (2 * width) / 3},${y + height} ${x + width}, ${y + height}
          Z`;

const TriangleBar = (props) => {
  const { fill, x, y, width, height } = props;

  return <path d={getPath(x, y, width, height)} stroke="none" fill={fill} />;
};

TriangleBar.propTypes = {
  fill: PropTypes.string,
  x: PropTypes.number,
  y: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number,
};


// #####################################################

const datasets = {
  "project_name": "Adult_Income",
  "module_name": "Adult_Income_Module",
  "od": {
    "project_name": "Adult_Income",
    "module_name": "Adult_Income_Module",
    "header": "Outlier Detection",
    "values": [
      {
        "x": [
          "-24.696",
          "53.526",
          "24.113",
          "16.912",
          "39.133",
          "-82.157",
          "-50.981",
          "83.958",
          "43.152",
          "25.068",
          "-22.225",
          "-38.333",
          "0.128",
          "-20.468",
          "50.737",
          "-34.982",
          "-48.602",
          "26.039",
          "-39.933",
          "-5.091",
          "3.317",
          "-63.442",
          "-22.525",
          "-4.99",
          "-60.179",
          "-5.3",
          "30.906",
          "-49.913",
          "-2.973",
          "-5.787",
          "-13.151",
          "18.045",
          "-56.185",
          "-6.341",
          "-67.436",
          "14.384",
          "56.647",
          "-47.704",
          "-61.233",
          "66.567",
          "-34.782",
          "24.253",
          "44.193",
          "37.061",
          "59.952",
          "-3.644",
          "-11.494",
          "-61.488",
          "-58.689",
          "69.742",
          "-5.414",
          "17.115",
          "-12.438",
          "69.833",
          "53.606",
          "-36.424",
          "48.298",
          "3.928",
          "12.524",
          "-1.799",
          "9.526",
          "-11.995",
          "45.399",
          "-26.794",
          "59.233",
          "53.329",
          "2.506",
          "25.343",
          "-25.127",
          "66.671",
          "-38.781",
          "-15.838",
          "-6.667",
          "-73.014",
          "27.334",
          "-8.463",
          "22.503",
          "56.963",
          "-52.671",
          "4.109",
          "13.785",
          "39.361",
          "-42.767",
          "-58.179",
          "-11.05",
          "19.141",
          "37.613",
          "-56.458",
          "18.201",
          "-7.743",
          "-5.964",
          "48.979",
          "63.317",
          "-37.006",
          "49.756",
          "7.898",
          "-50.62",
          "-34.951",
          "84.394",
          "-48.209",
          "-39.488",
          "-33.947",
          "56.877",
          "63.954",
          "27.994",
          "-25.579",
          "53.325",
          "-43.565",
          "-81.943",
          "-22.408",
          "38.485",
          "-1.985",
          "13.238",
          "-71.982",
          "-45.756",
          "73.647",
          "-63.934",
          "-63.355",
          "13.346",
          "16.482",
          "-56.696",
          "-12.125",
          "-16.037",
          "-2.102",
          "-20.141",
          "59.519",
          "55.429",
          "76.081",
          "3.57",
          "-44.57",
          "-17.003",
          "20.663",
          "-32.513",
          "23.805",
          "34.013",
          "-28.539",
          "51.994",
          "-19.368",
          "13.529",
          "41.815",
          "58.153",
          "-66.723",
          "8.836",
          "81.96",
          "-31.288",
          "34.813",
          "14.533",
          "15.381",
          "24.632",
          "6.085",
          "36.77",
          "-23.429",
          "-6.591",
          "-1.277",
          "-36.501",
          "-5.977",
          "-10.919",
          "19.575",
          "-3.108",
          "55.391",
          "2.258",
          "-32.208",
          "14.53",
          "10.794",
          "-6.308",
          "-40.162",
          "-38.374",
          "-41.456",
          "-20.528",
          "-7.817",
          "-19.905",
          "-33.394",
          "-10.007",
          "15.774",
          "-18.969",
          "-16.57",
          "14.684",
          "15.52",
          "-64.117",
          "21.303",
          "69.695",
          "-44.734",
          "-22.304",
          "61.741",
          "-43.903",
          "-53.068",
          "-43.85",
          "-35.365",
          "42.999",
          "85.705",
          "-20.522",
          "6.212",
          "65.552",
          "-10.741",
          "-1.667",
          "7.796",
          "-1.108",
          "30.289",
          "-47.916",
          "-15.768",
          "-33.765",
          "23.021",
          "-40.179",
          "-13.963",
          "-11.634",
          "-17.427",
          "-48.242",
          "67.147",
          "60.131",
          "49.261",
          "2.24",
          "5.102",
          "-67.82",
          "60.957",
          "34.605",
          "-8.649",
          "-6.618",
          "14.279",
          "-17.93",
          "55.556",
          "-28.699",
          "-59.056",
          "15.061",
          "-25.711",
          "32.726",
          "-18.013",
          "-28.723",
          "-14.767",
          "55.435",
          "8.338",
          "58.283",
          "-19.509",
          "75.944",
          "-4.015",
          "1.708",
          "8.468",
          "-54.507",
          "69.459",
          "-3.477",
          "27.911",
          "-18.97",
          "30.88",
          "80.741",
          "-29.16",
          "47.974",
          "-29.835",
          "14.355",
          "51.491",
          "-5.289",
          "-17.366",
          "55.528",
          "3.455",
          "77.994",
          "83.714",
          "-17.465",
          "27.249",
          "65.745",
          "71.289",
          "38.181",
          "19.134",
          "-75.878",
          "-50.156",
          "6.174",
          "82.479",
          "-48.454",
          "12.349",
          "-46.477",
          "-48.733",
          "19.607",
          "19.06",
          "32.315",
          "-30.35",
          "17.376",
          "18.954",
          "-69.779",
          "17.127",
          "64.193",
          "-48.744",
          "-29.16",
          "-66.733",
          "-49.767",
          "-21.136",
          "68.677",
          "-40.275",
          "34.008",
          "64.951",
          "-63.146",
          "5.602",
          "-20.137",
          "-36.27",
          "-45.755",
          "21.021",
          "-0.388",
          "-44.219",
          "-42.318",
          "19.859",
          "-56.332",
          "-55.932",
          "25.952",
          "-48.149",
          "-66.632",
          "-1.692",
          "11.097",
          "8.633",
          "85.848",
          "23.327",
          "20.505",
          "-12.093",
          "46.926",
          "17.555",
          "-19.433",
          "52.267",
          "17.491",
          "-51.551",
          "-50.003",
          "16.448",
          "-9.954",
          "63.785",
          "-38.216",
          "-34.601",
          "-4.808",
          "7.333",
          "11.077",
          "-28.16",
          "-20.355",
          "51.836",
          "0.864",
          "-66.612",
          "2.565",
          "-37.281",
          "57.708",
          "41.885",
          "-36.7",
          "-68.277",
          "-61.515",
          "65.881",
          "43.456",
          "-18.725",
          "-54.239",
          "-34.633",
          "43.909",
          "-41.075",
          "0.433",
          "11.9",
          "57.338",
          "-60.952",
          "7.478",
          "-78.425",
          "-39.96",
          "32.424",
          "80.642",
          "-51.604",
          "58.823",
          "62.101",
          "69.719",
          "-1.44",
          "2.293",
          "39.721",
          "-24.444",
          "-9.877",
          "16.217",
          "-56.523",
          "51.073",
          "-65.261",
          "72.678",
          "18.811",
          "-24.835",
          "81.78",
          "41.447",
          "-8.174",
          "-25.47",
          "-55.595",
          "-23.702",
          "2.325",
          "-33.264",
          "-5.013",
          "-19.304",
          "61.568",
          "68.854",
          "-14.704",
          "38.392",
          "-19.064",
          "18.815",
          "10.552",
          "7.934",
          "10.039",
          "-11.381",
          "-8.281",
          "-42.007",
          "-76.222",
          "-74.322",
          "64.291",
          "-28.333",
          "-19.225",
          "61.335",
          "-7.398",
          "-28.078",
          "-34.404",
          "2.504",
          "-37.301",
          "-18.968",
          "-27.302",
          "-67.278",
          "-2.989",
          "20.42",
          "-44.86",
          "-18.359",
          "-34.815",
          "-48.608",
          "2.288",
          "-9.167",
          "26.242",
          "-49.065",
          "-39.056",
          "-57.967",
          "-35.648",
          "-56.278",
          "-61.534",
          "10.838",
          "17.398",
          "-13.31",
          "70.851",
          "-10.686",
          "44.127",
          "82.314",
          "-38.933",
          "14.839",
          "-26.302",
          "39.729",
          "-20.264",
          "6.897",
          "-6.454",
          "51.155",
          "-63.449",
          "56.095",
          "-25.859",
          "42.123",
          "53.798",
          "2.495",
          "38.427",
          "82.87",
          "-17.578",
          "-63.684",
          "-34.213",
          "28.281",
          "-42.318",
          "87.074",
          "-15.31",
          "-14.246",
          "-32.015",
          "-23.15",
          "29.383",
          "-22.178",
          "-9.481",
          "-3.404",
          "-45.682",
          "-30.432",
          "-38.982",
          "65.338",
          "-5.187",
          "17.629",
          "43.023",
          "-65.597",
          "29.947",
          "-82.227",
          "-42.709",
          "19.402",
          "48.537",
          "-73.604",
          "38.833",
          "37.234",
          "80.816",
          "-34.925",
          "-19.904",
          "-8.461",
          "-32.87",
          "-71.203",
          "19.238",
          "-34.411",
          "-48.535",
          "-49.429",
          "-22.557",
          "64.151",
          "-19.723",
          "17.405",
          "-41.3",
          "-26.014",
          "39.901",
          "-24.411",
          "55.682",
          "46.539",
          "-26.379",
          "-54.362",
          "-48.102",
          "-1.124",
          "-2.645",
          "-27.547",
          "46.802",
          "52.458",
          "20.435",
          "-34.911",
          "-2.865",
          "-36.855",
          "-4.946",
          "51.143",
          "18.535",
          "18.866",
          "22.625",
          "83.333",
          "-45.256",
          "85.381",
          "15.104"
        ],
        "y": [
          "-13.179",
          "32.936",
          "-8.528",
          "-33.328",
          "-46.685",
          "42.226",
          "-52.686",
          "-44.434",
          "-5.288",
          "-4.675",
          "-65.528",
          "-23.219",
          "-85.738",
          "24.897",
          "-56.54",
          "76.024",
          "41.237",
          "67.38",
          "65.197",
          "-64.103",
          "-70.647",
          "-9.502",
          "33.144",
          "25.919",
          "9.235",
          "15.285",
          "86.124",
          "-56.051",
          "-44.106",
          "-49.262",
          "-6.336",
          "-21.616",
          "-58.5",
          "-39.955",
          "20.556",
          "78.882",
          "-54.146",
          "-31.169",
          "11.572",
          "-23.916",
          "-15.629",
          "25.048",
          "-11.586",
          "-50.079",
          "55.289",
          "27.721",
          "-12.807",
          "-9.634",
          "-27.834",
          "1.559",
          "-75.397",
          "-19.875",
          "-46.445",
          "7.409",
          "0.196",
          "3.243",
          "-12.199",
          "-37.375",
          "30.807",
          "-21.165",
          "-84.328",
          "-46.29",
          "-39.061",
          "-10.031",
          "13.584",
          "2.407",
          "12.837",
          "43.727",
          "-33.857",
          "-29.676",
          "2.987",
          "71.853",
          "-39.034",
          "41.162",
          "22.683",
          "-46.039",
          "63.61",
          "33.157",
          "-42.224",
          "75.673",
          "-12.985",
          "-31.146",
          "45.283",
          "-41.861",
          "23.684",
          "8.131",
          "41.295",
          "4.647",
          "-65.367",
          "28.121",
          "-78.414",
          "-30.645",
          "-15.76",
          "66.267",
          "49.587",
          "18.536",
          "47.22",
          "-41.158",
          "-23.97",
          "6.501",
          "-45.775",
          "-79.523",
          "-7.247",
          "-36.162",
          "-70.15",
          "-34.756",
          "-60.744",
          "-13.212",
          "42.461",
          "7.283",
          "-25.866",
          "-82.512",
          "97.927",
          "-27.214",
          "-13.899",
          "-1.403",
          "9.092",
          "-3.247",
          "-6.701",
          "-24.631",
          "-27.653",
          "-13.559",
          "-61.387",
          "-9.02",
          "12.048",
          "-54.302",
          "-57.674",
          "-11.109",
          "-27.061",
          "-36.638",
          "-87.198",
          "-34.741",
          "52.334",
          "-5.559",
          "-32.593",
          "47.822",
          "-28.257",
          "13.779",
          "-61.467",
          "32.241",
          "-51.784",
          "19.784",
          "66.318",
          "-35.536",
          "56.033",
          "-67.865",
          "-29.89",
          "45.789",
          "-5.06",
          "-75.713",
          "70.132",
          "16.973",
          "44.614",
          "-24.765",
          "-72.656",
          "-78.309",
          "-21.896",
          "-31.008",
          "27.339",
          "12.16",
          "-4.529",
          "53.653",
          "63.778",
          "-61.367",
          "-5.724",
          "-9.545",
          "25.533",
          "-32.983",
          "-7.324",
          "28.745",
          "-24.546",
          "11.111",
          "80.265",
          "44.817",
          "-27.788",
          "85.514",
          "-33.344",
          "-33.431",
          "4.799",
          "13.126",
          "18.21",
          "63.433",
          "48.406",
          "-24.088",
          "61.623",
          "-28.277",
          "-8.877",
          "54.681",
          "57.212",
          "-36.946",
          "30.387",
          "3.634",
          "-11.538",
          "24.475",
          "60.361",
          "67.694",
          "-67.431",
          "64.669",
          "49.864",
          "-8.882",
          "-40.117",
          "11.872",
          "65.349",
          "82.8",
          "-59.624",
          "-15.987",
          "29.655",
          "-18.084",
          "-52.879",
          "36.484",
          "-70.404",
          "-74.404",
          "44.985",
          "12.178",
          "66.157",
          "41.09",
          "16.281",
          "89.542",
          "-29.387",
          "-8.585",
          "33.957",
          "7.517",
          "-40.266",
          "16.655",
          "39.718",
          "68.95",
          "57.079",
          "-84.723",
          "55.793",
          "66.637",
          "13.769",
          "31.56",
          "17.715",
          "-12.186",
          "3.209",
          "76.945",
          "-58.02",
          "7.916",
          "79.086",
          "43.214",
          "0.001",
          "68.02",
          "-37.138",
          "10.931",
          "31.527",
          "-69.796",
          "-37.417",
          "-27.587",
          "64.672",
          "17.207",
          "-2.835",
          "-38.428",
          "19.278",
          "-47.782",
          "74.34",
          "18.751",
          "-41.109",
          "19.296",
          "37.834",
          "45.356",
          "46.875",
          "-39.071",
          "-94.013",
          "-36.669",
          "55.653",
          "21.146",
          "29.725",
          "52.732",
          "-65.383",
          "-40.646",
          "-65.609",
          "37.151",
          "-65.185",
          "96.996",
          "-25.194",
          "18.866",
          "-20.94",
          "53.059",
          "10.931",
          "-9.355",
          "-54.543",
          "74.429",
          "6.513",
          "-5.023",
          "-37.777",
          "-30.469",
          "-9.071",
          "66.779",
          "41.686",
          "-25.652",
          "-13.899",
          "65.297",
          "79.376",
          "60.642",
          "-27.402",
          "-59.727",
          "-43.324",
          "42.401",
          "-15.456",
          "-54.133",
          "39.14",
          "-12.781",
          "90.742",
          "38.383",
          "-28.176",
          "3.525",
          "15.151",
          "11.41",
          "0.923",
          "-18.291",
          "-23.712",
          "52.802",
          "4.04",
          "-48.909",
          "-16.323",
          "-12.1",
          "28.477",
          "-34.404",
          "-75.773",
          "66.701",
          "13.495",
          "37.979",
          "46.918",
          "45.471",
          "69.56",
          "-27.677",
          "74.707",
          "-9.711",
          "-31.854",
          "40.929",
          "52.962",
          "-7.482",
          "49.614",
          "15.737",
          "46.866",
          "-19.563",
          "-41.974",
          "28.963",
          "28.82",
          "66.733",
          "12.162",
          "-51.173",
          "-68.529",
          "93.879",
          "-3.574",
          "40.917",
          "49.604",
          "43.13",
          "-50.339",
          "-73.488",
          "-16.324",
          "49.263",
          "51.348",
          "55.28",
          "7.407",
          "78.544",
          "-19.716",
          "35.945",
          "18.323",
          "-10.844",
          "91.446",
          "48.662",
          "50.136",
          "-43.098",
          "0.54",
          "81.519",
          "43.715",
          "-20.609",
          "74.826",
          "12.945",
          "-34.386",
          "-22.826",
          "80.939",
          "18.394",
          "-40.851",
          "72.459",
          "23.015",
          "10.859",
          "6.006",
          "14.788",
          "-49.975",
          "77.999",
          "82.508",
          "-56.638",
          "21.211",
          "36.385",
          "-64.379",
          "28.999",
          "66.496",
          "46.384",
          "-28.797",
          "55.382",
          "-87.588",
          "-1.326",
          "-47.163",
          "-4.688",
          "-76.017",
          "-70.362",
          "18.482",
          "22.91",
          "0.001",
          "-35.274",
          "18.567",
          "72.981",
          "-28.545",
          "-53.803",
          "13.472",
          "41.707",
          "42.035",
          "-89.287",
          "-19.646",
          "25.243",
          "-19.304",
          "-49.702",
          "3.637",
          "-76.698",
          "-32.996",
          "8.987",
          "-96.969",
          "13.533",
          "78.134",
          "1.777",
          "20.057",
          "4.45",
          "-28.034",
          "23.142",
          "68.495",
          "83.997",
          "73.735",
          "-34.904",
          "-81.904",
          "6.64",
          "49.837",
          "19.211",
          "2.734",
          "83.961",
          "-40.663",
          "-3.59",
          "-33.749",
          "-50.36",
          "-38.796",
          "81.464",
          "-18.068",
          "1.151",
          "83.183",
          "-27.403",
          "-42.717",
          "78.654",
          "78.368",
          "-40.254",
          "9.198",
          "8.864",
          "-4.504",
          "65.551",
          "24.39",
          "-12.411",
          "53.282",
          "-22.92",
          "56.716",
          "25.488",
          "19.692",
          "31.846",
          "-44.666",
          "84.649",
          "42.367",
          "-52.038",
          "9.615",
          "-60.999",
          "41.221",
          "29.583",
          "-69.722",
          "8.587",
          "67.139",
          "-24.495",
          "30.026",
          "78.087",
          "-18.283",
          "-13.986",
          "2.515",
          "-16.985",
          "52.428",
          "-23.146",
          "-25.919",
          "-20.151",
          "-7.536",
          "-32.913",
          "-35.367",
          "76.7",
          "-31.362",
          "33.563",
          "33.172",
          "75.39",
          "-52.02",
          "52.185",
          "78.311",
          "26.293",
          "49.035",
          "-13.8",
          "-63.133",
          "5.408",
          "51.133",
          "26.405",
          "39.942",
          "40.97",
          "48.686",
          "-19.814",
          "7.109",
          "-5.112",
          "-47.289",
          "-15.922",
          "-41.8",
          "-41.194"
        ],
        "type": "scatter",
        "mode": "markers",
        "marker": {
          "color": "blue"
        },
        "name": "Normal"
      },
      {
        "x": [
          "-18.035",
          "15.98",
          "-47.762",
          "59.269",
          "27.27",
          "-31.984",
          "2.937",
          "36.697",
          "-9.414",
          "-6.968",
          "50.482",
          "16.188",
          "3.216",
          "-6.32",
          "-25.385",
          "-57.674",
          "43.416",
          "-67.233",
          "59.129",
          "26.447",
          "-53.512",
          "-65.278",
          "-30.28",
          "-3.077",
          "46.151",
          "34.642",
          "-70.36",
          "18.79",
          "18.492",
          "-60.774",
          "-30.578",
          "42.51",
          "43.407",
          "66.337",
          "-0.896",
          "26.788",
          "11.111",
          "-20.584",
          "12.652",
          "19.944",
          "19.961",
          "15.368",
          "3.672",
          "15.283",
          "-32.23",
          "14.347",
          "46.909",
          "27.556",
          "-70.093",
          "-20.544",
          "-21.301",
          "33.855",
          "-12.601",
          "-10.477",
          "44.97",
          "8.095",
          "-14.22",
          "-42.717",
          "-14.5",
          "68.327",
          "48.816",
          "-30.135",
          "88.242",
          "-78.69",
          "-21.389",
          "-69.827",
          "7.318",
          "-61.742",
          "28.657",
          "23.587",
          "-34.047",
          "-35.844",
          "-20.317",
          "-5.602",
          "-32.894",
          "14.594",
          "44.317",
          "-75.563",
          "27.093",
          "-2.532",
          "85.56",
          "83.026",
          "-13.376",
          "-28.489",
          "-58.677",
          "20.482",
          "-2.636",
          "19.11",
          "-16.538",
          "-38.831",
          "67.365",
          "54.209",
          "13.918",
          "-4.784",
          "27.03",
          "-33.472",
          "-3.243",
          "2.462",
          "43.205",
          "-15.134",
          "-78.84",
          "18.354",
          "-26.292",
          "10.343",
          "88.109",
          "-55.986",
          "-0.565",
          "65.128",
          "-27.628",
          "35.471",
          "2.783",
          "16.913",
          "-68.748",
          "-3.445",
          "25.082",
          "-38.675",
          "-56.259",
          "48.989",
          "-1.653",
          "4.038",
          "-32.923",
          "-0.849",
          "-0.707",
          "-71.913",
          "14.674",
          "42.666",
          "-15.435",
          "11.992",
          "-70.696",
          "50.507",
          "19.816",
          "-3.332",
          "-32.756",
          "-2.077",
          "34.984",
          "3.718",
          "-38.951",
          "-71.023",
          "12.525",
          "-76.817",
          "41.27",
          "3.497",
          "-31.35",
          "-23.508",
          "22.234",
          "39.496",
          "-14.69",
          "-6.063",
          "-30.368",
          "-19.448",
          "-16.835",
          "-27.907",
          "-74.586",
          "9.343",
          "-38.444",
          "-48.077",
          "-46.153",
          "-41.672",
          "-32.485",
          "20.473",
          "25.308",
          "-76.534",
          "-29.749",
          "-63.472",
          "33.265",
          "7.337",
          "-46.02",
          "-53.351",
          "-56.612",
          "27.168",
          "23.151",
          "1.97",
          "47.78",
          "62.463",
          "-14.779",
          "-53.328",
          "54.513",
          "5.209",
          "-41.052",
          "1.054",
          "9.741",
          "50.441",
          "41.222",
          "17.595",
          "12.041",
          "-33.582",
          "81.536",
          "-13.014",
          "38.138",
          "10.766",
          "-5.538",
          "12.34",
          "-44.123",
          "12.579",
          "-68.938",
          "-66.097",
          "23.608",
          "-60.947",
          "-64.512",
          "-33.043",
          "-33.044",
          "-51.814",
          "12.761",
          "23.937",
          "-76.799",
          "-45.487",
          "-69.361",
          "-63.288",
          "-58.405",
          "21.176",
          "-73.003",
          "-68.573",
          "83.145",
          "-31.658",
          "-48.227",
          "26.57",
          "-4.729",
          "-21.236",
          "-10.071",
          "80.661",
          "86.649",
          "-13.216",
          "6.46",
          "-24.713",
          "45.887",
          "63.206",
          "24.178",
          "-15.669",
          "21.124",
          "35.222",
          "83.236",
          "53.083",
          "27.574",
          "51.726",
          "-69.951",
          "13.869",
          "16.836",
          "29.848",
          "-63.849",
          "-63.755",
          "-11.648",
          "-60.671",
          "-0.013",
          "62.47",
          "-41.255",
          "-0.739",
          "14.84",
          "-54.778",
          "50.254",
          "-33.973",
          "5.886",
          "-32.448",
          "-43.923",
          "-39.899",
          "-31.401",
          "33.364",
          "-53.071",
          "45.899",
          "-9.534",
          "65.895",
          "58.149",
          "16.322",
          "-1.512",
          "-50.986",
          "11.139",
          "-21.046",
          "53.804",
          "38.836",
          "24.39",
          "56.69",
          "38.936",
          "1.76",
          "11.787",
          "44.319",
          "30.751",
          "55.099",
          "14.278",
          "-22.287",
          "5.257",
          "39.915",
          "-62.82",
          "-62.756",
          "85.509",
          "81.991",
          "-1.976",
          "26.535",
          "-70.853",
          "-37.006",
          "-82.373",
          "-73.868",
          "1.465",
          "-31.98",
          "-62.081",
          "-30.331",
          "-22.254",
          "-22.426",
          "52.24",
          "13.323",
          "-37.33",
          "62.015",
          "6.489",
          "-71.245",
          "-18.083",
          "50.615",
          "18.161",
          "-62.495",
          "-56.457",
          "-63.618",
          "-35.599",
          "-12.804",
          "-28.431",
          "-14.486",
          "-5.635",
          "-1.445",
          "-20.503",
          "-19.703",
          "-11.172",
          "32.411",
          "76.823",
          "-56.281",
          "0.204",
          "-72.087",
          "-17.622",
          "-38.231",
          "67.287",
          "-65.955",
          "-46.372",
          "61.963",
          "-78.784",
          "-71.369",
          "40.429",
          "-0.175",
          "-4.008",
          "-19.214",
          "3.521",
          "-25.69",
          "34.644",
          "42.869",
          "3.119",
          "84.253",
          "36.57",
          "49.85",
          "46.738",
          "6.449",
          "35.344",
          "13.378",
          "5.857",
          "-41.261",
          "-14.554",
          "-52.442",
          "-17.907",
          "-14.831",
          "-71.409",
          "-22.068",
          "-0.407",
          "25.721",
          "-58.743",
          "-59.998",
          "25.388",
          "-19.458",
          "-23.281",
          "26.378",
          "25.618",
          "-5.869",
          "13.921",
          "58.604",
          "22.476",
          "-19.003",
          "-20.061",
          "-21.287",
          "-4.751",
          "60.708",
          "-21.141",
          "17.866",
          "-70.505",
          "50.507",
          "10.649",
          "-59.399",
          "-3.618",
          "-24.581",
          "6.17",
          "-14.398",
          "5.343",
          "-61.215",
          "-49.353",
          "41.683",
          "18.391",
          "13.307",
          "1.348",
          "18.01",
          "-54.976",
          "39.295",
          "-5.575",
          "-64.141",
          "-71.094",
          "23.76",
          "11.496",
          "26.435",
          "44.023",
          "-75.07",
          "-76.962",
          "-3.706",
          "-42.065",
          "24.77",
          "27.051",
          "3.528",
          "-34.044",
          "86.336",
          "-61.662",
          "-68.945",
          "18.414",
          "19.993",
          "-64.128",
          "-7.214",
          "59.801",
          "-76.252",
          "-64.227",
          "3.427",
          "20.577",
          "18.561",
          "57.979",
          "-38.447",
          "-9.552",
          "-10.905",
          "-26.166",
          "-51.92",
          "24.12",
          "17.647",
          "-32.406",
          "-65.166",
          "-23.046",
          "43.096",
          "-76.893",
          "59.045",
          "-19.273",
          "27.563",
          "-38.232",
          "42.524",
          "5.396",
          "16.29",
          "25.031",
          "-39.133",
          "52.477",
          "-21.678",
          "20.306",
          "26.631",
          "-16.599",
          "43.967",
          "61.733",
          "62.619",
          "-73.951",
          "-59.889",
          "-25.251",
          "-63.716",
          "-32.09",
          "-70.948",
          "22.201",
          "50.984",
          "-48.213",
          "-64.883",
          "-33.711",
          "-53.271",
          "32.172",
          "-17.96",
          "17.685",
          "-33.913",
          "-7.222",
          "-59.55",
          "15.52",
          "-35.467",
          "-44.314",
          "43.626",
          "4.411",
          "11.517",
          "-42.264",
          "-22.207",
          "29.028",
          "27.951",
          "-54.509",
          "-40.683",
          "36.891",
          "26.491",
          "-21.234",
          "-66.1",
          "46.859",
          "-47.703",
          "-78.296",
          "-19.253",
          "-19.822",
          "84.94",
          "-33.923",
          "-75.807",
          "66.024",
          "-65.607",
          "-7.124",
          "-20.626",
          "-28.946",
          "-5.784",
          "-67.057",
          "-65.228",
          "44.239",
          "-17.518",
          "-7.961",
          "-8.1",
          "12.553",
          "-58.753",
          "-65.999",
          "-19.777",
          "8.047",
          "27.026",
          "13.754",
          "-70.455"
        ],
        "y": [
          "73.655",
          "20.883",
          "7.51",
          "-44.239",
          "38.236",
          "74.25",
          "62.133",
          "39.241",
          "30.829",
          "-34.887",
          "-66.103",
          "9.587",
          "-37.962",
          "79.161",
          "83.795",
          "2.289",
          "-6.747",
          "-33.86",
          "2.133",
          "63.443",
          "26.265",
          "-36.524",
          "79.594",
          "12.201",
          "-0.541",
          "-64.497",
          "-21.035",
          "16.945",
          "-35.347",
          "-2.48",
          "15.92",
          "73.147",
          "-6.644",
          "-33.401",
          "-82.362",
          "0.192",
          "-38.294",
          "73.328",
          "88.648",
          "97.328",
          "-59.155",
          "45.343",
          "-26.92",
          "67.883",
          "79.459",
          "-34.518",
          "34.104",
          "68.762",
          "-14.158",
          "-69.764",
          "-66.195",
          "39.019",
          "0.156",
          "29.176",
          "51.381",
          "-35.862",
          "17.109",
          "69.123",
          "-94.218",
          "2.315",
          "-13.831",
          "-6.645",
          "-32.609",
          "43.261",
          "88.364",
          "-25.421",
          "81.814",
          "9.493",
          "19.741",
          "-19.681",
          "-69.325",
          "-1.846",
          "-69.36",
          "0.044",
          "67.496",
          "-28.865",
          "50.925",
          "30.521",
          "-10.121",
          "-84.601",
          "-22.972",
          "-22.786",
          "85.989",
          "74.487",
          "-31.16",
          "-58.275",
          "-65.631",
          "-7.953",
          "12.413",
          "-21.422",
          "-20.0",
          "-48.013",
          "5.013",
          "-80.059",
          "21.183",
          "70.185",
          "62.3",
          "67.855",
          "-46.785",
          "-83.62",
          "43.17",
          "-0.143",
          "-82.133",
          "19.006",
          "-33.68",
          "-61.614",
          "-13.661",
          "6.846",
          "82.52",
          "71.986",
          "-28.934",
          "67.666",
          "16.248",
          "-27.837",
          "-24.748",
          "-21.669",
          "4.75",
          "48.939",
          "60.233",
          "38.326",
          "-70.26",
          "20.544",
          "77.938",
          "-23.623",
          "100.063",
          "38.24",
          "-70.008",
          "17.431",
          "17.332",
          "-66.069",
          "-22.708",
          "42.698",
          "68.305",
          "77.573",
          "30.217",
          "77.748",
          "-51.441",
          "-17.723",
          "81.54",
          "26.996",
          "-2.34",
          "75.48",
          "79.418",
          "-20.029",
          "45.315",
          "-29.119",
          "24.417",
          "-61.653",
          "76.706",
          "-68.253",
          "24.634",
          "-3.987",
          "-30.61",
          "-78.326",
          "-55.28",
          "-52.354",
          "35.99",
          "42.696",
          "-86.128",
          "-8.317",
          "67.49",
          "33.693",
          "7.553",
          "2.814",
          "-38.242",
          "43.145",
          "35.975",
          "-31.952",
          "-58.253",
          "-10.051",
          "-4.259",
          "68.128",
          "36.978",
          "-16.044",
          "-44.855",
          "-31.764",
          "-58.276",
          "66.737",
          "-55.764",
          "-33.929",
          "51.215",
          "53.47",
          "-37.958",
          "7.89",
          "-29.556",
          "-81.271",
          "-14.992",
          "72.395",
          "-24.432",
          "-97.08",
          "-73.623",
          "-28.863",
          "23.686",
          "-81.531",
          "15.561",
          "-18.435",
          "-14.067",
          "11.049",
          "10.652",
          "-21.96",
          "-78.145",
          "47.59",
          "89.106",
          "-31.43",
          "37.107",
          "-22.435",
          "26.608",
          "-0.823",
          "11.087",
          "3.911",
          "29.901",
          "-38.023",
          "13.459",
          "67.008",
          "6.479",
          "23.917",
          "43.838",
          "-20.655",
          "70.876",
          "12.106",
          "-37.143",
          "-90.954",
          "82.885",
          "-81.614",
          "-14.001",
          "-44.183",
          "60.756",
          "-9.405",
          "12.752",
          "71.95",
          "-42.353",
          "7.453",
          "85.461",
          "2.817",
          "-38.584",
          "67.845",
          "-8.064",
          "-71.693",
          "8.36",
          "8.598",
          "41.242",
          "50.873",
          "63.729",
          "6.113",
          "29.93",
          "15.432",
          "0.008",
          "-62.03",
          "48.565",
          "-69.914",
          "41.403",
          "76.527",
          "22.978",
          "-21.412",
          "-9.049",
          "-74.47",
          "25.655",
          "-13.077",
          "-61.885",
          "0.695",
          "1.912",
          "10.485",
          "78.931",
          "25.952",
          "48.588",
          "-33.696",
          "7.69",
          "-52.543",
          "27.346",
          "1.173",
          "-46.503",
          "-5.376",
          "64.727",
          "50.952",
          "60.563",
          "34.573",
          "67.887",
          "74.236",
          "35.213",
          "-69.272",
          "2.78",
          "43.722",
          "-22.948",
          "-31.647",
          "62.314",
          "-6.266",
          "17.129",
          "-22.104",
          "41.828",
          "28.299",
          "76.914",
          "67.422",
          "-37.241",
          "-76.245",
          "-25.806",
          "85.178",
          "3.192",
          "-31.183",
          "-73.478",
          "-11.317",
          "2.19",
          "-23.376",
          "69.32",
          "55.426",
          "-24.969",
          "-16.354",
          "-60.616",
          "-5.249",
          "-45.087",
          "-45.841",
          "-32.669",
          "87.981",
          "-2.602",
          "76.956",
          "-72.98",
          "-66.207",
          "70.09",
          "85.633",
          "14.914",
          "12.653",
          "3.481",
          "-23.841",
          "-15.078",
          "41.081",
          "-44.055",
          "11.813",
          "26.77",
          "54.914",
          "43.019",
          "-18.589",
          "-40.429",
          "-20.494",
          "-49.088",
          "-70.725",
          "77.703",
          "85.424",
          "-31.616",
          "51.627",
          "-38.472",
          "-25.0",
          "-27.022",
          "35.481",
          "34.235",
          "-81.91",
          "-30.212",
          "-5.325",
          "-71.725",
          "29.909",
          "84.7",
          "-31.871",
          "-14.421",
          "76.368",
          "29.07",
          "-2.622",
          "-13.565",
          "-5.901",
          "-31.218",
          "38.656",
          "2.146",
          "16.153",
          "-24.107",
          "-6.699",
          "21.929",
          "9.361",
          "-7.573",
          "35.097",
          "19.9",
          "-2.549",
          "80.739",
          "-22.019",
          "64.752",
          "-24.583",
          "72.786",
          "-28.154",
          "18.18",
          "-66.069",
          "30.64",
          "-10.731",
          "42.799",
          "82.226",
          "38.233",
          "-46.417",
          "-78.233",
          "11.532",
          "-33.22",
          "-6.679",
          "42.013",
          "-18.65",
          "77.559",
          "-32.995",
          "26.234",
          "36.089",
          "42.914",
          "0.204",
          "-17.84",
          "-24.705",
          "-80.789",
          "-7.299",
          "10.917",
          "25.025",
          "47.626",
          "-79.462",
          "68.493",
          "38.075",
          "-10.047",
          "82.488",
          "78.119",
          "-35.864",
          "45.831",
          "22.213",
          "-35.133",
          "66.575",
          "0.155",
          "-34.59",
          "-28.603",
          "27.583",
          "0.171",
          "-70.114",
          "24.361",
          "-35.628",
          "32.652",
          "75.384",
          "-12.292",
          "81.687",
          "74.079",
          "-56.394",
          "60.785",
          "-34.479",
          "56.3",
          "-0.701",
          "-68.412",
          "-43.46",
          "32.859",
          "-56.719",
          "-70.765",
          "25.967",
          "-75.958",
          "51.684",
          "66.779",
          "-21.331",
          "-14.224",
          "63.133",
          "-63.01",
          "-71.066",
          "5.256",
          "-24.095",
          "-2.56",
          "51.151",
          "-23.58",
          "-35.643",
          "-24.825",
          "47.217",
          "36.406",
          "-7.637",
          "-85.089",
          "-17.421",
          "18.496",
          "-65.349",
          "7.732",
          "-17.718",
          "78.28",
          "-39.829",
          "-71.758",
          "89.316",
          "-9.278",
          "40.843",
          "71.607",
          "-10.765",
          "-15.475",
          "54.738",
          "25.285",
          "-46.845",
          "-1.89",
          "-84.535",
          "-51.054",
          "-64.746",
          "60.296",
          "23.48",
          "27.513",
          "23.761",
          "75.963",
          "-14.959",
          "74.921",
          "-4.92",
          "2.056",
          "-29.409",
          "30.411",
          "77.107",
          "90.229",
          "-44.761",
          "66.535",
          "38.675",
          "1.068",
          "-4.221",
          "71.717",
          "-73.735",
          "-87.397",
          "-78.749",
          "18.779",
          "-0.463",
          "4.343",
          "6.284",
          "16.547",
          "73.122",
          "-81.486",
          "-8.196",
          "-40.055",
          "84.893",
          "48.656",
          "-61.631",
          "-33.726",
          "17.356"
        ],
        "type": "scatter",
        "mode": "markers",
        "marker": {
          "color": "red"
        },
        "name": "Outlier"
      }
    ],
    "layout": {
      "autosize": false,
      "margin": {
        "l": 50,
        "r": 50,
        "b": 50,
        "t": 50,
        "pad": 0
      },
      "height": 350,
      "width": 875,
      "xaxis": {
        "title": "X_embedded_1(TSNE)"
      },
      "yaxis": {
        "title": "X_embedded_2(TSNE)"
      },
      "showlegend": true
    },
    "features": [
      {
        "title": "age",
        "train_oulier": "0.4",
        "test_oulier": "0.4",
        "feat_imp": "28.4",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "title": "bins"
            },
            "yaxis": {
              "title": "pdf"
            },
            "showlegend": true
          },
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "title": "data"
            },
            "yaxis": {
              "title": "values"
            },
            "showlegend": true
          }
        ],
        "data": [
          [
            {
              "x": [
                17,
                18.46,
                19.92,
                21.38,
                22.84,
                24.3,
                25.76,
                27.22,
                28.68,
                30.14,
                31.6,
                33.06,
                34.52,
                35.98,
                37.44,
                38.9,
                40.36,
                41.82,
                43.28,
                44.74,
                46.2,
                47.66,
                49.12,
                50.58,
                52.04,
                53.5,
                54.96,
                56.42,
                57.88,
                59.34,
                60.8,
                62.26,
                63.72,
                65.18,
                66.64,
                68.1,
                69.56,
                71.02,
                72.48,
                73.94,
                75.4,
                76.86,
                78.32,
                79.78,
                81.24,
                82.7,
                84.16,
                85.62,
                87.08,
                88.54,
                90
              ],
              "y": [
                0.029,
                0.021,
                0.045,
                0.025,
                0.053,
                0.024,
                0.048,
                0.026,
                0.051,
                0.027,
                0.054,
                0.026,
                0.027,
                0.054,
                0.026,
                0.049,
                0.025,
                0.046,
                0.022,
                0.044,
                0.022,
                0.035,
                0.017,
                0.033,
                0.014,
                0.012,
                0.024,
                0.012,
                0.022,
                0.009,
                0.016,
                0.007,
                0.013,
                0.005,
                0.008,
                0.003,
                0.005,
                0.003,
                0.003,
                0.003,
                0.001,
                0.002,
                0.001,
                0.002,
                0,
                0.001,
                0,
                0,
                0,
                0.001
              ],
              "type": "lines",
              "name": "reference",
              "fill": "tozeroy",
              "marker": {
                "color": "blue"
              }
            },
            {
              "x": [
                17,
                18.46,
                19.92,
                21.38,
                22.84,
                24.3,
                25.76,
                27.22,
                28.68,
                30.14,
                31.6,
                33.06,
                34.52,
                35.98,
                37.44,
                38.9,
                40.36,
                41.82,
                43.28,
                44.74,
                46.2,
                47.66,
                49.12,
                50.58,
                52.04,
                53.5,
                54.96,
                56.42,
                57.88,
                59.34,
                60.8,
                62.26,
                63.72,
                65.18,
                66.64,
                68.1,
                69.56,
                71.02,
                72.48,
                73.94,
                75.4,
                76.86,
                78.32,
                79.78,
                81.24,
                82.7,
                84.16,
                85.62,
                87.08,
                88.54,
                90
              ],
              "y": [
                0.031,
                0.023,
                0.045,
                0.023,
                0.05,
                0.025,
                0.05,
                0.027,
                0.051,
                0.027,
                0.051,
                0.028,
                0.027,
                0.053,
                0.026,
                0.048,
                0.026,
                0.048,
                0.021,
                0.046,
                0.021,
                0.033,
                0.019,
                0.033,
                0.015,
                0.013,
                0.026,
                0.01,
                0.022,
                0.011,
                0.019,
                0.006,
                0.012,
                0.005,
                0.009,
                0.003,
                0.005,
                0.002,
                0.001,
                0.003,
                0.001,
                0.001,
                0.001,
                0.001,
                0.001,
                0,
                0,
                0,
                0,
                0.001
              ],
              "type": "lines",
              "name": "production",
              "fill": "tozeroy",
              "marker": {
                "color": "red"
              }
            }
          ],
          [
            {
              "y": [
                25,
                38,
                28,
                44,
                18,
                34,
                29,
                63,
                24,
                55,
                65,
                36,
                26,
                58,
                48,
                43,
                20,
                43,
                37,
                40,
                34,
                34,
                72,
                25,
                25,
                45,
                22,
                23,
                54,
                32,
                46,
                56,
                24,
                23,
                26,
                65,
                36,
                22,
                17,
                20,
                65,
                44,
                36,
                29,
                20,
                28,
                39,
                54,
                52,
                56,
                18,
                39,
                21,
                22,
                38,
                21,
                63,
                34,
                42,
                33,
                30,
                39,
                26,
                33,
                47,
                41,
                41,
                19,
                46,
                43,
                55,
                46,
                30,
                21,
                46,
                17,
                41,
                69,
                50,
                20,
                45,
                23,
                24,
                44,
                31,
                43,
                20,
                55,
                24,
                41,
                59,
                49,
                33,
                59,
                34,
                20,
                25,
                49,
                59,
                20,
                51,
                33,
                22,
                58,
                52,
                36,
                41,
                28,
                19,
                18,
                18,
                28,
                29,
                20,
                40,
                26,
                46,
                23,
                44,
                43,
                31,
                18,
                19,
                41,
                41,
                69,
                48,
                28,
                27,
                41,
                41,
                24,
                20,
                42,
                57,
                30,
                36,
                49,
                33,
                23,
                46,
                18,
                40,
                43,
                34,
                47,
                44,
                33,
                55,
                19,
                28,
                27,
                50,
                22,
                40,
                25,
                26,
                22,
                42,
                38,
                55,
                32,
                22,
                29,
                46,
                31,
                58,
                42,
                18,
                58,
                54,
                34,
                26,
                61,
                48,
                36,
                24,
                40,
                33,
                37,
                34,
                56,
                28,
                37,
                44,
                64,
                54,
                23,
                34,
                22,
                33,
                39,
                47,
                79,
                26,
                31,
                44,
                42,
                19,
                27,
                51,
                28,
                57,
                45,
                50,
                34,
                45,
                73,
                34,
                31,
                19,
                25,
                38,
                39,
                23,
                49,
                33,
                21,
                31,
                23,
                34,
                25,
                39,
                52,
                63,
                41,
                46,
                53,
                25,
                77,
                18,
                38,
                55,
                34,
                80,
                34,
                52,
                42,
                26,
                31,
                25,
                55,
                19,
                62,
                22,
                39,
                35,
                28,
                47,
                44,
                21,
                35,
                24,
                42,
                28,
                21,
                62,
                39,
                30,
                72,
                50,
                28,
                29,
                26,
                27,
                29,
                61,
                29,
                21,
                31,
                25,
                58,
                64,
                46,
                53,
                19,
                42,
                18,
                58,
                20,
                35,
                32,
                23,
                31,
                33,
                41,
                22,
                46,
                61,
                30,
                42,
                63,
                26,
                42,
                23,
                25,
                30,
                23,
                34,
                30,
                39,
                30,
                38,
                26,
                20,
                37,
                33,
                24,
                42,
                51,
                56,
                22,
                52,
                44,
                34,
                51,
                20,
                19,
                37,
                68,
                22,
                56,
                37,
                52,
                26,
                33,
                45,
                18,
                43,
                64,
                18,
                20,
                57,
                41,
                34,
                19,
                44,
                56,
                36,
                48,
                29,
                33,
                31,
                39,
                66,
                27,
                39,
                59,
                26,
                31,
                45,
                23,
                36,
                34,
                32,
                37,
                33,
                50,
                32,
                35,
                37,
                44,
                57,
                29,
                55,
                43,
                43,
                45,
                33,
                26,
                23,
                41,
                24,
                47,
                34,
                40,
                28,
                24,
                73,
                23,
                43,
                26,
                58,
                52,
                29,
                47,
                49,
                40,
                62,
                49,
                50,
                31,
                48,
                24,
                41,
                37,
                45,
                63,
                36,
                45,
                41,
                26,
                17,
                27,
                43,
                35,
                38,
                26,
                28,
                38,
                36,
                33,
                19,
                22,
                42,
                50,
                30,
                37,
                54,
                52,
                65,
                33,
                25,
                24,
                26,
                39,
                59,
                29,
                47,
                23,
                64,
                21,
                32,
                26,
                19,
                62,
                32,
                75,
                45,
                31,
                32,
                24,
                25,
                41,
                18,
                44,
                40,
                27,
                23,
                21,
                37,
                65,
                43,
                45,
                24,
                24,
                19,
                37,
                24,
                34,
                50,
                36,
                39,
                44,
                45,
                32,
                47,
                50,
                32,
                19,
                19,
                28,
                28,
                39,
                21,
                73,
                39,
                25,
                31,
                51,
                39,
                31,
                21,
                46,
                73,
                41,
                20,
                27,
                24,
                20,
                39,
                27,
                33,
                33,
                36,
                55,
                19,
                35,
                34,
                62,
                33,
                39,
                36,
                41,
                39,
                38,
                18,
                61,
                20,
                35,
                27,
                66
              ],
              "type": "box",
              "name": "reference",
              "marker": {
                "color": "blue"
              }
            },
            {
              "y": [
                32,
                60,
                18,
                36,
                26,
                24,
                90,
                20,
                27,
                58,
                37,
                65,
                28,
                36,
                45,
                23,
                69,
                58,
                22,
                58,
                53,
                44,
                31,
                46,
                48,
                46,
                43,
                43,
                17,
                20,
                22,
                19,
                35,
                29,
                18,
                25,
                54,
                23,
                36,
                26,
                25,
                46,
                41,
                31,
                48,
                52,
                22,
                18,
                46,
                34,
                30,
                31,
                21,
                41,
                45,
                30,
                21,
                44,
                54,
                36,
                50,
                26,
                47,
                36,
                32,
                21,
                30,
                34,
                51,
                55,
                43,
                37,
                28,
                39,
                35,
                59,
                26,
                68,
                46,
                21,
                23,
                17,
                23,
                34,
                33,
                31,
                31,
                56,
                21,
                45,
                41,
                26,
                41,
                46,
                47,
                43,
                35,
                44,
                58,
                25,
                44,
                57,
                24,
                38,
                33,
                25,
                33,
                50,
                35,
                36,
                27,
                22,
                30,
                90,
                39,
                34,
                39,
                19,
                19,
                29,
                66,
                38,
                44,
                34,
                35,
                29,
                22,
                33,
                73,
                35,
                41,
                27,
                25,
                47,
                36,
                36,
                25,
                37,
                26,
                53,
                36,
                30,
                53,
                37,
                41,
                53,
                23,
                28,
                53,
                32,
                33,
                27,
                52,
                31,
                27,
                44,
                37,
                39,
                18,
                42,
                49,
                35,
                43,
                43,
                31,
                27,
                46,
                54,
                37,
                53,
                26,
                59,
                36,
                32,
                53,
                26,
                35,
                48,
                30,
                38,
                58,
                44,
                30,
                68,
                26,
                26,
                41,
                43,
                48,
                55,
                50,
                41,
                52,
                24,
                31,
                54,
                31,
                31,
                47,
                40,
                46,
                45,
                39,
                34,
                48,
                19,
                56,
                47,
                35,
                25,
                43,
                59,
                66,
                63,
                32,
                58,
                43,
                27,
                21,
                44,
                40,
                65,
                50,
                18,
                51,
                44,
                20,
                29,
                50,
                50,
                43,
                23,
                41,
                30,
                58,
                50,
                37,
                21,
                33,
                52,
                47,
                45,
                34,
                39,
                31,
                19,
                45,
                45,
                34,
                27,
                37,
                20,
                32,
                24,
                39,
                18,
                62,
                24,
                37,
                46,
                44,
                53,
                25,
                44,
                24,
                61,
                45,
                33,
                48,
                26,
                40,
                68,
                24,
                25,
                31,
                55,
                46,
                58,
                56,
                45,
                24,
                35,
                51,
                47,
                17,
                21,
                45,
                42,
                56,
                39,
                31,
                20,
                65,
                44,
                33,
                25,
                38,
                31,
                33,
                49,
                28,
                29,
                23,
                37,
                52,
                27,
                47,
                21,
                41,
                61,
                32,
                21,
                63,
                34,
                21,
                44,
                26,
                36,
                39,
                52,
                44,
                42,
                60,
                31,
                30,
                23,
                81,
                39,
                38,
                21,
                28,
                34,
                47,
                36,
                27,
                56,
                57,
                42,
                43,
                48,
                53,
                58,
                19,
                37,
                41,
                31,
                31,
                53,
                19,
                56,
                55,
                51,
                62,
                43,
                45,
                28,
                46,
                62,
                57,
                60,
                23,
                47,
                21,
                51,
                61,
                52,
                76,
                24,
                31,
                43,
                58,
                18,
                19,
                44,
                41,
                21,
                40,
                25,
                62,
                42,
                35,
                19,
                60,
                20,
                23,
                18,
                40,
                19,
                51,
                41,
                18,
                41,
                27,
                71,
                25,
                73,
                45,
                25,
                50,
                44,
                44,
                49,
                44,
                42,
                20,
                66,
                19,
                60,
                46,
                42,
                59,
                58,
                47,
                58,
                69,
                17,
                19,
                28,
                37,
                30,
                36,
                45,
                59,
                45,
                53,
                37,
                26,
                53,
                44,
                27,
                22,
                41,
                53,
                58,
                34,
                32,
                32,
                47,
                27,
                25,
                40,
                36,
                23,
                44,
                19,
                42,
                60,
                41,
                45,
                67,
                36,
                52,
                28,
                83,
                17,
                27,
                35,
                40,
                23,
                51,
                51,
                82,
                28,
                53,
                29,
                19,
                30,
                23,
                66,
                27,
                35,
                17,
                27,
                27,
                44,
                64,
                62,
                26,
                40,
                40,
                35,
                25,
                52,
                46,
                30,
                52,
                28,
                17,
                46,
                45,
                21,
                18,
                17,
                90,
                23,
                41,
                19,
                69,
                23,
                28,
                37,
                57,
                30,
                48,
                73,
                25,
                33,
                36,
                28,
                57,
                31,
                35
              ],
              "type": "box",
              "name": "production",
              "marker": {
                "color": "red"
              }
            }
          ]
        ]
      },
      {
        "title": "educational-num",
        "train_oulier": "3.6",
        "test_oulier": "3.8",
        "feat_imp": "7.3",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "title": "bins"
            },
            "yaxis": {
              "title": "pdf"
            },
            "showlegend": true
          },
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "title": "data"
            },
            "yaxis": {
              "title": "values"
            },
            "showlegend": true
          }
        ],
        "data": [
          [
            {
              "x": [
                1,
                1.3,
                1.6,
                1.9,
                2.2,
                2.5,
                2.8,
                3.1,
                3.4,
                3.7,
                4,
                4.3,
                4.6,
                4.9,
                5.2,
                5.5,
                5.8,
                6.1,
                6.4,
                6.7,
                7,
                7.3,
                7.6,
                7.9,
                8.2,
                8.5,
                8.8,
                9.1,
                9.4,
                9.7,
                10,
                10.3,
                10.6,
                10.9,
                11.2,
                11.5,
                11.8,
                12.1,
                12.4,
                12.7,
                13,
                13.3,
                13.6,
                13.9,
                14.2,
                14.5,
                14.8,
                15.1,
                15.4,
                15.7,
                16
              ],
              "y": [
                0.002,
                0,
                0,
                0.005,
                0,
                0,
                0.01,
                0,
                0,
                0,
                0.019,
                0,
                0,
                0.015,
                0,
                0,
                0.028,
                0,
                0,
                0,
                0.037,
                0,
                0,
                0.013,
                0,
                0,
                0.326,
                0,
                0,
                0,
                0.222,
                0,
                0,
                0.042,
                0,
                0,
                0.032,
                0,
                0,
                0,
                0.165,
                0,
                0,
                0.055,
                0,
                0,
                0.016,
                0,
                0,
                0.012
              ],
              "type": "lines",
              "name": "reference",
              "fill": "tozeroy",
              "marker": {
                "color": "blue"
              }
            },
            {
              "x": [
                1,
                1.3,
                1.6,
                1.9,
                2.2,
                2.5,
                2.8,
                3.1,
                3.4,
                3.7,
                4,
                4.3,
                4.6,
                4.9,
                5.2,
                5.5,
                5.8,
                6.1,
                6.4,
                6.7,
                7,
                7.3,
                7.6,
                7.9,
                8.2,
                8.5,
                8.8,
                9.1,
                9.4,
                9.7,
                10,
                10.3,
                10.6,
                10.9,
                11.2,
                11.5,
                11.8,
                12.1,
                12.4,
                12.7,
                13,
                13.3,
                13.6,
                13.9,
                14.2,
                14.5,
                14.8,
                15.1,
                15.4,
                15.7,
                16
              ],
              "y": [
                0.002,
                0,
                0,
                0.006,
                0,
                0,
                0.01,
                0,
                0,
                0,
                0.02,
                0,
                0,
                0.016,
                0,
                0,
                0.029,
                0,
                0,
                0,
                0.036,
                0,
                0,
                0.016,
                0,
                0,
                0.317,
                0,
                0,
                0,
                0.225,
                0,
                0,
                0.043,
                0,
                0,
                0.034,
                0,
                0,
                0,
                0.162,
                0,
                0,
                0.053,
                0,
                0,
                0.019,
                0,
                0,
                0.013
              ],
              "type": "lines",
              "name": "production",
              "fill": "tozeroy",
              "marker": {
                "color": "red"
              }
            }
          ],
          [
            {
              "y": [
                7,
                9,
                12,
                10,
                10,
                6,
                9,
                15,
                10,
                4,
                9,
                13,
                9,
                9,
                9,
                14,
                10,
                9,
                9,
                16,
                13,
                10,
                4,
                13,
                13,
                9,
                9,
                9,
                9,
                10,
                10,
                7,
                13,
                10,
                9,
                9,
                13,
                3,
                6,
                9,
                14,
                11,
                9,
                7,
                10,
                11,
                4,
                10,
                7,
                9,
                10,
                9,
                10,
                9,
                5,
                10,
                9,
                13,
                9,
                9,
                13,
                10,
                14,
                9,
                9,
                13,
                12,
                10,
                9,
                9,
                10,
                11,
                9,
                10,
                10,
                6,
                9,
                9,
                9,
                10,
                10,
                13,
                10,
                9,
                10,
                9,
                7,
                9,
                10,
                14,
                13,
                4,
                14,
                13,
                14,
                9,
                13,
                6,
                9,
                9,
                10,
                10,
                10,
                5,
                9,
                6,
                9,
                9,
                10,
                9,
                9,
                10,
                11,
                9,
                10,
                9,
                9,
                7,
                9,
                13,
                13,
                10,
                10,
                10,
                9,
                9,
                16,
                9,
                9,
                14,
                10,
                9,
                9,
                16,
                9,
                12,
                9,
                4,
                9,
                6,
                14,
                10,
                9,
                9,
                14,
                9,
                11,
                9,
                13,
                9,
                10,
                7,
                4,
                7,
                13,
                10,
                9,
                13,
                10,
                13,
                7,
                9,
                9,
                13,
                14,
                10,
                16,
                9,
                9,
                9,
                9,
                14,
                13,
                8,
                14,
                10,
                11,
                10,
                9,
                10,
                14,
                10,
                9,
                13,
                9,
                10,
                9,
                9,
                13,
                9,
                13,
                13,
                10,
                4,
                9,
                10,
                10,
                15,
                9,
                9,
                10,
                13,
                13,
                13,
                11,
                13,
                4,
                9,
                13,
                10,
                7,
                10,
                11,
                13,
                13,
                9,
                9,
                3,
                11,
                13,
                13,
                9,
                9,
                9,
                5,
                10,
                13,
                9,
                5,
                10,
                8,
                15,
                14,
                9,
                9,
                11,
                10,
                9,
                10,
                9,
                9,
                9,
                10,
                10,
                10,
                9,
                9,
                9,
                9,
                9,
                10,
                11,
                13,
                13,
                13,
                10,
                10,
                9,
                9,
                15,
                10,
                14,
                10,
                13,
                14,
                10,
                9,
                6,
                10,
                7,
                9,
                6,
                10,
                14,
                9,
                9,
                9,
                7,
                13,
                10,
                9,
                9,
                9,
                10,
                13,
                10,
                9,
                10,
                10,
                9,
                9,
                6,
                10,
                6,
                10,
                9,
                5,
                9,
                11,
                9,
                10,
                7,
                10,
                9,
                10,
                13,
                9,
                13,
                13,
                9,
                12,
                10,
                10,
                13,
                9,
                10,
                10,
                10,
                13,
                9,
                10,
                13,
                9,
                2,
                9,
                14,
                14,
                7,
                10,
                16,
                9,
                10,
                9,
                9,
                14,
                9,
                5,
                6,
                9,
                13,
                9,
                13,
                3,
                14,
                9,
                13,
                9,
                4,
                9,
                11,
                9,
                9,
                9,
                10,
                9,
                13,
                13,
                15,
                12,
                13,
                7,
                10,
                10,
                10,
                9,
                15,
                10,
                10,
                14,
                6,
                10,
                4,
                9,
                13,
                9,
                9,
                13,
                9,
                10,
                9,
                9,
                13,
                16,
                9,
                7,
                7,
                9,
                7,
                9,
                9,
                13,
                9,
                14,
                9,
                9,
                9,
                13,
                9,
                14,
                13,
                13,
                12,
                7,
                9,
                9,
                9,
                13,
                9,
                10,
                13,
                7,
                9,
                9,
                12,
                6,
                6,
                9,
                10,
                15,
                13,
                2,
                9,
                10,
                13,
                11,
                9,
                9,
                10,
                7,
                10,
                9,
                9,
                10,
                9,
                10,
                14,
                13,
                6,
                9,
                13,
                9,
                13,
                13,
                9,
                10,
                16,
                10,
                13,
                13,
                10,
                9,
                9,
                14,
                9,
                13,
                10,
                10,
                13,
                9,
                10,
                9,
                9,
                13,
                4,
                9,
                7,
                14,
                9,
                11,
                9,
                10,
                14,
                9,
                14,
                10,
                10,
                4,
                10,
                10,
                10,
                13,
                13,
                10,
                13,
                9,
                9,
                9,
                12,
                13,
                10,
                11,
                13,
                7,
                9,
                5,
                10,
                10,
                9,
                3,
                15,
                10,
                5,
                10,
                13,
                9,
                9,
                9,
                10,
                11,
                9,
                9,
                6
              ],
              "type": "box",
              "name": "reference",
              "marker": {
                "color": "blue"
              }
            },
            {
              "y": [
                9,
                7,
                8,
                13,
                13,
                9,
                9,
                10,
                13,
                13,
                14,
                9,
                9,
                13,
                9,
                9,
                9,
                9,
                9,
                13,
                10,
                9,
                6,
                13,
                9,
                10,
                5,
                10,
                6,
                10,
                10,
                10,
                10,
                13,
                10,
                9,
                6,
                10,
                3,
                9,
                9,
                5,
                10,
                9,
                14,
                14,
                9,
                9,
                10,
                10,
                9,
                7,
                9,
                9,
                13,
                13,
                5,
                10,
                7,
                9,
                13,
                13,
                15,
                9,
                10,
                6,
                9,
                9,
                9,
                6,
                10,
                9,
                10,
                10,
                9,
                14,
                9,
                9,
                15,
                9,
                10,
                6,
                9,
                9,
                12,
                12,
                13,
                9,
                9,
                9,
                13,
                6,
                7,
                14,
                9,
                15,
                9,
                9,
                13,
                12,
                11,
                10,
                10,
                13,
                4,
                10,
                9,
                10,
                9,
                13,
                10,
                11,
                9,
                14,
                9,
                13,
                13,
                10,
                6,
                9,
                12,
                10,
                3,
                4,
                12,
                13,
                9,
                10,
                11,
                10,
                9,
                10,
                9,
                13,
                13,
                2,
                9,
                7,
                13,
                10,
                14,
                13,
                10,
                9,
                9,
                13,
                10,
                9,
                6,
                9,
                13,
                9,
                11,
                10,
                12,
                9,
                14,
                9,
                8,
                9,
                13,
                9,
                9,
                15,
                10,
                13,
                10,
                9,
                10,
                10,
                10,
                15,
                10,
                9,
                14,
                9,
                9,
                9,
                10,
                8,
                9,
                9,
                11,
                9,
                13,
                13,
                2,
                13,
                13,
                9,
                10,
                7,
                9,
                9,
                9,
                11,
                14,
                13,
                9,
                11,
                10,
                9,
                6,
                10,
                10,
                10,
                10,
                9,
                10,
                10,
                13,
                13,
                4,
                4,
                10,
                13,
                11,
                9,
                8,
                10,
                9,
                9,
                10,
                9,
                14,
                10,
                10,
                11,
                11,
                9,
                6,
                13,
                9,
                10,
                13,
                11,
                13,
                9,
                9,
                10,
                9,
                13,
                10,
                10,
                10,
                10,
                10,
                11,
                9,
                7,
                9,
                9,
                13,
                2,
                9,
                10,
                10,
                13,
                9,
                13,
                9,
                9,
                13,
                15,
                13,
                9,
                14,
                10,
                13,
                9,
                9,
                13,
                9,
                13,
                13,
                10,
                12,
                13,
                9,
                13,
                13,
                9,
                9,
                15,
                7,
                6,
                13,
                9,
                8,
                9,
                4,
                10,
                3,
                10,
                9,
                13,
                9,
                6,
                13,
                9,
                9,
                9,
                11,
                13,
                10,
                9,
                10,
                9,
                13,
                10,
                13,
                10,
                8,
                10,
                12,
                9,
                13,
                14,
                13,
                9,
                13,
                9,
                9,
                13,
                10,
                10,
                2,
                13,
                6,
                10,
                9,
                13,
                9,
                9,
                9,
                13,
                9,
                10,
                9,
                9,
                9,
                9,
                8,
                9,
                10,
                4,
                13,
                9,
                10,
                16,
                10,
                3,
                10,
                10,
                4,
                9,
                9,
                13,
                9,
                13,
                10,
                10,
                10,
                9,
                9,
                13,
                13,
                10,
                13,
                13,
                10,
                10,
                8,
                10,
                10,
                10,
                9,
                10,
                16,
                9,
                11,
                9,
                9,
                9,
                12,
                9,
                10,
                10,
                9,
                13,
                6,
                10,
                10,
                2,
                8,
                9,
                10,
                10,
                9,
                9,
                11,
                9,
                10,
                9,
                9,
                9,
                10,
                10,
                11,
                11,
                10,
                12,
                9,
                10,
                13,
                6,
                7,
                10,
                9,
                9,
                10,
                7,
                4,
                10,
                16,
                9,
                10,
                5,
                9,
                13,
                10,
                9,
                9,
                9,
                8,
                13,
                10,
                14,
                9,
                10,
                6,
                10,
                9,
                5,
                9,
                13,
                10,
                9,
                9,
                3,
                13,
                14,
                16,
                9,
                7,
                11,
                11,
                10,
                12,
                7,
                2,
                6,
                9,
                9,
                13,
                9,
                13,
                4,
                13,
                7,
                9,
                8,
                9,
                15,
                13,
                9,
                9,
                10,
                9,
                16,
                9,
                13,
                10,
                10,
                9,
                10,
                9,
                6,
                10,
                13,
                10,
                9,
                7,
                10,
                10,
                13,
                10,
                9,
                12,
                10,
                12,
                9,
                10,
                9,
                9,
                3,
                14,
                9,
                9,
                9,
                10,
                5
              ],
              "type": "box",
              "name": "production",
              "marker": {
                "color": "red"
              }
            }
          ]
        ]
      },
      {
        "title": "hours-per-week",
        "train_oulier": "27.5",
        "test_oulier": "27.9",
        "feat_imp": "14.2",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "title": "bins"
            },
            "yaxis": {
              "title": "pdf"
            },
            "showlegend": true
          },
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "title": "data"
            },
            "yaxis": {
              "title": "values"
            },
            "showlegend": true
          }
        ],
        "data": [
          [
            {
              "x": [
                1,
                2.96,
                4.92,
                6.88,
                8.84,
                10.8,
                12.76,
                14.72,
                16.68,
                18.64,
                20.6,
                22.56,
                24.52,
                26.48,
                28.44,
                30.4,
                32.36,
                34.32,
                36.28,
                38.24,
                40.2,
                42.16,
                44.12,
                46.08,
                48.04,
                50,
                51.96,
                53.92,
                55.88,
                57.84,
                59.8,
                61.76,
                63.72,
                65.68,
                67.64,
                69.6,
                71.56,
                73.52,
                75.48,
                77.44,
                79.4,
                81.36,
                83.32,
                85.28,
                87.24,
                89.2,
                91.16,
                93.12,
                95.08,
                97.04,
                99
              ],
              "y": [
                0.002,
                0.003,
                0.004,
                0.006,
                0.009,
                0.005,
                0.002,
                0.019,
                0.004,
                0.039,
                0.002,
                0.008,
                0.02,
                0.004,
                0.035,
                0.009,
                0.002,
                0.047,
                0.02,
                0.468,
                0.009,
                0.011,
                0.057,
                0.017,
                0.001,
                0.088,
                0.005,
                0.022,
                0.003,
                0.001,
                0.045,
                0.001,
                0.007,
                0.001,
                0,
                0.009,
                0.002,
                0.002,
                0,
                0,
                0.004,
                0,
                0.002,
                0,
                0,
                0.001,
                0,
                0,
                0,
                0.003
              ],
              "type": "lines",
              "name": "reference",
              "fill": "tozeroy",
              "marker": {
                "color": "blue"
              }
            },
            {
              "x": [
                1,
                2.96,
                4.92,
                6.88,
                8.84,
                10.8,
                12.76,
                14.72,
                16.68,
                18.64,
                20.6,
                22.56,
                24.52,
                26.48,
                28.44,
                30.4,
                32.36,
                34.32,
                36.28,
                38.24,
                40.2,
                42.16,
                44.12,
                46.08,
                48.04,
                50,
                51.96,
                53.92,
                55.88,
                57.84,
                59.8,
                61.76,
                63.72,
                65.68,
                67.64,
                69.6,
                71.56,
                73.52,
                75.48,
                77.44,
                79.4,
                81.36,
                83.32,
                85.28,
                87.24,
                89.2,
                91.16,
                93.12,
                95.08,
                97.04,
                99
              ],
              "y": [
                0.002,
                0.003,
                0.004,
                0.005,
                0.01,
                0.006,
                0.002,
                0.019,
                0.003,
                0.038,
                0.002,
                0.008,
                0.021,
                0.003,
                0.036,
                0.009,
                0.002,
                0.046,
                0.018,
                0.468,
                0.007,
                0.01,
                0.06,
                0.018,
                0.001,
                0.086,
                0.005,
                0.025,
                0.004,
                0.001,
                0.044,
                0.001,
                0.009,
                0.001,
                0.001,
                0.009,
                0.002,
                0.002,
                0,
                0,
                0.004,
                0,
                0.002,
                0,
                0,
                0.001,
                0,
                0,
                0,
                0.003
              ],
              "type": "lines",
              "name": "production",
              "fill": "tozeroy",
              "marker": {
                "color": "red"
              }
            }
          ],
          [
            {
              "y": [
                40,
                50,
                40,
                40,
                30,
                30,
                40,
                32,
                40,
                10,
                40,
                40,
                39,
                35,
                48,
                50,
                25,
                30,
                20,
                45,
                47,
                35,
                6,
                43,
                40,
                90,
                20,
                54,
                35,
                60,
                38,
                50,
                50,
                40,
                40,
                40,
                40,
                50,
                40,
                40,
                50,
                45,
                40,
                40,
                32,
                36,
                40,
                50,
                18,
                50,
                20,
                40,
                24,
                60,
                54,
                40,
                40,
                50,
                50,
                40,
                50,
                40,
                40,
                40,
                40,
                40,
                60,
                20,
                40,
                48,
                45,
                40,
                40,
                40,
                40,
                40,
                50,
                30,
                40,
                40,
                50,
                40,
                40,
                50,
                50,
                44,
                10,
                56,
                40,
                10,
                25,
                20,
                10,
                40,
                40,
                40,
                40,
                40,
                40,
                40,
                18,
                35,
                39,
                40,
                28,
                40,
                40,
                40,
                16,
                28,
                48,
                40,
                40,
                20,
                40,
                40,
                40,
                24,
                40,
                40,
                60,
                25,
                30,
                40,
                40,
                25,
                40,
                40,
                60,
                50,
                40,
                40,
                40,
                41,
                48,
                40,
                60,
                40,
                35,
                40,
                40,
                22,
                55,
                45,
                30,
                30,
                30,
                40,
                50,
                30,
                14,
                32,
                20,
                40,
                45,
                40,
                40,
                25,
                40,
                40,
                30,
                40,
                45,
                40,
                45,
                40,
                16,
                45,
                25,
                33,
                40,
                40,
                40,
                60,
                40,
                45,
                45,
                37,
                50,
                40,
                40,
                40,
                38,
                55,
                40,
                8,
                45,
                50,
                40,
                45,
                40,
                50,
                37,
                40,
                55,
                40,
                45,
                50,
                40,
                40,
                40,
                50,
                45,
                40,
                40,
                54,
                40,
                20,
                50,
                55,
                12,
                50,
                40,
                40,
                32,
                40,
                32,
                38,
                40,
                45,
                40,
                40,
                40,
                40,
                40,
                40,
                38,
                40,
                40,
                35,
                40,
                50,
                50,
                40,
                30,
                60,
                40,
                28,
                40,
                40,
                35,
                60,
                12,
                32,
                20,
                50,
                40,
                40,
                70,
                40,
                15,
                50,
                40,
                40,
                50,
                35,
                40,
                40,
                40,
                20,
                50,
                40,
                40,
                40,
                40,
                40,
                40,
                25,
                30,
                20,
                75,
                40,
                40,
                38,
                35,
                35,
                52,
                24,
                50,
                60,
                40,
                38,
                25,
                40,
                55,
                48,
                40,
                40,
                40,
                40,
                55,
                40,
                40,
                40,
                40,
                40,
                32,
                40,
                60,
                48,
                40,
                38,
                38,
                40,
                16,
                40,
                40,
                40,
                60,
                84,
                45,
                40,
                60,
                45,
                35,
                42,
                40,
                25,
                40,
                40,
                40,
                40,
                40,
                40,
                40,
                50,
                42,
                15,
                60,
                50,
                20,
                45,
                40,
                42,
                50,
                40,
                55,
                40,
                80,
                48,
                40,
                40,
                40,
                45,
                40,
                50,
                40,
                50,
                40,
                40,
                40,
                30,
                40,
                12,
                84,
                50,
                45,
                80,
                40,
                40,
                40,
                60,
                25,
                40,
                50,
                25,
                70,
                60,
                8,
                40,
                68,
                40,
                40,
                44,
                45,
                40,
                40,
                40,
                10,
                15,
                40,
                40,
                35,
                35,
                99,
                35,
                37,
                40,
                40,
                55,
                50,
                40,
                50,
                40,
                40,
                60,
                45,
                16,
                45,
                40,
                40,
                20,
                25,
                36,
                65,
                55,
                40,
                40,
                40,
                24,
                40,
                40,
                70,
                25,
                40,
                40,
                30,
                40,
                40,
                40,
                40,
                40,
                40,
                45,
                40,
                40,
                40,
                40,
                45,
                35,
                50,
                20,
                40,
                37,
                20,
                40,
                55,
                5,
                60,
                50,
                40,
                40,
                40,
                60,
                20,
                55,
                50,
                40,
                40,
                40,
                40,
                48,
                40,
                44,
                40,
                42,
                35,
                65,
                35,
                40,
                39,
                40,
                60,
                38,
                40,
                40,
                40,
                40,
                40,
                40,
                20,
                10,
                50,
                40,
                40,
                75,
                40,
                40,
                20,
                32,
                28,
                40,
                17,
                50,
                35,
                40,
                40,
                30,
                35,
                40,
                40,
                28,
                60,
                40,
                40,
                36,
                40,
                60,
                40,
                35,
                40,
                55,
                40,
                33,
                60,
                10,
                10,
                45,
                36,
                65,
                40,
                38
              ],
              "type": "box",
              "name": "reference",
              "marker": {
                "color": "blue"
              }
            },
            {
              "y": [
                40,
                20,
                30,
                40,
                40,
                45,
                40,
                40,
                50,
                50,
                40,
                75,
                40,
                60,
                40,
                48,
                35,
                40,
                20,
                35,
                60,
                60,
                40,
                40,
                40,
                40,
                40,
                40,
                15,
                40,
                35,
                35,
                40,
                40,
                40,
                35,
                40,
                16,
                35,
                50,
                40,
                40,
                50,
                40,
                40,
                50,
                43,
                25,
                40,
                40,
                48,
                40,
                40,
                45,
                60,
                40,
                35,
                46,
                50,
                40,
                50,
                35,
                35,
                37,
                60,
                35,
                45,
                40,
                45,
                50,
                40,
                30,
                40,
                50,
                40,
                20,
                36,
                40,
                40,
                37,
                20,
                30,
                40,
                15,
                40,
                45,
                30,
                40,
                40,
                40,
                40,
                30,
                40,
                55,
                40,
                60,
                45,
                50,
                30,
                25,
                40,
                42,
                40,
                50,
                35,
                40,
                84,
                52,
                50,
                55,
                40,
                50,
                40,
                40,
                40,
                45,
                60,
                4,
                40,
                40,
                30,
                45,
                40,
                40,
                40,
                40,
                40,
                40,
                60,
                40,
                40,
                50,
                50,
                51,
                35,
                20,
                40,
                65,
                40,
                40,
                40,
                45,
                40,
                45,
                40,
                55,
                32,
                50,
                40,
                20,
                50,
                32,
                40,
                55,
                40,
                30,
                40,
                60,
                20,
                40,
                40,
                36,
                99,
                60,
                40,
                40,
                40,
                44,
                40,
                40,
                20,
                55,
                40,
                40,
                40,
                40,
                40,
                40,
                40,
                40,
                10,
                32,
                40,
                10,
                40,
                40,
                40,
                40,
                47,
                37,
                40,
                50,
                36,
                40,
                40,
                38,
                25,
                50,
                40,
                40,
                48,
                40,
                25,
                18,
                60,
                20,
                40,
                40,
                40,
                40,
                40,
                37,
                10,
                60,
                37,
                40,
                50,
                52,
                32,
                60,
                60,
                40,
                45,
                20,
                40,
                40,
                13,
                40,
                50,
                40,
                40,
                40,
                40,
                30,
                25,
                40,
                65,
                24,
                20,
                45,
                40,
                45,
                40,
                40,
                15,
                40,
                45,
                3,
                30,
                35,
                40,
                20,
                48,
                55,
                40,
                30,
                80,
                40,
                45,
                25,
                40,
                48,
                35,
                45,
                50,
                20,
                40,
                48,
                45,
                30,
                32,
                40,
                40,
                60,
                50,
                38,
                38,
                38,
                40,
                55,
                40,
                56,
                40,
                55,
                10,
                40,
                40,
                50,
                40,
                40,
                40,
                40,
                21,
                45,
                40,
                45,
                50,
                40,
                20,
                40,
                40,
                40,
                20,
                5,
                37,
                40,
                55,
                40,
                40,
                40,
                40,
                40,
                40,
                42,
                10,
                33,
                35,
                50,
                40,
                8,
                40,
                40,
                50,
                40,
                40,
                25,
                20,
                40,
                40,
                38,
                40,
                40,
                40,
                50,
                99,
                52,
                30,
                38,
                35,
                32,
                40,
                24,
                40,
                46,
                15,
                40,
                35,
                40,
                25,
                50,
                40,
                40,
                40,
                50,
                48,
                45,
                40,
                40,
                30,
                45,
                40,
                60,
                8,
                48,
                40,
                30,
                40,
                39,
                55,
                50,
                40,
                24,
                25,
                45,
                7,
                20,
                35,
                30,
                40,
                40,
                40,
                12,
                40,
                40,
                25,
                40,
                45,
                15,
                40,
                50,
                20,
                40,
                40,
                28,
                40,
                20,
                40,
                40,
                16,
                40,
                40,
                45,
                45,
                40,
                45,
                18,
                15,
                55,
                40,
                35,
                52,
                60,
                40,
                36,
                40,
                40,
                24,
                70,
                40,
                50,
                40,
                76,
                99,
                40,
                40,
                40,
                40,
                40,
                15,
                40,
                40,
                40,
                40,
                40,
                53,
                60,
                38,
                40,
                40,
                40,
                40,
                92,
                40,
                40,
                60,
                40,
                15,
                45,
                40,
                49,
                48,
                40,
                18,
                20,
                20,
                40,
                60,
                40,
                25,
                40,
                54,
                20,
                45,
                50,
                35,
                45,
                50,
                40,
                15,
                40,
                40,
                15,
                40,
                50,
                40,
                16,
                15,
                40,
                40,
                40,
                40,
                40,
                24,
                40,
                40,
                40,
                40,
                25,
                40,
                40,
                32,
                40,
                15,
                37,
                40,
                40,
                50,
                40,
                32,
                54,
                45,
                30,
                40,
                40,
                32,
                40,
                40,
                40,
                40,
                40,
                40,
                38
              ],
              "type": "box",
              "name": "production",
              "marker": {
                "color": "red"
              }
            }
          ]
        ]
      },
      {
        "title": "workclass_?",
        "train_oulier": "5.7",
        "test_oulier": "5.7",
        "feat_imp": "0.2",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "32989",
                "2011"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13054",
                "788"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "workclass_Federal-gov",
        "train_oulier": "3.0",
        "test_oulier": "2.9",
        "feat_imp": "0.6",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "33964",
                "1036"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13446",
                "396"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "workclass_Local-gov",
        "train_oulier": "6.4",
        "test_oulier": "6.6",
        "feat_imp": "0.7",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "32772",
                "2228"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "12934",
                "908"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "workclass_Never-worked",
        "train_oulier": "0.0",
        "test_oulier": "0.0",
        "feat_imp": "0.0",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34994",
                "6"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13838",
                "4"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "workclass_Private",
        "train_oulier": "0.0",
        "test_oulier": "0.0",
        "feat_imp": "1.2",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "10748",
                "24252"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "4188",
                "9654"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "workclass_Self-emp-inc",
        "train_oulier": "3.5",
        "test_oulier": "3.4",
        "feat_imp": "0.8",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "33777",
                "1223"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13370",
                "472"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "workclass_Self-emp-not-inc",
        "train_oulier": "8.0",
        "test_oulier": "7.7",
        "feat_imp": "1.0",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "32200",
                "2800"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "12780",
                "1062"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "workclass_State-gov",
        "train_oulier": "4.1",
        "test_oulier": "4.0",
        "feat_imp": "0.6",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "33568",
                "1432"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13293",
                "549"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "workclass_Without-pay",
        "train_oulier": "0.0",
        "test_oulier": "0.1",
        "feat_imp": "0.0",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34988",
                "12"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13833",
                "9"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "education_10th",
        "train_oulier": "2.8",
        "test_oulier": "2.9",
        "feat_imp": "0.2",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34013",
                "987"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13440",
                "402"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "education_11th",
        "train_oulier": "3.7",
        "test_oulier": "3.6",
        "feat_imp": "0.2",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "33691",
                "1309"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13339",
                "503"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "education_12th",
        "train_oulier": "1.3",
        "test_oulier": "1.6",
        "feat_imp": "0.1",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34561",
                "439"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13624",
                "218"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "education_1st-4th",
        "train_oulier": "0.5",
        "test_oulier": "0.6",
        "feat_imp": "0.0",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34831",
                "169"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13764",
                "78"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "education_5th-6th",
        "train_oulier": "1.0",
        "test_oulier": "1.0",
        "feat_imp": "0.1",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34634",
                "366"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13699",
                "143"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "education_7th-8th",
        "train_oulier": "1.9",
        "test_oulier": "2.0",
        "feat_imp": "0.3",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34324",
                "676"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13563",
                "279"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "education_9th",
        "train_oulier": "1.5",
        "test_oulier": "1.6",
        "feat_imp": "0.2",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34466",
                "534"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13620",
                "222"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "education_Assoc-acdm",
        "train_oulier": "3.2",
        "test_oulier": "3.4",
        "feat_imp": "0.3",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "33871",
                "1129"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13370",
                "472"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "education_Assoc-voc",
        "train_oulier": "4.2",
        "test_oulier": "4.3",
        "feat_imp": "0.3",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "33536",
                "1464"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13245",
                "597"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "education_Bachelors",
        "train_oulier": "16.5",
        "test_oulier": "16.2",
        "feat_imp": "1.2",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "29213",
                "5787"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "11604",
                "2238"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "education_Doctorate",
        "train_oulier": "1.2",
        "test_oulier": "1.3",
        "feat_imp": "0.3",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34580",
                "420"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13668",
                "174"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "education_HS-grad",
        "train_oulier": "0.0",
        "test_oulier": "0.0",
        "feat_imp": "0.9",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "23602",
                "11398"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "9456",
                "4386"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "education_Masters",
        "train_oulier": "5.5",
        "test_oulier": "5.3",
        "feat_imp": "0.9",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "33079",
                "1921"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13106",
                "736"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "education_Preschool",
        "train_oulier": "0.2",
        "test_oulier": "0.2",
        "feat_imp": "0.0",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34943",
                "57"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13816",
                "26"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "education_Prof-school",
        "train_oulier": "1.6",
        "test_oulier": "1.9",
        "feat_imp": "0.8",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34425",
                "575"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13583",
                "259"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "education_Some-college",
        "train_oulier": "22.2",
        "test_oulier": "22.5",
        "feat_imp": "0.6",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "27231",
                "7769"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "10733",
                "3109"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "marital-status_Divorced",
        "train_oulier": "13.5",
        "test_oulier": "13.7",
        "feat_imp": "0.9",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "30259",
                "4741"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "11950",
                "1892"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "marital-status_Married-AF-spouse",
        "train_oulier": "0.1",
        "test_oulier": "0.1",
        "feat_imp": "0.0",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34972",
                "28"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13833",
                "9"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "marital-status_Married-civ-spouse",
        "train_oulier": "0.0",
        "test_oulier": "0.0",
        "feat_imp": "6.9",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "18986",
                "16014"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "7477",
                "6365"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "marital-status_Married-spouse-absent",
        "train_oulier": "1.3",
        "test_oulier": "1.3",
        "feat_imp": "0.1",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34553",
                "447"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13661",
                "181"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "marital-status_Never-married",
        "train_oulier": "0.0",
        "test_oulier": "0.0",
        "feat_imp": "2.6",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "23420",
                "11580"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "9305",
                "4537"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "marital-status_Separated",
        "train_oulier": "3.1",
        "test_oulier": "3.2",
        "feat_imp": "0.2",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "33915",
                "1085"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13397",
                "445"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "marital-status_Widowed",
        "train_oulier": "3.2",
        "test_oulier": "3.0",
        "feat_imp": "0.2",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "33895",
                "1105"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13429",
                "413"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "occupation_?",
        "train_oulier": "5.8",
        "test_oulier": "5.7",
        "feat_imp": "0.2",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "32983",
                "2017"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13050",
                "792"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "occupation_Adm-clerical",
        "train_oulier": "11.7",
        "test_oulier": "11.0",
        "feat_imp": "0.7",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "30916",
                "4084"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "12315",
                "1527"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "occupation_Armed-Forces",
        "train_oulier": "0.0",
        "test_oulier": "0.0",
        "feat_imp": "0.0",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34988",
                "12"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13839",
                "3"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "occupation_Craft-repair",
        "train_oulier": "12.4",
        "test_oulier": "12.9",
        "feat_imp": "0.8",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "30667",
                "4333"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "12063",
                "1779"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "occupation_Exec-managerial",
        "train_oulier": "12.3",
        "test_oulier": "12.7",
        "feat_imp": "2.3",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "30678",
                "4322"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "12078",
                "1764"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "occupation_Farming-fishing",
        "train_oulier": "3.0",
        "test_oulier": "3.2",
        "feat_imp": "0.6",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "33957",
                "1043"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13395",
                "447"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "occupation_Handlers-cleaners",
        "train_oulier": "4.1",
        "test_oulier": "4.5",
        "feat_imp": "0.4",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "33553",
                "1447"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13217",
                "625"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "occupation_Machine-op-inspct",
        "train_oulier": "6.2",
        "test_oulier": "6.0",
        "feat_imp": "0.5",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "32813",
                "2187"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13007",
                "835"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "occupation_Other-service",
        "train_oulier": "10.1",
        "test_oulier": "10.0",
        "feat_imp": "0.9",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "31458",
                "3542"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "12461",
                "1381"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "occupation_Priv-house-serv",
        "train_oulier": "0.5",
        "test_oulier": "0.4",
        "feat_imp": "0.0",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34812",
                "188"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13788",
                "54"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "occupation_Prof-specialty",
        "train_oulier": "12.6",
        "test_oulier": "12.8",
        "feat_imp": "1.8",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "30595",
                "4405"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "12075",
                "1767"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "occupation_Protective-serv",
        "train_oulier": "2.0",
        "test_oulier": "2.0",
        "feat_imp": "0.4",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34300",
                "700"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13559",
                "283"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "occupation_Sales",
        "train_oulier": "11.4",
        "test_oulier": "10.9",
        "feat_imp": "0.8",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "31003",
                "3997"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "12335",
                "1507"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "occupation_Tech-support",
        "train_oulier": "3.0",
        "test_oulier": "2.9",
        "feat_imp": "0.6",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "33954",
                "1046"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13442",
                "400"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "occupation_Transport-moving",
        "train_oulier": "4.8",
        "test_oulier": "4.9",
        "feat_imp": "0.5",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "33323",
                "1677"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13164",
                "678"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "relationship_Husband",
        "train_oulier": "0.0",
        "test_oulier": "0.0",
        "feat_imp": "4.8",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "20915",
                "14085"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "8211",
                "5631"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "relationship_Not-in-family",
        "train_oulier": "0.0",
        "test_oulier": "0.0",
        "feat_imp": "1.4",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "25906",
                "9094"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "10353",
                "3489"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "relationship_Other-relative",
        "train_oulier": "3.1",
        "test_oulier": "3.1",
        "feat_imp": "0.2",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "33920",
                "1080"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13416",
                "426"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "relationship_Own-child",
        "train_oulier": "15.5",
        "test_oulier": "15.6",
        "feat_imp": "1.4",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "29579",
                "5421"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "11682",
                "2160"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "relationship_Unmarried",
        "train_oulier": "10.4",
        "test_oulier": "10.8",
        "feat_imp": "0.5",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "31374",
                "3626"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "12343",
                "1499"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "relationship_Wife",
        "train_oulier": "4.8",
        "test_oulier": "4.6",
        "feat_imp": "1.2",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "33306",
                "1694"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13205",
                "637"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "race_Amer-Indian-Eskimo",
        "train_oulier": "1.0",
        "test_oulier": "1.0",
        "feat_imp": "0.2",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34667",
                "333"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13705",
                "137"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "race_Asian-Pac-Islander",
        "train_oulier": "3.0",
        "test_oulier": "3.3",
        "feat_imp": "0.4",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "33936",
                "1064"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13387",
                "455"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "race_Black",
        "train_oulier": "9.5",
        "test_oulier": "9.8",
        "feat_imp": "0.6",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "31665",
                "3335"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "12492",
                "1350"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "race_Other",
        "train_oulier": "0.8",
        "test_oulier": "0.8",
        "feat_imp": "0.1",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34709",
                "291"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13727",
                "115"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "race_White",
        "train_oulier": "14.4",
        "test_oulier": "14.9",
        "feat_imp": "0.8",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "5023",
                "29977"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "2057",
                "11785"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "gender_Female",
        "train_oulier": "0.0",
        "test_oulier": "0.0",
        "feat_imp": "1.0",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "23412",
                "11588"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "9238",
                "4604"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "gender_Male",
        "train_oulier": "0.0",
        "test_oulier": "0.0",
        "feat_imp": "1.0",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "11588",
                "23412"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "4604",
                "9238"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_?",
        "train_oulier": "1.7",
        "test_oulier": "1.8",
        "feat_imp": "0.4",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34392",
                "608"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13593",
                "249"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Cambodia",
        "train_oulier": "0.1",
        "test_oulier": "0.1",
        "feat_imp": "0.0",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34979",
                "21"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13835",
                "7"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Canada",
        "train_oulier": "0.4",
        "test_oulier": "0.3",
        "feat_imp": "0.2",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34865",
                "135"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13795",
                "47"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_China",
        "train_oulier": "0.3",
        "test_oulier": "0.2",
        "feat_imp": "0.1",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34907",
                "93"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13813",
                "29"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Columbia",
        "train_oulier": "0.2",
        "test_oulier": "0.2",
        "feat_imp": "0.0",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34945",
                "55"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13812",
                "30"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Cuba",
        "train_oulier": "0.3",
        "test_oulier": "0.3",
        "feat_imp": "0.1",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34899",
                "101"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13805",
                "37"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Dominican-Republic",
        "train_oulier": "0.2",
        "test_oulier": "0.2",
        "feat_imp": "0.0",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34927",
                "73"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13812",
                "30"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Ecuador",
        "train_oulier": "0.1",
        "test_oulier": "0.1",
        "feat_imp": "0.0",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34965",
                "35"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13832",
                "10"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_El-Salvador",
        "train_oulier": "0.3",
        "test_oulier": "0.3",
        "feat_imp": "0.0",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34893",
                "107"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13794",
                "48"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_England",
        "train_oulier": "0.3",
        "test_oulier": "0.2",
        "feat_imp": "0.1",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34901",
                "99"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13814",
                "28"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_France",
        "train_oulier": "0.1",
        "test_oulier": "0.1",
        "feat_imp": "0.0",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34978",
                "22"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13826",
                "16"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Germany",
        "train_oulier": "0.4",
        "test_oulier": "0.4",
        "feat_imp": "0.1",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34849",
                "151"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13787",
                "55"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Greece",
        "train_oulier": "0.1",
        "test_oulier": "0.1",
        "feat_imp": "0.1",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34961",
                "39"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13832",
                "10"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Guatemala",
        "train_oulier": "0.2",
        "test_oulier": "0.2",
        "feat_imp": "0.0",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34936",
                "64"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13818",
                "24"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Haiti",
        "train_oulier": "0.2",
        "test_oulier": "0.1",
        "feat_imp": "0.0",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34943",
                "57"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13824",
                "18"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Holand-Netherlands",
        "train_oulier": "0.0",
        "test_oulier": "0.0",
        "feat_imp": "0.0",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "35000",
                "0"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13841",
                "1"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Honduras",
        "train_oulier": "0.0",
        "test_oulier": "0.0",
        "feat_imp": "0.0",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34985",
                "15"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13837",
                "5"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Hong",
        "train_oulier": "0.1",
        "test_oulier": "0.1",
        "feat_imp": "0.0",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34982",
                "18"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13830",
                "12"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Hungary",
        "train_oulier": "0.0",
        "test_oulier": "0.1",
        "feat_imp": "0.0",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34988",
                "12"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13835",
                "7"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_India",
        "train_oulier": "0.3",
        "test_oulier": "0.4",
        "feat_imp": "0.1",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34899",
                "101"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13792",
                "50"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Iran",
        "train_oulier": "0.1",
        "test_oulier": "0.1",
        "feat_imp": "0.1",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34955",
                "45"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13828",
                "14"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Ireland",
        "train_oulier": "0.1",
        "test_oulier": "0.1",
        "feat_imp": "0.1",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34971",
                "29"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13834",
                "8"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Italy",
        "train_oulier": "0.2",
        "test_oulier": "0.2",
        "feat_imp": "0.1",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34927",
                "73"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13810",
                "32"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Jamaica",
        "train_oulier": "0.2",
        "test_oulier": "0.2",
        "feat_imp": "0.0",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34928",
                "72"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13808",
                "34"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Japan",
        "train_oulier": "0.2",
        "test_oulier": "0.2",
        "feat_imp": "0.1",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34933",
                "67"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13817",
                "25"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Laos",
        "train_oulier": "0.0",
        "test_oulier": "0.1",
        "feat_imp": "0.0",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34989",
                "11"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13830",
                "12"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Mexico",
        "train_oulier": "1.9",
        "test_oulier": "2.0",
        "feat_imp": "0.2",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34320",
                "680"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13571",
                "271"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Nicaragua",
        "train_oulier": "0.1",
        "test_oulier": "0.1",
        "feat_imp": "0.0",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34965",
                "35"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13828",
                "14"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Outlying-US(Guam-USVI-etc)",
        "train_oulier": "0.0",
        "test_oulier": "0.1",
        "feat_imp": "0.0",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34985",
                "15"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13834",
                "8"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Peru",
        "train_oulier": "0.1",
        "test_oulier": "0.1",
        "feat_imp": "0.0",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34969",
                "31"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13827",
                "15"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Philippines",
        "train_oulier": "0.6",
        "test_oulier": "0.6",
        "feat_imp": "0.1",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34792",
                "208"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13755",
                "87"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Poland",
        "train_oulier": "0.2",
        "test_oulier": "0.1",
        "feat_imp": "0.1",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34932",
                "68"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13823",
                "19"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Portugal",
        "train_oulier": "0.1",
        "test_oulier": "0.1",
        "feat_imp": "0.1",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34949",
                "51"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13826",
                "16"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Puerto-Rico",
        "train_oulier": "0.4",
        "test_oulier": "0.3",
        "feat_imp": "0.1",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34858",
                "142"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13800",
                "42"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Scotland",
        "train_oulier": "0.0",
        "test_oulier": "0.1",
        "feat_imp": "0.0",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34986",
                "14"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13835",
                "7"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_South",
        "train_oulier": "0.2",
        "test_oulier": "0.2",
        "feat_imp": "0.1",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34913",
                "87"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13814",
                "28"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Taiwan",
        "train_oulier": "0.1",
        "test_oulier": "0.1",
        "feat_imp": "0.0",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34954",
                "46"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13823",
                "19"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Thailand",
        "train_oulier": "0.1",
        "test_oulier": "0.1",
        "feat_imp": "0.0",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34979",
                "21"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13833",
                "9"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Trinadad&Tobago",
        "train_oulier": "0.0",
        "test_oulier": "0.1",
        "feat_imp": "0.0",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34984",
                "16"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13831",
                "11"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_United-States",
        "train_oulier": "10.3",
        "test_oulier": "10.3",
        "feat_imp": "0.8",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "3589",
                "31411"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "1421",
                "12421"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Vietnam",
        "train_oulier": "0.2",
        "test_oulier": "0.2",
        "feat_imp": "0.0",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34943",
                "57"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13813",
                "29"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Yugoslavia",
        "train_oulier": "0.0",
        "test_oulier": "0.1",
        "feat_imp": "0.0",
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34985",
                "15"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13834",
                "8"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      }
    ],
    "timestamp": "2021-12-01 14:50:32.701985",
    "name": "Outlier Detection",
    "des": "An outlier represents the data points which are not in the normal range as specified by \n        threshold values. Any datapoint outside the threshold values will be highlighted as outlier / anomalies. \n        We have given an overall scatter plot for the entire production dataset after reducing the data’s\n        dimensionality if required. Apart from this, we have also given two plots for each feature. \n        One of them is a Probability Density Plot and the other one is a Box Plot. These plots represent \n        outliers with respect to the reference and production data.\n        "
  },
  "dd": {
    "project_name": "froud_detection",
    "module_name": "credit_fraud",
    "header": "Drift Detection",
    "timestamp": "2021-12-01 14:52:58.385284",
    "name": "Drift Detection",
    "des": "Data drift identifies potential changes in the data inputs that may cause performance\n        degradation of the model. This drift is detected by measuring and comparing probability distributions \n        of reference and production data using multiple, best in class, statistical methods. We have provided \n        a bar plot with p-values highlighting the drift in production data. Apart from this, for every \n        feature we have provided three graphs. They are, a Probability Density Plot, a Cumulative Distribution \n        Function plot and a Mean Bar Plot.\n        ",
    "values": [
      {
        "x": [],
        "y": [],
        "type": "bar",
        "marker": {
          "color": "blue"
        }
      },
      {
        "x": [],
        "y": [],
        "mode": "lines+markers",
        "type": "scatter",
        "marker": {
          "color": "red"
        }
      }
    ],
    "layout": {
      "autosize": "false",
      "margin": {
        "l": 50,
        "r": 50,
        "b": 50,
        "t": 50,
        "pad": 0
      },
      "height": 470,
      "width": 990,
      "xaxis": {
        "title": "feature names"
      },
      "yaxis": {
        "title": "p-values"
      },
      "showlegend": "true"
    },
    "features": [
      {
        "title": "age",
        "status": "Not Detected",
        "pvalue": "0.89",
        "feat_imp": 28.6,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "bins"
            },
            "yaxis": {
              "title": "pdf"
            },
            "showlegend": "false",
            "barmode": "group"
          },
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "bins"
            },
            "yaxis": {
              "title": "cdf"
            },
            "showlegend": "false"
          },
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 360,
            "xaxis": {
              "title": "data"
            },
            "yaxis": {
              "title": "mean"
            },
            "showlegend": "false"
          }
        ],
        "data": [
          [
            {
              "x": [
                17,
                18.46,
                19.92,
                21.38,
                22.84,
                24.3,
                25.76,
                27.22,
                28.68,
                30.14,
                31.6,
                33.06,
                34.52,
                35.98,
                37.44,
                38.9,
                40.36,
                41.82,
                43.28,
                44.74,
                46.2,
                47.66,
                49.12,
                50.58,
                52.04,
                53.5,
                54.96,
                56.42,
                57.88,
                59.34,
                60.8,
                62.26,
                63.72,
                65.18,
                66.64,
                68.1,
                69.56,
                71.02,
                72.48,
                73.94,
                75.4,
                76.86,
                78.32,
                79.78,
                81.24,
                82.7,
                84.16,
                85.62,
                87.08,
                88.54,
                90
              ],
              "y": [
                0.029,
                0.021,
                0.045,
                0.025,
                0.053,
                0.024,
                0.048,
                0.026,
                0.051,
                0.027,
                0.054,
                0.026,
                0.027,
                0.054,
                0.026,
                0.049,
                0.025,
                0.046,
                0.022,
                0.044,
                0.022,
                0.035,
                0.017,
                0.033,
                0.014,
                0.012,
                0.024,
                0.012,
                0.022,
                0.009,
                0.016,
                0.007,
                0.013,
                0.005,
                0.008,
                0.003,
                0.005,
                0.003,
                0.003,
                0.003,
                0.001,
                0.002,
                0.001,
                0.002,
                0,
                0.001,
                0,
                0,
                0,
                0.001
              ],
              "type": "lines",
              "fill": "tozeroy",
              "name": "reference",
              "marker": {
                "color": "blue"
              }
            },
            {
              "x": [
                17,
                18.46,
                19.92,
                21.38,
                22.84,
                24.3,
                25.76,
                27.22,
                28.68,
                30.14,
                31.6,
                33.06,
                34.52,
                35.98,
                37.44,
                38.9,
                40.36,
                41.82,
                43.28,
                44.74,
                46.2,
                47.66,
                49.12,
                50.58,
                52.04,
                53.5,
                54.96,
                56.42,
                57.88,
                59.34,
                60.8,
                62.26,
                63.72,
                65.18,
                66.64,
                68.1,
                69.56,
                71.02,
                72.48,
                73.94,
                75.4,
                76.86,
                78.32,
                79.78,
                81.24,
                82.7,
                84.16,
                85.62,
                87.08,
                88.54,
                90
              ],
              "y": [
                0.031,
                0.023,
                0.045,
                0.023,
                0.05,
                0.025,
                0.05,
                0.027,
                0.051,
                0.027,
                0.051,
                0.028,
                0.027,
                0.053,
                0.026,
                0.048,
                0.026,
                0.048,
                0.021,
                0.046,
                0.021,
                0.033,
                0.019,
                0.033,
                0.015,
                0.013,
                0.026,
                0.01,
                0.022,
                0.011,
                0.019,
                0.006,
                0.012,
                0.005,
                0.009,
                0.003,
                0.005,
                0.002,
                0.001,
                0.003,
                0.001,
                0.001,
                0.001,
                0.001,
                0.001,
                0,
                0,
                0,
                0,
                0.001
              ],
              "type": "lines",
              "fill": "tozeroy",
              "name": "production",
              "marker": {
                "color": "red"
              }
            }
          ],
          [
            {
              "x": [
                17,
                17.365,
                17.73,
                18.095,
                18.46,
                18.825,
                19.19,
                19.555,
                19.92,
                20.285,
                20.65,
                21.015,
                21.38,
                21.745,
                22.11,
                22.475,
                22.84,
                23.205,
                23.57,
                23.935,
                24.3,
                24.665,
                25.03,
                25.395,
                25.76,
                26.125,
                26.49,
                26.855,
                27.22,
                27.585,
                27.95,
                28.315,
                28.68,
                29.045,
                29.41,
                29.775,
                30.14,
                30.505,
                30.87,
                31.235,
                31.6,
                31.965,
                32.33,
                32.695,
                33.06,
                33.425,
                33.79,
                34.155,
                34.52,
                34.885,
                35.25,
                35.615,
                35.98,
                36.345,
                36.71,
                37.075,
                37.44,
                37.805,
                38.17,
                38.535,
                38.9,
                39.265,
                39.63,
                39.995,
                40.36,
                40.725,
                41.09,
                41.455,
                41.82,
                42.185,
                42.55,
                42.915,
                43.28,
                43.645,
                44.01,
                44.375,
                44.74,
                45.105,
                45.47,
                45.835,
                46.2,
                46.565,
                46.93,
                47.295,
                47.66,
                48.025,
                48.39,
                48.755,
                49.12,
                49.485,
                49.85,
                50.215,
                50.58,
                50.945,
                51.31,
                51.675,
                52.04,
                52.405,
                52.77,
                53.135,
                53.5,
                53.865,
                54.23,
                54.595,
                54.96,
                55.325,
                55.69,
                56.055,
                56.42,
                56.785,
                57.15,
                57.515,
                57.88,
                58.245,
                58.61,
                58.975,
                59.34,
                59.705,
                60.07,
                60.435,
                60.8,
                61.165,
                61.53,
                61.895,
                62.26,
                62.625,
                62.99,
                63.355,
                63.72,
                64.085,
                64.45,
                64.815,
                65.18,
                65.545,
                65.91,
                66.275,
                66.64,
                67.005,
                67.37,
                67.735,
                68.1,
                68.465,
                68.83,
                69.195,
                69.56,
                69.925,
                70.29,
                70.655,
                71.02,
                71.385,
                71.75,
                72.115,
                72.48,
                72.845,
                73.21,
                73.575,
                73.94,
                74.305,
                74.67,
                75.035,
                75.4,
                75.765,
                76.13,
                76.495,
                76.86,
                77.225,
                77.59,
                77.955,
                78.32,
                78.685,
                79.05,
                79.415,
                79.78,
                80.145,
                80.51,
                80.875,
                81.24,
                81.605,
                81.97,
                82.335,
                82.7,
                83.065,
                83.43,
                83.795,
                84.16,
                84.525,
                84.89,
                85.255,
                85.62,
                85.985,
                86.35,
                86.715,
                87.08,
                87.445,
                87.81,
                88.175,
                88.54,
                88.905,
                89.27,
                89.635,
                90
              ],
              "y": [
                0.012,
                0.012,
                0.029,
                0.029,
                0.029,
                0.05,
                0.05,
                0.05,
                0.073,
                0.073,
                0.096,
                0.096,
                0.096,
                0.12,
                0.12,
                0.12,
                0.148,
                0.148,
                0.148,
                0.173,
                0.173,
                0.197,
                0.197,
                0.197,
                0.22,
                0.22,
                0.22,
                0.246,
                0.246,
                0.246,
                0.271,
                0.271,
                0.297,
                0.297,
                0.297,
                0.323,
                0.323,
                0.323,
                0.35,
                0.35,
                0.35,
                0.376,
                0.376,
                0.404,
                0.404,
                0.404,
                0.43,
                0.43,
                0.43,
                0.457,
                0.457,
                0.457,
                0.485,
                0.485,
                0.512,
                0.512,
                0.512,
                0.537,
                0.537,
                0.537,
                0.562,
                0.562,
                0.562,
                0.587,
                0.587,
                0.612,
                0.612,
                0.612,
                0.635,
                0.635,
                0.635,
                0.658,
                0.658,
                0.68,
                0.68,
                0.68,
                0.702,
                0.702,
                0.702,
                0.724,
                0.724,
                0.724,
                0.747,
                0.747,
                0.764,
                0.764,
                0.764,
                0.782,
                0.782,
                0.782,
                0.799,
                0.799,
                0.799,
                0.817,
                0.817,
                0.832,
                0.832,
                0.832,
                0.847,
                0.847,
                0.847,
                0.859,
                0.859,
                0.859,
                0.871,
                0.871,
                0.883,
                0.883,
                0.883,
                0.895,
                0.895,
                0.895,
                0.906,
                0.906,
                0.906,
                0.917,
                0.917,
                0.925,
                0.925,
                0.925,
                0.934,
                0.934,
                0.934,
                0.942,
                0.942,
                0.942,
                0.949,
                0.949,
                0.956,
                0.956,
                0.956,
                0.962,
                0.962,
                0.962,
                0.967,
                0.967,
                0.972,
                0.972,
                0.972,
                0.975,
                0.975,
                0.975,
                0.978,
                0.978,
                0.978,
                0.981,
                0.981,
                0.984,
                0.984,
                0.984,
                0.986,
                0.986,
                0.986,
                0.989,
                0.989,
                0.989,
                0.99,
                0.99,
                0.992,
                0.992,
                0.992,
                0.994,
                0.994,
                0.994,
                0.995,
                0.995,
                0.995,
                0.996,
                0.996,
                0.996,
                0.996,
                0.996,
                0.997,
                0.997,
                0.997,
                0.998,
                0.998,
                0.998,
                0.998,
                0.998,
                0.998,
                0.998,
                0.998,
                0.999,
                0.999,
                0.999,
                0.999,
                0.999,
                0.999,
                0.999,
                0.999,
                0.999,
                0.999,
                0.999,
                0.999,
                0.999,
                0.999,
                0.999,
                0.999,
                1
              ],
              "type": "line",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "shape": "spline"
            },
            {
              "x": [
                17,
                17.365,
                17.73,
                18.095,
                18.46,
                18.825,
                19.19,
                19.555,
                19.92,
                20.285,
                20.65,
                21.015,
                21.38,
                21.745,
                22.11,
                22.475,
                22.84,
                23.205,
                23.57,
                23.935,
                24.3,
                24.665,
                25.03,
                25.395,
                25.76,
                26.125,
                26.49,
                26.855,
                27.22,
                27.585,
                27.95,
                28.315,
                28.68,
                29.045,
                29.41,
                29.775,
                30.14,
                30.505,
                30.87,
                31.235,
                31.6,
                31.965,
                32.33,
                32.695,
                33.06,
                33.425,
                33.79,
                34.155,
                34.52,
                34.885,
                35.25,
                35.615,
                35.98,
                36.345,
                36.71,
                37.075,
                37.44,
                37.805,
                38.17,
                38.535,
                38.9,
                39.265,
                39.63,
                39.995,
                40.36,
                40.725,
                41.09,
                41.455,
                41.82,
                42.185,
                42.55,
                42.915,
                43.28,
                43.645,
                44.01,
                44.375,
                44.74,
                45.105,
                45.47,
                45.835,
                46.2,
                46.565,
                46.93,
                47.295,
                47.66,
                48.025,
                48.39,
                48.755,
                49.12,
                49.485,
                49.85,
                50.215,
                50.58,
                50.945,
                51.31,
                51.675,
                52.04,
                52.405,
                52.77,
                53.135,
                53.5,
                53.865,
                54.23,
                54.595,
                54.96,
                55.325,
                55.69,
                56.055,
                56.42,
                56.785,
                57.15,
                57.515,
                57.88,
                58.245,
                58.61,
                58.975,
                59.34,
                59.705,
                60.07,
                60.435,
                60.8,
                61.165,
                61.53,
                61.895,
                62.26,
                62.625,
                62.99,
                63.355,
                63.72,
                64.085,
                64.45,
                64.815,
                65.18,
                65.545,
                65.91,
                66.275,
                66.64,
                67.005,
                67.37,
                67.735,
                68.1,
                68.465,
                68.83,
                69.195,
                69.56,
                69.925,
                70.29,
                70.655,
                71.02,
                71.385,
                71.75,
                72.115,
                72.48,
                72.845,
                73.21,
                73.575,
                73.94,
                74.305,
                74.67,
                75.035,
                75.4,
                75.765,
                76.13,
                76.495,
                76.86,
                77.225,
                77.59,
                77.955,
                78.32,
                78.685,
                79.05,
                79.415,
                79.78,
                80.145,
                80.51,
                80.875,
                81.24,
                81.605,
                81.97,
                82.335,
                82.7,
                83.065,
                83.43,
                83.795,
                84.16,
                84.525,
                84.89,
                85.255,
                85.62,
                85.985,
                86.35,
                86.715,
                87.08,
                87.445,
                87.81,
                88.175,
                88.54,
                88.905,
                89.27,
                89.635,
                90
              ],
              "y": [
                0.013,
                0.013,
                0.031,
                0.031,
                0.031,
                0.054,
                0.054,
                0.054,
                0.076,
                0.076,
                0.099,
                0.099,
                0.099,
                0.122,
                0.122,
                0.122,
                0.148,
                0.148,
                0.148,
                0.172,
                0.172,
                0.197,
                0.197,
                0.197,
                0.222,
                0.222,
                0.222,
                0.247,
                0.247,
                0.247,
                0.274,
                0.274,
                0.299,
                0.299,
                0.299,
                0.325,
                0.325,
                0.325,
                0.352,
                0.352,
                0.352,
                0.377,
                0.377,
                0.403,
                0.403,
                0.403,
                0.431,
                0.431,
                0.431,
                0.458,
                0.458,
                0.458,
                0.486,
                0.486,
                0.511,
                0.511,
                0.511,
                0.537,
                0.537,
                0.537,
                0.561,
                0.561,
                0.561,
                0.585,
                0.585,
                0.611,
                0.611,
                0.611,
                0.636,
                0.636,
                0.636,
                0.659,
                0.659,
                0.68,
                0.68,
                0.68,
                0.703,
                0.703,
                0.703,
                0.726,
                0.726,
                0.726,
                0.747,
                0.747,
                0.764,
                0.764,
                0.764,
                0.78,
                0.78,
                0.78,
                0.799,
                0.799,
                0.799,
                0.817,
                0.817,
                0.832,
                0.832,
                0.832,
                0.847,
                0.847,
                0.847,
                0.86,
                0.86,
                0.86,
                0.874,
                0.874,
                0.885,
                0.885,
                0.885,
                0.895,
                0.895,
                0.895,
                0.906,
                0.906,
                0.906,
                0.918,
                0.918,
                0.928,
                0.928,
                0.928,
                0.939,
                0.939,
                0.939,
                0.948,
                0.948,
                0.948,
                0.954,
                0.954,
                0.96,
                0.96,
                0.96,
                0.965,
                0.965,
                0.965,
                0.97,
                0.97,
                0.975,
                0.975,
                0.975,
                0.979,
                0.979,
                0.979,
                0.982,
                0.982,
                0.982,
                0.985,
                0.985,
                0.987,
                0.987,
                0.987,
                0.989,
                0.989,
                0.989,
                0.991,
                0.991,
                0.991,
                0.992,
                0.992,
                0.993,
                0.993,
                0.993,
                0.994,
                0.994,
                0.994,
                0.995,
                0.995,
                0.995,
                0.996,
                0.996,
                0.996,
                0.996,
                0.996,
                0.997,
                0.997,
                0.997,
                0.998,
                0.998,
                0.998,
                0.998,
                0.998,
                0.998,
                0.998,
                0.998,
                0.998,
                0.998,
                0.998,
                0.999,
                0.999,
                0.999,
                0.999,
                0.999,
                0.999,
                0.999,
                0.999,
                0.999,
                0.999,
                0.999,
                0.999,
                0.999,
                1
              ],
              "type": "line",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "shape": "spline"
            }
          ],
          [
            {
              "y": [
                38.668
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "y": [
                38.581
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "educational-num",
        "status": "Not Detected",
        "pvalue": "0.92",
        "feat_imp": 8,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "bins"
            },
            "yaxis": {
              "title": "pdf"
            },
            "showlegend": "false",
            "barmode": "group"
          },
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "bins"
            },
            "yaxis": {
              "title": "cdf"
            },
            "showlegend": "false"
          },
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 360,
            "xaxis": {
              "title": "data"
            },
            "yaxis": {
              "title": "mean"
            },
            "showlegend": "false"
          }
        ],
        "data": [
          [
            {
              "x": [
                1,
                1.3,
                1.6,
                1.9,
                2.2,
                2.5,
                2.8,
                3.1,
                3.4,
                3.7,
                4,
                4.3,
                4.6,
                4.9,
                5.2,
                5.5,
                5.8,
                6.1,
                6.4,
                6.7,
                7,
                7.3,
                7.6,
                7.9,
                8.2,
                8.5,
                8.8,
                9.1,
                9.4,
                9.7,
                10,
                10.3,
                10.6,
                10.9,
                11.2,
                11.5,
                11.8,
                12.1,
                12.4,
                12.7,
                13,
                13.3,
                13.6,
                13.9,
                14.2,
                14.5,
                14.8,
                15.1,
                15.4,
                15.7,
                16
              ],
              "y": [
                0.002,
                0,
                0,
                0.005,
                0,
                0,
                0.01,
                0,
                0,
                0,
                0.019,
                0,
                0,
                0.015,
                0,
                0,
                0.028,
                0,
                0,
                0,
                0.037,
                0,
                0,
                0.013,
                0,
                0,
                0.326,
                0,
                0,
                0,
                0.222,
                0,
                0,
                0.042,
                0,
                0,
                0.032,
                0,
                0,
                0,
                0.165,
                0,
                0,
                0.055,
                0,
                0,
                0.016,
                0,
                0,
                0.012
              ],
              "type": "lines",
              "fill": "tozeroy",
              "name": "reference",
              "marker": {
                "color": "blue"
              }
            },
            {
              "x": [
                1,
                1.3,
                1.6,
                1.9,
                2.2,
                2.5,
                2.8,
                3.1,
                3.4,
                3.7,
                4,
                4.3,
                4.6,
                4.9,
                5.2,
                5.5,
                5.8,
                6.1,
                6.4,
                6.7,
                7,
                7.3,
                7.6,
                7.9,
                8.2,
                8.5,
                8.8,
                9.1,
                9.4,
                9.7,
                10,
                10.3,
                10.6,
                10.9,
                11.2,
                11.5,
                11.8,
                12.1,
                12.4,
                12.7,
                13,
                13.3,
                13.6,
                13.9,
                14.2,
                14.5,
                14.8,
                15.1,
                15.4,
                15.7,
                16
              ],
              "y": [
                0.002,
                0,
                0,
                0.006,
                0,
                0,
                0.01,
                0,
                0,
                0,
                0.02,
                0,
                0,
                0.016,
                0,
                0,
                0.029,
                0,
                0,
                0,
                0.036,
                0,
                0,
                0.016,
                0,
                0,
                0.317,
                0,
                0,
                0,
                0.225,
                0,
                0,
                0.043,
                0,
                0,
                0.034,
                0,
                0,
                0,
                0.162,
                0,
                0,
                0.053,
                0,
                0,
                0.019,
                0,
                0,
                0.013
              ],
              "type": "lines",
              "fill": "tozeroy",
              "name": "production",
              "marker": {
                "color": "red"
              }
            }
          ],
          [
            {
              "x": [
                1,
                1.075,
                1.15,
                1.225,
                1.3,
                1.375,
                1.45,
                1.525,
                1.6,
                1.675,
                1.75,
                1.825,
                1.9,
                1.975,
                2.05,
                2.125,
                2.2,
                2.275,
                2.35,
                2.425,
                2.5,
                2.575,
                2.65,
                2.725,
                2.8,
                2.875,
                2.95,
                3.025,
                3.1,
                3.175,
                3.25,
                3.325,
                3.4,
                3.475,
                3.55,
                3.625,
                3.7,
                3.775,
                3.85,
                3.925,
                4,
                4.075,
                4.15,
                4.225,
                4.3,
                4.375,
                4.45,
                4.525,
                4.6,
                4.675,
                4.75,
                4.825,
                4.9,
                4.975,
                5.05,
                5.125,
                5.2,
                5.275,
                5.35,
                5.425,
                5.5,
                5.575,
                5.65,
                5.725,
                5.8,
                5.875,
                5.95,
                6.025,
                6.1,
                6.175,
                6.25,
                6.325,
                6.4,
                6.475,
                6.55,
                6.625,
                6.7,
                6.775,
                6.85,
                6.925,
                7,
                7.075,
                7.15,
                7.225,
                7.3,
                7.375,
                7.45,
                7.525,
                7.6,
                7.675,
                7.75,
                7.825,
                7.9,
                7.975,
                8.05,
                8.125,
                8.2,
                8.275,
                8.35,
                8.425,
                8.5,
                8.575,
                8.65,
                8.725,
                8.8,
                8.875,
                8.95,
                9.025,
                9.1,
                9.175,
                9.25,
                9.325,
                9.4,
                9.475,
                9.55,
                9.625,
                9.7,
                9.775,
                9.85,
                9.925,
                10,
                10.075,
                10.15,
                10.225,
                10.3,
                10.375,
                10.45,
                10.525,
                10.6,
                10.675,
                10.75,
                10.825,
                10.9,
                10.975,
                11.05,
                11.125,
                11.2,
                11.275,
                11.35,
                11.425,
                11.5,
                11.575,
                11.65,
                11.725,
                11.8,
                11.875,
                11.95,
                12.025,
                12.1,
                12.175,
                12.25,
                12.325,
                12.4,
                12.475,
                12.55,
                12.625,
                12.7,
                12.775,
                12.85,
                12.925,
                13,
                13.075,
                13.15,
                13.225,
                13.3,
                13.375,
                13.45,
                13.525,
                13.6,
                13.675,
                13.75,
                13.825,
                13.9,
                13.975,
                14.05,
                14.125,
                14.2,
                14.275,
                14.35,
                14.425,
                14.5,
                14.575,
                14.65,
                14.725,
                14.8,
                14.875,
                14.95,
                15.025,
                15.1,
                15.175,
                15.25,
                15.325,
                15.4,
                15.475,
                15.55,
                15.625,
                15.7,
                15.775,
                15.85,
                15.925,
                16
              ],
              "y": [
                0.002,
                0.002,
                0.002,
                0.002,
                0.002,
                0.002,
                0.002,
                0.002,
                0.002,
                0.002,
                0.002,
                0.002,
                0.002,
                0.006,
                0.006,
                0.006,
                0.006,
                0.006,
                0.006,
                0.006,
                0.006,
                0.006,
                0.006,
                0.006,
                0.006,
                0.006,
                0.017,
                0.017,
                0.017,
                0.017,
                0.017,
                0.017,
                0.017,
                0.017,
                0.017,
                0.017,
                0.017,
                0.017,
                0.017,
                0.017,
                0.036,
                0.036,
                0.036,
                0.036,
                0.036,
                0.036,
                0.036,
                0.036,
                0.036,
                0.036,
                0.036,
                0.036,
                0.036,
                0.051,
                0.051,
                0.051,
                0.051,
                0.051,
                0.051,
                0.051,
                0.051,
                0.051,
                0.051,
                0.051,
                0.051,
                0.051,
                0.08,
                0.08,
                0.08,
                0.08,
                0.08,
                0.08,
                0.08,
                0.08,
                0.08,
                0.08,
                0.08,
                0.08,
                0.08,
                0.08,
                0.117,
                0.117,
                0.117,
                0.117,
                0.117,
                0.117,
                0.117,
                0.117,
                0.117,
                0.117,
                0.117,
                0.117,
                0.117,
                0.13,
                0.13,
                0.13,
                0.13,
                0.13,
                0.13,
                0.13,
                0.13,
                0.13,
                0.13,
                0.13,
                0.13,
                0.13,
                0.455,
                0.455,
                0.455,
                0.455,
                0.455,
                0.455,
                0.455,
                0.455,
                0.455,
                0.455,
                0.455,
                0.455,
                0.455,
                0.455,
                0.677,
                0.677,
                0.677,
                0.677,
                0.677,
                0.677,
                0.677,
                0.677,
                0.677,
                0.677,
                0.677,
                0.677,
                0.677,
                0.719,
                0.719,
                0.719,
                0.719,
                0.719,
                0.719,
                0.719,
                0.719,
                0.719,
                0.719,
                0.719,
                0.719,
                0.719,
                0.751,
                0.751,
                0.751,
                0.751,
                0.751,
                0.751,
                0.751,
                0.751,
                0.751,
                0.751,
                0.751,
                0.751,
                0.751,
                0.751,
                0.917,
                0.917,
                0.917,
                0.917,
                0.917,
                0.917,
                0.917,
                0.917,
                0.917,
                0.917,
                0.917,
                0.917,
                0.917,
                0.972,
                0.972,
                0.972,
                0.972,
                0.972,
                0.972,
                0.972,
                0.972,
                0.972,
                0.972,
                0.972,
                0.972,
                0.972,
                0.988,
                0.988,
                0.988,
                0.988,
                0.988,
                0.988,
                0.988,
                0.988,
                0.988,
                0.988,
                0.988,
                0.988,
                0.988,
                1
              ],
              "type": "line",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "shape": "spline"
            },
            {
              "x": [
                1,
                1.075,
                1.15,
                1.225,
                1.3,
                1.375,
                1.45,
                1.525,
                1.6,
                1.675,
                1.75,
                1.825,
                1.9,
                1.975,
                2.05,
                2.125,
                2.2,
                2.275,
                2.35,
                2.425,
                2.5,
                2.575,
                2.65,
                2.725,
                2.8,
                2.875,
                2.95,
                3.025,
                3.1,
                3.175,
                3.25,
                3.325,
                3.4,
                3.475,
                3.55,
                3.625,
                3.7,
                3.775,
                3.85,
                3.925,
                4,
                4.075,
                4.15,
                4.225,
                4.3,
                4.375,
                4.45,
                4.525,
                4.6,
                4.675,
                4.75,
                4.825,
                4.9,
                4.975,
                5.05,
                5.125,
                5.2,
                5.275,
                5.35,
                5.425,
                5.5,
                5.575,
                5.65,
                5.725,
                5.8,
                5.875,
                5.95,
                6.025,
                6.1,
                6.175,
                6.25,
                6.325,
                6.4,
                6.475,
                6.55,
                6.625,
                6.7,
                6.775,
                6.85,
                6.925,
                7,
                7.075,
                7.15,
                7.225,
                7.3,
                7.375,
                7.45,
                7.525,
                7.6,
                7.675,
                7.75,
                7.825,
                7.9,
                7.975,
                8.05,
                8.125,
                8.2,
                8.275,
                8.35,
                8.425,
                8.5,
                8.575,
                8.65,
                8.725,
                8.8,
                8.875,
                8.95,
                9.025,
                9.1,
                9.175,
                9.25,
                9.325,
                9.4,
                9.475,
                9.55,
                9.625,
                9.7,
                9.775,
                9.85,
                9.925,
                10,
                10.075,
                10.15,
                10.225,
                10.3,
                10.375,
                10.45,
                10.525,
                10.6,
                10.675,
                10.75,
                10.825,
                10.9,
                10.975,
                11.05,
                11.125,
                11.2,
                11.275,
                11.35,
                11.425,
                11.5,
                11.575,
                11.65,
                11.725,
                11.8,
                11.875,
                11.95,
                12.025,
                12.1,
                12.175,
                12.25,
                12.325,
                12.4,
                12.475,
                12.55,
                12.625,
                12.7,
                12.775,
                12.85,
                12.925,
                13,
                13.075,
                13.15,
                13.225,
                13.3,
                13.375,
                13.45,
                13.525,
                13.6,
                13.675,
                13.75,
                13.825,
                13.9,
                13.975,
                14.05,
                14.125,
                14.2,
                14.275,
                14.35,
                14.425,
                14.5,
                14.575,
                14.65,
                14.725,
                14.8,
                14.875,
                14.95,
                15.025,
                15.1,
                15.175,
                15.25,
                15.325,
                15.4,
                15.475,
                15.55,
                15.625,
                15.7,
                15.775,
                15.85,
                15.925,
                16
              ],
              "y": [
                0.002,
                0.002,
                0.002,
                0.002,
                0.002,
                0.002,
                0.002,
                0.002,
                0.002,
                0.002,
                0.002,
                0.002,
                0.002,
                0.008,
                0.008,
                0.008,
                0.008,
                0.008,
                0.008,
                0.008,
                0.008,
                0.008,
                0.008,
                0.008,
                0.008,
                0.008,
                0.018,
                0.018,
                0.018,
                0.018,
                0.018,
                0.018,
                0.018,
                0.018,
                0.018,
                0.018,
                0.018,
                0.018,
                0.018,
                0.018,
                0.038,
                0.038,
                0.038,
                0.038,
                0.038,
                0.038,
                0.038,
                0.038,
                0.038,
                0.038,
                0.038,
                0.038,
                0.038,
                0.054,
                0.054,
                0.054,
                0.054,
                0.054,
                0.054,
                0.054,
                0.054,
                0.054,
                0.054,
                0.054,
                0.054,
                0.054,
                0.083,
                0.083,
                0.083,
                0.083,
                0.083,
                0.083,
                0.083,
                0.083,
                0.083,
                0.083,
                0.083,
                0.083,
                0.083,
                0.083,
                0.119,
                0.119,
                0.119,
                0.119,
                0.119,
                0.119,
                0.119,
                0.119,
                0.119,
                0.119,
                0.119,
                0.119,
                0.119,
                0.135,
                0.135,
                0.135,
                0.135,
                0.135,
                0.135,
                0.135,
                0.135,
                0.135,
                0.135,
                0.135,
                0.135,
                0.135,
                0.452,
                0.452,
                0.452,
                0.452,
                0.452,
                0.452,
                0.452,
                0.452,
                0.452,
                0.452,
                0.452,
                0.452,
                0.452,
                0.452,
                0.677,
                0.677,
                0.677,
                0.677,
                0.677,
                0.677,
                0.677,
                0.677,
                0.677,
                0.677,
                0.677,
                0.677,
                0.677,
                0.72,
                0.72,
                0.72,
                0.72,
                0.72,
                0.72,
                0.72,
                0.72,
                0.72,
                0.72,
                0.72,
                0.72,
                0.72,
                0.754,
                0.754,
                0.754,
                0.754,
                0.754,
                0.754,
                0.754,
                0.754,
                0.754,
                0.754,
                0.754,
                0.754,
                0.754,
                0.754,
                0.916,
                0.916,
                0.916,
                0.916,
                0.916,
                0.916,
                0.916,
                0.916,
                0.916,
                0.916,
                0.916,
                0.916,
                0.916,
                0.969,
                0.969,
                0.969,
                0.969,
                0.969,
                0.969,
                0.969,
                0.969,
                0.969,
                0.969,
                0.969,
                0.969,
                0.969,
                0.987,
                0.987,
                0.987,
                0.987,
                0.987,
                0.987,
                0.987,
                0.987,
                0.987,
                0.987,
                0.987,
                0.987,
                0.987,
                1
              ],
              "type": "line",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "shape": "spline"
            }
          ],
          [
            {
              "y": [
                10.082
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "y": [
                10.069
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "hours-per-week",
        "status": "Not Detected",
        "pvalue": "0.97",
        "feat_imp": 13.9,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "bins"
            },
            "yaxis": {
              "title": "pdf"
            },
            "showlegend": "false",
            "barmode": "group"
          },
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "bins"
            },
            "yaxis": {
              "title": "cdf"
            },
            "showlegend": "false"
          },
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 360,
            "xaxis": {
              "title": "data"
            },
            "yaxis": {
              "title": "mean"
            },
            "showlegend": "false"
          }
        ],
        "data": [
          [
            {
              "x": [
                1,
                2.96,
                4.92,
                6.88,
                8.84,
                10.8,
                12.76,
                14.72,
                16.68,
                18.64,
                20.6,
                22.56,
                24.52,
                26.48,
                28.44,
                30.4,
                32.36,
                34.32,
                36.28,
                38.24,
                40.2,
                42.16,
                44.12,
                46.08,
                48.04,
                50,
                51.96,
                53.92,
                55.88,
                57.84,
                59.8,
                61.76,
                63.72,
                65.68,
                67.64,
                69.6,
                71.56,
                73.52,
                75.48,
                77.44,
                79.4,
                81.36,
                83.32,
                85.28,
                87.24,
                89.2,
                91.16,
                93.12,
                95.08,
                97.04,
                99
              ],
              "y": [
                0.002,
                0.003,
                0.004,
                0.006,
                0.009,
                0.005,
                0.002,
                0.019,
                0.004,
                0.039,
                0.002,
                0.008,
                0.02,
                0.004,
                0.035,
                0.009,
                0.002,
                0.047,
                0.02,
                0.468,
                0.009,
                0.011,
                0.057,
                0.017,
                0.001,
                0.088,
                0.005,
                0.022,
                0.003,
                0.001,
                0.045,
                0.001,
                0.007,
                0.001,
                0,
                0.009,
                0.002,
                0.002,
                0,
                0,
                0.004,
                0,
                0.002,
                0,
                0,
                0.001,
                0,
                0,
                0,
                0.003
              ],
              "type": "lines",
              "fill": "tozeroy",
              "name": "reference",
              "marker": {
                "color": "blue"
              }
            },
            {
              "x": [
                1,
                2.96,
                4.92,
                6.88,
                8.84,
                10.8,
                12.76,
                14.72,
                16.68,
                18.64,
                20.6,
                22.56,
                24.52,
                26.48,
                28.44,
                30.4,
                32.36,
                34.32,
                36.28,
                38.24,
                40.2,
                42.16,
                44.12,
                46.08,
                48.04,
                50,
                51.96,
                53.92,
                55.88,
                57.84,
                59.8,
                61.76,
                63.72,
                65.68,
                67.64,
                69.6,
                71.56,
                73.52,
                75.48,
                77.44,
                79.4,
                81.36,
                83.32,
                85.28,
                87.24,
                89.2,
                91.16,
                93.12,
                95.08,
                97.04,
                99
              ],
              "y": [
                0.002,
                0.003,
                0.004,
                0.005,
                0.01,
                0.006,
                0.002,
                0.019,
                0.003,
                0.038,
                0.002,
                0.008,
                0.021,
                0.003,
                0.036,
                0.009,
                0.002,
                0.046,
                0.018,
                0.468,
                0.007,
                0.01,
                0.06,
                0.018,
                0.001,
                0.086,
                0.005,
                0.025,
                0.004,
                0.001,
                0.044,
                0.001,
                0.009,
                0.001,
                0.001,
                0.009,
                0.002,
                0.002,
                0,
                0,
                0.004,
                0,
                0.002,
                0,
                0,
                0.001,
                0,
                0,
                0,
                0.003
              ],
              "type": "lines",
              "fill": "tozeroy",
              "name": "production",
              "marker": {
                "color": "red"
              }
            }
          ],
          [
            {
              "x": [
                1,
                1.49,
                1.98,
                2.47,
                2.96,
                3.45,
                3.94,
                4.43,
                4.92,
                5.41,
                5.9,
                6.39,
                6.88,
                7.37,
                7.86,
                8.35,
                8.84,
                9.33,
                9.82,
                10.31,
                10.8,
                11.29,
                11.78,
                12.27,
                12.76,
                13.25,
                13.74,
                14.23,
                14.72,
                15.21,
                15.7,
                16.19,
                16.68,
                17.17,
                17.66,
                18.15,
                18.64,
                19.13,
                19.62,
                20.11,
                20.6,
                21.09,
                21.58,
                22.07,
                22.56,
                23.05,
                23.54,
                24.03,
                24.52,
                25.01,
                25.5,
                25.99,
                26.48,
                26.97,
                27.46,
                27.95,
                28.44,
                28.93,
                29.42,
                29.91,
                30.4,
                30.89,
                31.38,
                31.87,
                32.36,
                32.85,
                33.34,
                33.83,
                34.32,
                34.81,
                35.3,
                35.79,
                36.28,
                36.77,
                37.26,
                37.75,
                38.24,
                38.73,
                39.22,
                39.71,
                40.2,
                40.69,
                41.18,
                41.67,
                42.16,
                42.65,
                43.14,
                43.63,
                44.12,
                44.61,
                45.1,
                45.59,
                46.08,
                46.57,
                47.06,
                47.55,
                48.04,
                48.53,
                49.02,
                49.51,
                50,
                50.49,
                50.98,
                51.47,
                51.96,
                52.45,
                52.94,
                53.43,
                53.92,
                54.41,
                54.9,
                55.39,
                55.88,
                56.37,
                56.86,
                57.35,
                57.84,
                58.33,
                58.82,
                59.31,
                59.8,
                60.29,
                60.78,
                61.27,
                61.76,
                62.25,
                62.74,
                63.23,
                63.72,
                64.21,
                64.7,
                65.19,
                65.68,
                66.17,
                66.66,
                67.15,
                67.64,
                68.13,
                68.62,
                69.11,
                69.6,
                70.09,
                70.58,
                71.07,
                71.56,
                72.05,
                72.54,
                73.03,
                73.52,
                74.01,
                74.5,
                74.99,
                75.48,
                75.97,
                76.46,
                76.95,
                77.44,
                77.93,
                78.42,
                78.91,
                79.4,
                79.89,
                80.38,
                80.87,
                81.36,
                81.85,
                82.34,
                82.83,
                83.32,
                83.81,
                84.3,
                84.79,
                85.28,
                85.77,
                86.26,
                86.75,
                87.24,
                87.73,
                88.22,
                88.71,
                89.2,
                89.69,
                90.18,
                90.67,
                91.16,
                91.65,
                92.14,
                92.63,
                93.12,
                93.61,
                94.1,
                94.59,
                95.08,
                95.57,
                96.06,
                96.55,
                97.04,
                97.53,
                98.02,
                98.51,
                99
              ],
              "y": [
                0,
                0,
                0.002,
                0.002,
                0.003,
                0.003,
                0.005,
                0.005,
                0.006,
                0.006,
                0.008,
                0.008,
                0.009,
                0.009,
                0.014,
                0.014,
                0.015,
                0.015,
                0.023,
                0.023,
                0.024,
                0.024,
                0.028,
                0.028,
                0.029,
                0.029,
                0.03,
                0.03,
                0.043,
                0.043,
                0.049,
                0.049,
                0.05,
                0.05,
                0.052,
                0.052,
                0.053,
                0.053,
                0.091,
                0.091,
                0.093,
                0.093,
                0.094,
                0.094,
                0.094,
                0.094,
                0.102,
                0.102,
                0.121,
                0.121,
                0.121,
                0.122,
                0.122,
                0.123,
                0.123,
                0.126,
                0.126,
                0.126,
                0.126,
                0.161,
                0.161,
                0.161,
                0.161,
                0.169,
                0.169,
                0.171,
                0.171,
                0.172,
                0.172,
                0.211,
                0.211,
                0.218,
                0.218,
                0.223,
                0.223,
                0.238,
                0.238,
                0.24,
                0.24,
                0.707,
                0.707,
                0.708,
                0.708,
                0.715,
                0.715,
                0.72,
                0.72,
                0.727,
                0.727,
                0.782,
                0.782,
                0.784,
                0.784,
                0.786,
                0.786,
                0.801,
                0.801,
                0.802,
                0.802,
                0.802,
                0.89,
                0.89,
                0.89,
                0.89,
                0.894,
                0.894,
                0.895,
                0.895,
                0.896,
                0.896,
                0.917,
                0.917,
                0.92,
                0.92,
                0.92,
                0.92,
                0.921,
                0.921,
                0.921,
                0.921,
                0.966,
                0.966,
                0.966,
                0.966,
                0.967,
                0.967,
                0.967,
                0.967,
                0.967,
                0.967,
                0.974,
                0.974,
                0.975,
                0.975,
                0.975,
                0.975,
                0.975,
                0.975,
                0.975,
                0.975,
                0.984,
                0.984,
                0.984,
                0.984,
                0.986,
                0.986,
                0.986,
                0.986,
                0.986,
                0.986,
                0.986,
                0.989,
                0.989,
                0.989,
                0.989,
                0.989,
                0.989,
                0.989,
                0.989,
                0.989,
                0.989,
                0.994,
                0.994,
                0.994,
                0.994,
                0.994,
                0.994,
                0.994,
                0.994,
                0.995,
                0.995,
                0.996,
                0.996,
                0.996,
                0.996,
                0.996,
                0.996,
                0.996,
                0.996,
                0.996,
                0.996,
                0.997,
                0.997,
                0.997,
                0.997,
                0.997,
                0.997,
                0.997,
                0.997,
                0.997,
                0.997,
                0.997,
                0.997,
                0.997,
                0.997,
                0.997,
                0.997,
                0.997,
                0.997,
                1
              ],
              "type": "line",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "shape": "spline"
            },
            {
              "x": [
                1,
                1.49,
                1.98,
                2.47,
                2.96,
                3.45,
                3.94,
                4.43,
                4.92,
                5.41,
                5.9,
                6.39,
                6.88,
                7.37,
                7.86,
                8.35,
                8.84,
                9.33,
                9.82,
                10.31,
                10.8,
                11.29,
                11.78,
                12.27,
                12.76,
                13.25,
                13.74,
                14.23,
                14.72,
                15.21,
                15.7,
                16.19,
                16.68,
                17.17,
                17.66,
                18.15,
                18.64,
                19.13,
                19.62,
                20.11,
                20.6,
                21.09,
                21.58,
                22.07,
                22.56,
                23.05,
                23.54,
                24.03,
                24.52,
                25.01,
                25.5,
                25.99,
                26.48,
                26.97,
                27.46,
                27.95,
                28.44,
                28.93,
                29.42,
                29.91,
                30.4,
                30.89,
                31.38,
                31.87,
                32.36,
                32.85,
                33.34,
                33.83,
                34.32,
                34.81,
                35.3,
                35.79,
                36.28,
                36.77,
                37.26,
                37.75,
                38.24,
                38.73,
                39.22,
                39.71,
                40.2,
                40.69,
                41.18,
                41.67,
                42.16,
                42.65,
                43.14,
                43.63,
                44.12,
                44.61,
                45.1,
                45.59,
                46.08,
                46.57,
                47.06,
                47.55,
                48.04,
                48.53,
                49.02,
                49.51,
                50,
                50.49,
                50.98,
                51.47,
                51.96,
                52.45,
                52.94,
                53.43,
                53.92,
                54.41,
                54.9,
                55.39,
                55.88,
                56.37,
                56.86,
                57.35,
                57.84,
                58.33,
                58.82,
                59.31,
                59.8,
                60.29,
                60.78,
                61.27,
                61.76,
                62.25,
                62.74,
                63.23,
                63.72,
                64.21,
                64.7,
                65.19,
                65.68,
                66.17,
                66.66,
                67.15,
                67.64,
                68.13,
                68.62,
                69.11,
                69.6,
                70.09,
                70.58,
                71.07,
                71.56,
                72.05,
                72.54,
                73.03,
                73.52,
                74.01,
                74.5,
                74.99,
                75.48,
                75.97,
                76.46,
                76.95,
                77.44,
                77.93,
                78.42,
                78.91,
                79.4,
                79.89,
                80.38,
                80.87,
                81.36,
                81.85,
                82.34,
                82.83,
                83.32,
                83.81,
                84.3,
                84.79,
                85.28,
                85.77,
                86.26,
                86.75,
                87.24,
                87.73,
                88.22,
                88.71,
                89.2,
                89.69,
                90.18,
                90.67,
                91.16,
                91.65,
                92.14,
                92.63,
                93.12,
                93.61,
                94.1,
                94.59,
                95.08,
                95.57,
                96.06,
                96.55,
                97.04,
                97.53,
                98.02,
                98.51,
                99
              ],
              "y": [
                0.001,
                0.001,
                0.002,
                0.002,
                0.003,
                0.003,
                0.005,
                0.005,
                0.007,
                0.007,
                0.009,
                0.009,
                0.009,
                0.009,
                0.013,
                0.013,
                0.013,
                0.013,
                0.023,
                0.023,
                0.023,
                0.023,
                0.029,
                0.029,
                0.03,
                0.03,
                0.031,
                0.031,
                0.044,
                0.044,
                0.05,
                0.05,
                0.051,
                0.051,
                0.053,
                0.053,
                0.054,
                0.054,
                0.091,
                0.091,
                0.091,
                0.091,
                0.093,
                0.093,
                0.094,
                0.094,
                0.101,
                0.101,
                0.122,
                0.122,
                0.122,
                0.122,
                0.122,
                0.123,
                0.123,
                0.125,
                0.125,
                0.125,
                0.125,
                0.161,
                0.161,
                0.161,
                0.161,
                0.17,
                0.17,
                0.171,
                0.171,
                0.172,
                0.172,
                0.212,
                0.212,
                0.218,
                0.218,
                0.224,
                0.224,
                0.237,
                0.237,
                0.238,
                0.238,
                0.704,
                0.704,
                0.705,
                0.705,
                0.711,
                0.711,
                0.716,
                0.716,
                0.722,
                0.722,
                0.779,
                0.779,
                0.782,
                0.782,
                0.784,
                0.784,
                0.8,
                0.8,
                0.801,
                0.801,
                0.801,
                0.886,
                0.886,
                0.887,
                0.887,
                0.891,
                0.891,
                0.892,
                0.892,
                0.893,
                0.893,
                0.917,
                0.917,
                0.919,
                0.919,
                0.92,
                0.92,
                0.921,
                0.921,
                0.921,
                0.921,
                0.964,
                0.964,
                0.964,
                0.964,
                0.965,
                0.965,
                0.965,
                0.965,
                0.966,
                0.966,
                0.974,
                0.974,
                0.975,
                0.975,
                0.975,
                0.975,
                0.975,
                0.975,
                0.975,
                0.975,
                0.985,
                0.985,
                0.985,
                0.985,
                0.986,
                0.986,
                0.986,
                0.986,
                0.987,
                0.987,
                0.987,
                0.988,
                0.988,
                0.988,
                0.988,
                0.989,
                0.989,
                0.989,
                0.989,
                0.989,
                0.989,
                0.993,
                0.993,
                0.993,
                0.993,
                0.993,
                0.993,
                0.993,
                0.993,
                0.994,
                0.994,
                0.995,
                0.995,
                0.995,
                0.995,
                0.995,
                0.995,
                0.995,
                0.995,
                0.995,
                0.995,
                0.996,
                0.996,
                0.996,
                0.996,
                0.996,
                0.996,
                0.996,
                0.996,
                0.996,
                0.996,
                0.996,
                0.996,
                0.997,
                0.997,
                0.997,
                0.997,
                0.997,
                0.997,
                1
              ],
              "type": "line",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "shape": "spline"
            }
          ],
          [
            {
              "y": [
                40.403
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "y": [
                40.472
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "workclass_?",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0.2,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "32989",
                "2011"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13054",
                "788"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "workclass_Federal-gov",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0.5,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "33964",
                "1036"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13446",
                "396"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "workclass_Local-gov",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0.7,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "32772",
                "2228"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "12934",
                "908"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "workclass_Never-worked",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34994",
                "6"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13838",
                "4"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "workclass_Private",
        "status": "Not Detected",
        "pvalue": "0.99",
        "feat_imp": 1.3,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "10748",
                "24252"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "4188",
                "9654"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "workclass_Self-emp-inc",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0.8,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "33777",
                "1223"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13370",
                "472"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "workclass_Self-emp-not-inc",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 1.1,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "32200",
                "2800"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "12780",
                "1062"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "workclass_State-gov",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0.6,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "33568",
                "1432"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13293",
                "549"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "workclass_Without-pay",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34988",
                "12"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13833",
                "9"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "education_10th",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0.2,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34013",
                "987"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13440",
                "402"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "education_11th",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0.2,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "33691",
                "1309"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13339",
                "503"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "education_12th",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0.1,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34561",
                "439"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13624",
                "218"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "education_1st-4th",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34831",
                "169"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13764",
                "78"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "education_5th-6th",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0.1,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34634",
                "366"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13699",
                "143"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "education_7th-8th",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0.2,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34324",
                "676"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13563",
                "279"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "education_9th",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0.1,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34466",
                "534"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13620",
                "222"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "education_Assoc-acdm",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0.3,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "33871",
                "1129"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13370",
                "472"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "education_Assoc-voc",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0.3,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "33536",
                "1464"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13245",
                "597"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "education_Bachelors",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 1.2,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "29213",
                "5787"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "11604",
                "2238"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "education_Doctorate",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0.3,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34580",
                "420"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13668",
                "174"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "education_HS-grad",
        "status": "Not Detected",
        "pvalue": "0.42",
        "feat_imp": 0.8,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "23602",
                "11398"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "9456",
                "4386"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "education_Masters",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0.8,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "33079",
                "1921"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13106",
                "736"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "education_Preschool",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34943",
                "57"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13816",
                "26"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "education_Prof-school",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0.5,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34425",
                "575"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13583",
                "259"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "education_Some-college",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0.6,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "27231",
                "7769"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "10733",
                "3109"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "marital-status_Divorced",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0.8,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "30259",
                "4741"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "11950",
                "1892"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "marital-status_Married-AF-spouse",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34972",
                "28"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13833",
                "9"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "marital-status_Married-civ-spouse",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 7.4,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "18986",
                "16014"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "7477",
                "6365"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "marital-status_Married-spouse-absent",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0.1,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34553",
                "447"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13661",
                "181"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "marital-status_Never-married",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 3.2,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "23420",
                "11580"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "9305",
                "4537"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "marital-status_Separated",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0.2,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "33915",
                "1085"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13397",
                "445"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "marital-status_Widowed",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0.2,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "33895",
                "1105"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13429",
                "413"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "occupation_?",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0.2,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "32983",
                "2017"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13050",
                "792"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "occupation_Adm-clerical",
        "status": "Not Detected",
        "pvalue": "0.81",
        "feat_imp": 0.7,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "30916",
                "4084"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "12315",
                "1527"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "occupation_Armed-Forces",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34988",
                "12"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13839",
                "3"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "occupation_Craft-repair",
        "status": "Not Detected",
        "pvalue": "0.98",
        "feat_imp": 0.8,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "30667",
                "4333"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "12063",
                "1779"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "occupation_Exec-managerial",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 2.1,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "30678",
                "4322"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "12078",
                "1764"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "occupation_Farming-fishing",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0.5,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "33957",
                "1043"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13395",
                "447"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "occupation_Handlers-cleaners",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0.4,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "33553",
                "1447"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13217",
                "625"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "occupation_Machine-op-inspct",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0.5,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "32813",
                "2187"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13007",
                "835"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "occupation_Other-service",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0.9,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "31458",
                "3542"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "12461",
                "1381"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "occupation_Priv-house-serv",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34812",
                "188"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13788",
                "54"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "occupation_Prof-specialty",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 1.9,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "30595",
                "4405"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "12075",
                "1767"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "occupation_Protective-serv",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0.4,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34300",
                "700"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13559",
                "283"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "occupation_Sales",
        "status": "Not Detected",
        "pvalue": "0.94",
        "feat_imp": 0.8,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "31003",
                "3997"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "12335",
                "1507"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "occupation_Tech-support",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0.6,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "33954",
                "1046"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13442",
                "400"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "occupation_Transport-moving",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0.5,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "33323",
                "1677"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13164",
                "678"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "relationship_Husband",
        "status": "Not Detected",
        "pvalue": "0.99",
        "feat_imp": 4.7,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "20915",
                "14085"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "8211",
                "5631"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "relationship_Not-in-family",
        "status": "Not Detected",
        "pvalue": "0.58",
        "feat_imp": 1.2,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "25906",
                "9094"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "10353",
                "3489"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "relationship_Other-relative",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0.2,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "33920",
                "1080"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13416",
                "426"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "relationship_Own-child",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0.9,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "29579",
                "5421"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "11682",
                "2160"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "relationship_Unmarried",
        "status": "Not Detected",
        "pvalue": "0.98",
        "feat_imp": 0.8,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "31374",
                "3626"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "12343",
                "1499"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "relationship_Wife",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 1,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "33306",
                "1694"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13205",
                "637"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "race_Amer-Indian-Eskimo",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0.2,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34667",
                "333"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13705",
                "137"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "race_Asian-Pac-Islander",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0.4,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "33936",
                "1064"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13387",
                "455"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "race_Black",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0.6,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "31665",
                "3335"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "12492",
                "1350"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "race_Other",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0.1,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34709",
                "291"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13727",
                "115"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "race_White",
        "status": "Not Detected",
        "pvalue": "0.96",
        "feat_imp": 0.8,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "5023",
                "29977"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "2057",
                "11785"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "gender_Female",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 1.2,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "23412",
                "11588"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "9238",
                "4604"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "gender_Male",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0.6,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "11588",
                "23412"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "4604",
                "9238"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_?",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0.4,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34392",
                "608"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13593",
                "249"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Cambodia",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34979",
                "21"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13835",
                "7"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Canada",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0.2,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34865",
                "135"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13795",
                "47"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_China",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0.1,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34907",
                "93"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13813",
                "29"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Columbia",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34945",
                "55"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13812",
                "30"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Cuba",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0.1,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34899",
                "101"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13805",
                "37"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Dominican-Republic",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34927",
                "73"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13812",
                "30"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Ecuador",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34965",
                "35"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13832",
                "10"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_El-Salvador",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34893",
                "107"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13794",
                "48"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_England",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0.1,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34901",
                "99"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13814",
                "28"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_France",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34978",
                "22"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13826",
                "16"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Germany",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0.1,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34849",
                "151"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13787",
                "55"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Greece",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0.1,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34961",
                "39"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13832",
                "10"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Guatemala",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34936",
                "64"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13818",
                "24"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Haiti",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34943",
                "57"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13824",
                "18"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Holand-Netherlands",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "35000",
                "0"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13841",
                "1"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Honduras",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34985",
                "15"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13837",
                "5"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Hong",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34982",
                "18"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13830",
                "12"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Hungary",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34988",
                "12"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13835",
                "7"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_India",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0.1,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34899",
                "101"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13792",
                "50"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Iran",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0.1,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34955",
                "45"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13828",
                "14"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Ireland",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0.1,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34971",
                "29"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13834",
                "8"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Italy",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0.1,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34927",
                "73"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13810",
                "32"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Jamaica",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34928",
                "72"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13808",
                "34"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Japan",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0.1,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34933",
                "67"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13817",
                "25"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Laos",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34989",
                "11"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13830",
                "12"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Mexico",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0.3,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34320",
                "680"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13571",
                "271"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Nicaragua",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34965",
                "35"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13828",
                "14"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Outlying-US(Guam-USVI-etc)",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34985",
                "15"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13834",
                "8"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Peru",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34969",
                "31"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13827",
                "15"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Philippines",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0.1,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34792",
                "208"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13755",
                "87"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Poland",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0.1,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34932",
                "68"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13823",
                "19"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Portugal",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0.1,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34949",
                "51"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13826",
                "16"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Puerto-Rico",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0.1,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34858",
                "142"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13800",
                "42"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Scotland",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34986",
                "14"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13835",
                "7"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_South",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0.1,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34913",
                "87"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13814",
                "28"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Taiwan",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34954",
                "46"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13823",
                "19"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Thailand",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34979",
                "21"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13833",
                "9"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Trinadad&Tobago",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34984",
                "16"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13831",
                "11"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_United-States",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0.8,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "3589",
                "31411"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "1421",
                "12421"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Vietnam",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34943",
                "57"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13813",
                "29"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Yugoslavia",
        "status": "Not Detected",
        "pvalue": "1.0",
        "feat_imp": 0,
        "layout": [
          {
            "autosize": "false",
            "margin": {
              "l": 25,
              "r": 12,
              "b": 16,
              "t": 14,
              "pad": 0
            },
            "height": 240,
            "width": 460,
            "xaxis": {
              "title": "categories"
            },
            "yaxis": {
              "title": "counts"
            },
            "showlegend": "false",
            "bargap": 0.05,
            "barmode": "group"
          }
        ],
        "data": [
          [
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "34985",
                "15"
              ],
              "type": "bar",
              "name": "reference",
              "marker": {
                "color": "blue"
              },
              "width": "0.25"
            },
            {
              "x": [
                "0",
                "1"
              ],
              "y": [
                "13834",
                "8"
              ],
              "type": "bar",
              "name": "production",
              "marker": {
                "color": "red"
              },
              "width": "0.25"
            }
          ]
        ]
      }
    ]
  },
  "cd": {
    "project_name": "froud_detection",
    "model_name": "credit_fraud",
    "header": "Concept Drift",
    "values": [
      {
        "x": [
          "accuracy",
          "auc_roc",
          "f1_score"
        ],
        "y": [
          0.22,
          0.01,
          0.02
        ],
        "type": "bar",
        "marker": {
          "color": "green"
        },
        "width": "0.25",
        "barmode": "stack"
      }
    ],
    "layout": {
      "autosize": "false",
      "margin": {
        "l": 50,
        "r": 50,
        "b": 50,
        "t": 50,
        "pad": 0
      },
      "height": 350,
      "width": 875,
      "xaxis": {
        "title": "metrics"
      },
      "yaxis": {
        "title": "Percentage"
      },
      "showlegend": "true"
    },
    "timestamp": "2021-12-01 14:52:55.531141",
    "name": "production metric drift",
    "des": "Concept drift indicates the changes in model performance with respect to various metrics like\n      Accuracy, AUC-ROC, F1 score etc. The Bar Plot given given represents percentage concept drift with \n      respect to these metrics."
  },
  "ae": {
    "project_name": "froud_detection",
    "module_name": "credit_fraud",
    "header": "Adversarial Detection",
    "values": [
      {
        "x": [
          "Reference Data",
          "Production Data"
        ],
        "y": [
          95,
          94.741
        ],
        "type": "bar",
        "mode": "lines+markers",
        "marker": {
          "color": "blue"
        },
        "width": "0.20",
        "name": "normal"
      },
      {
        "x": [
          "Reference Data",
          "Production Data"
        ],
        "y": [
          5,
          5.259
        ],
        "type": "bar",
        "mode": "lines+markers",
        "marker": {
          "color": "red"
        },
        "width": "0.20",
        "name": "adversarial"
      }
    ],
    "layout": {
      "autosize": "false",
      "margin": {
        "l": 50,
        "r": 50,
        "b": 50,
        "t": 50,
        "pad": 0
      },
      "height": 350,
      "width": 875,
      "xaxis": {
        "title": "data"
      },
      "yaxis": {
        "title": "Percentage"
      },
      "showlegend": "true"
    },
    "timestamp": "2021-12-01 14:52:59.491438",
    "name": "AE",
    "des": "Adversarial detection indicates the percentage of data points which are adversarial in nature \n      when compared to all data points in reference and production data. We have deployed multiple best in \n      class techniques to identify and detect data points which are perturbated. We are representing \n      adversarial perturbation in reference and production data through a Paired Bar Plot.\n      "
  },
  "di": {
    "project_name": "froud_detection",
    "module_name": "credit_fraud",
    "header": "Data Integrity",
    "values": [
      {
        "x": [
          "Null_values",
          "Out_of_range_values"
        ],
        "y": [
          0,
          0.001
        ],
        "type": "bar",
        "mode": "lines+markers",
        "width": "0.25",
        "marker": {
          "color": "blue"
        },
        "barmode": "stack"
      }
    ],
    "layout": {
      "autosize": "false",
      "margin": {
        "l": 50,
        "r": 50,
        "b": 50,
        "t": 50,
        "pad": 0
      },
      "height": 350,
      "width": 875,
      "xaxis": {
        "title": "metrics"
      },
      "yaxis": {
        "title": "Percentage"
      },
      "showlegend": "true"
    },
    "features": [
      {
        "title": "age",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "28.4",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "28.4",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "educational-num",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "7.3",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "7.3",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "hours-per-week",
        "nan": "0.0",
        "oor": "13.68",
        "feature_imp": "14.2",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "14.2",
                "0.0",
                "13.68"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "workclass_?",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.2",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.2",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "workclass_Federal-gov",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.6",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.6",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "workclass_Local-gov",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.7",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.7",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "workclass_Never-worked",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.0",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.0",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "workclass_Private",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "1.2",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "1.2",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "workclass_Self-emp-inc",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.8",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.8",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "workclass_Self-emp-not-inc",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "1.0",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "1.0",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "workclass_State-gov",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.6",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.6",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "workclass_Without-pay",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.0",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.0",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "education_10th",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.2",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.2",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "education_11th",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.2",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.2",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "education_12th",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.1",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.1",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "education_1st-4th",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.0",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.0",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "education_5th-6th",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.1",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.1",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "education_7th-8th",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.3",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.3",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "education_9th",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.2",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.2",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "education_Assoc-acdm",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.3",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.3",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "education_Assoc-voc",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.3",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.3",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "education_Bachelors",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "1.2",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "1.2",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "education_Doctorate",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.3",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.3",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "education_HS-grad",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.9",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.9",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "education_Masters",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.9",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.9",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "education_Preschool",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.0",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.0",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "education_Prof-school",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.8",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.8",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "education_Some-college",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.6",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.6",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "marital-status_Divorced",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.9",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.9",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "marital-status_Married-AF-spouse",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.0",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.0",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "marital-status_Married-civ-spouse",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "6.9",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "6.9",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "marital-status_Married-spouse-absent",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.1",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.1",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "marital-status_Never-married",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "2.6",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "2.6",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "marital-status_Separated",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.2",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.2",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "marital-status_Widowed",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.2",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.2",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "occupation_?",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.2",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.2",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "occupation_Adm-clerical",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.7",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.7",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "occupation_Armed-Forces",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.0",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.0",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "occupation_Craft-repair",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.8",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.8",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "occupation_Exec-managerial",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "2.3",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "2.3",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "occupation_Farming-fishing",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.6",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.6",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "occupation_Handlers-cleaners",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.4",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.4",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "occupation_Machine-op-inspct",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.5",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.5",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "occupation_Other-service",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.9",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.9",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "occupation_Priv-house-serv",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.0",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.0",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "occupation_Prof-specialty",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "1.8",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "1.8",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "occupation_Protective-serv",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.4",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.4",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "occupation_Sales",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.8",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.8",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "occupation_Tech-support",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.6",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.6",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "occupation_Transport-moving",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.5",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.5",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "relationship_Husband",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "4.8",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "4.8",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "relationship_Not-in-family",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "1.4",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "1.4",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "relationship_Other-relative",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.2",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.2",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "relationship_Own-child",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "1.4",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "1.4",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "relationship_Unmarried",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.5",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.5",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "relationship_Wife",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "1.2",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "1.2",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "race_Amer-Indian-Eskimo",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.2",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.2",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "race_Asian-Pac-Islander",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.4",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.4",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "race_Black",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.6",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.6",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "race_Other",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.1",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.1",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "race_White",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.8",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.8",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "gender_Female",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "1.0",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "1.0",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "gender_Male",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "1.0",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "1.0",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_?",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.4",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.4",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Cambodia",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.0",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.0",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Canada",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.2",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.2",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_China",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.1",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.1",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Columbia",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.0",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.0",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Cuba",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.1",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.1",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Dominican-Republic",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.0",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.0",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Ecuador",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.0",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.0",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_El-Salvador",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.0",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.0",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_England",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.1",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.1",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_France",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.0",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.0",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Germany",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.1",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.1",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Greece",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.1",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.1",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Guatemala",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.0",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.0",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Haiti",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.0",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.0",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Holand-Netherlands",
        "nan": "0.0",
        "oor": "0.01",
        "feature_imp": "0.0",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.0",
                "0.0",
                "0.01"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Honduras",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.0",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.0",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Hong",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.0",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.0",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Hungary",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.0",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.0",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_India",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.1",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.1",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Iran",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.1",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.1",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Ireland",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.1",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.1",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Italy",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.1",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.1",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Jamaica",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.0",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.0",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Japan",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.1",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.1",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Laos",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.0",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.0",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Mexico",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.2",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.2",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Nicaragua",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.0",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.0",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Outlying-US(Guam-USVI-etc)",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.0",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.0",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Peru",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.0",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.0",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Philippines",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.1",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.1",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Poland",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.1",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.1",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Portugal",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.1",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.1",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Puerto-Rico",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.1",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.1",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Scotland",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.0",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.0",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_South",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.1",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.1",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Taiwan",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.0",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.0",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Thailand",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.0",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.0",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Trinadad&Tobago",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.0",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.0",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_United-States",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.8",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.8",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Vietnam",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.0",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.0",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      },
      {
        "title": "native-country_Yugoslavia",
        "nan": "0.0",
        "oor": "0.0",
        "feature_imp": "0.0",
        "layout": [
          {
            "autosize": false,
            "margin": {
              "l": 40,
              "r": 12,
              "b": 30,
              "t": 14,
              "pad": 0
            },
            "height": 286,
            "width": 455,
            "xaxis": {
              "automargin": "true",
              "title": ""
            },
            "yaxis": {
              "title": "Percentage"
            }
          }
        ],
        "data": [
          [
            {
              "x": [
                "Feature_importance",
                "NaN(Null)",
                "Out of range(OOR)"
              ],
              "y": [
                "0.0",
                "0.0",
                "0.0"
              ],
              "type": "bar",
              "marker": {
                "color": [
                  "skyblue",
                  "blue",
                  "blue"
                ]
              },
              "width": "0.25"
            }
          ]
        ]
      }
    ],
    "timestamp": "2021-12-01 14:53:00.557123",
    "name": "Data Integrity",
    "des": " Data integrity indicates the total percentage of NaN(null) and OOR(Out of range)\n\n        values in the production data as a bar plot. Apart from this, for every feature, we have provided\n\n        the graphs which indicate the feature importance, Nan(null) and OOR(Out of range) percenatge\n\n        of each feature."
  },
  "Monitoring": {
    "project_name": "froud_detection",
    "model_name": "credit_fraud",
    "header": "Monitoring Alert",
    "values": [
      {
        "x": [
          "od",
          "dd",
          "cd",
          "ae",
          "NaN",
          "Out_of_range"
        ],
        "y": [
          2,
          0,
          0.22,
          2,
          0,
          0.001
        ],
        "type": "bar",
        "name": "Normal",
        "mode": "lines+markers",
        "marker": {
          "color": "rgb(0, 204, 204)"
        },
        "width": "0.25"
      },
      {
        "x": [
          "od",
          "dd",
          "cd",
          "ae",
          "NaN",
          "Out_of_range"
        ],
        "y": [
          3,
          0,
          0,
          3,
          0,
          0
        ],
        "type": "bar",
        "name": "Medium",
        "mode": "lines+markers",
        "marker": {
          "color": "yellow"
        },
        "width": "0.25"
      },
      {
        "x": [
          "od",
          "dd",
          "cd",
          "ae",
          "NaN",
          "Out_of_range"
        ],
        "y": [
          0.15000000000000036,
          0,
          0,
          0.2599999999999998,
          0,
          0
        ],
        "type": "bar",
        "name": "High",
        "mode": "lines+markers",
        "marker": {
          "color": "red"
        },
        "width": "0.25"
      }
    ],
    "values2": [
      {
        "values": [
          4,
          0,
          2
        ],
        "labels": [
          "Normal_alert",
          "Medium_alert",
          "High_alert"
        ],
        "type": "pie",
        "marker": {
          "colors": [
            "rgb(0, 204, 204)",
            "yellow",
            "red"
          ]
        }
      }
    ],
    "layout": {
      "barmode": "stack",
      "autosize": "false",
      "margin": {
        "l": 50,
        "r": 50,
        "b": 50,
        "t": 50,
        "pad": 0
      },
      "height": 350,
      "width": 875,
      "xaxis": {
        "title": "metrics"
      },
      "yaxis": {
        "title": "Percentage"
      },
      "showlegend": "true",
      "shapes": [
        {
          "type": "line",
          "xref": "paper",
          "x0": 0,
          "y0": 5,
          "x1": 1,
          "y1": 5,
          "line": {
            "color": "rgb(255, 0, 0)",
            "width": 2,
            "dash": "dot"
          }
        },
        {
          "type": "line",
          "xref": "paper",
          "x0": 0,
          "y0": 2,
          "x1": 1,
          "y1": 2,
          "line": {
            "color": "rgb(0, 204, 204)",
            "width": 2,
            "dash": "dot"
          }
        }
      ]
    },
    "layout2": {
      "autosize": "false",
      "margin": {
        "l": 50,
        "r": 50,
        "b": 50,
        "t": 50,
        "pad": 0
      },
      "height": 350,
      "width": 875,
      "xaxis": {
        "title": ""
      },
      "yaxis": {
        "title": ""
      },
      "showlegend": "true"
    },
    "features": [
      {
        "title": "od_alert",
        "data": [
          "Percentage of outlier sample detected in production data is High"
        ]
      },
      {
        "title": "dd_alert",
        "data": [
          "Percentage of feature drifted in production data is Normal"
        ]
      },
     
      {
        "title": "di_alert",
        "data": [
          "Percentage of NaN value detected in production data is Normal",
          "Percentage of OOR(Out of Range) value detected in production data is Normal"
        ]
      },
      {
        "title": "Logs",
        "data": [
          "***** Adverserial_Detection ***** : ",
          "Critical/Error logs Not found in Adverserial_Detection log file",
          "***** Concept_Drift ***** : ",
          "2021-12-01 14:41:16,266 — Concept_Drift — CRITICAL — CD training failed",
          "***** Drift_Detection ***** : ",
          "Critical/Error logs Not found in Drift_Detection log file",
          "***** Outlier_Detection ***** : ",
          "Critical/Error logs Not found in Outlier_Detection log file",
          "***** froud_detection_credit_fraud ***** : ",
          "Critical/Error logs Not found in froud_detection_credit_fraud log file",
          "***** response ***** : ",
          "Critical/Error logs Not found in response log file"
        ]
      }
    ],
    "timestamp": "2021-12-01 14:50:32.701985",
    "name": "Monitoring Alert",
    "des": " Monitoring alerts indicate the percentage of outliers, drifted features, \n\n      adversarial samples, NaN(null) values and OOR(out of range) values in the production \n\n      data that go beyond the predetermined threshold value and is highlighted through a \n\n      different color. If the metric percentage is less than 2% then it is considered as a \n\n      normal alert (blue), if it is between 2% to 5% then it will appear as medium alert (yellow) \n\n      and if the metric percentage is beyond 5% then it will appear as a high alert (red). \n\n      The pie chart indicates the total number of normal, medium and high alerts. All the dropdown \n\n      buttons contain the information of the particular module such as alerts from the outlier \n\n      detection module, the drift detection module and more. Finally, the logs button contains \n\n      critical/Error log information if any."
  },
  "bias_alert": {
    "header": "Bias Alert",
    "values": [
      {
        "x": [
          "false_negative_rate_ratio",
          "false_ommision_rate_ratio",
          "sensitivity",
          "false_discovery_rate"
        ],
        "y": [
          8.956371354087289e-8,
          0.000017182778292181736,
          1.241283226986617e-8,
          0.000005162895667882635
        ],
        "type": "bar",
        "marker": {
          "color": "red"
        },
        "width": "0.25",
        "barmode": "stack"
      }
    ],
    "values2": [
      {
        "values": [
          8,
          12,
          4
        ],
        "labels": [
          "Normal",
          "Medium",
          "High"
        ],
        "type": "pie",
        "marker": {
          "colors": [
            "rgb(0, 204, 204)",
            "yellow",
            "red"
          ]
        }
      }
    ],
    "layout": {
      "autosize": "false",
      "margin": {
        "l": 50,
        "r": 50,
        "b": 50,
        "t": 50,
        "pad": 0
      },
      "height": 350,
      "width": 875,
      "xaxis": {
        "title": "metrics"
      },
      "yaxis": {
        "title": "Percentage of change"
      },
      "showlegend": "true"
    },
    "layout2": {
      "autosize": "false",
      "margin": {
        "l": 50,
        "r": 50,
        "b": 50,
        "t": 50,
        "pad": 0
      },
      "height": 350,
      "width": 875,
      "xaxis": {
        "title": ""
      },
      "yaxis": {
        "title": ""
      },
      "showlegend": "true"
    },
    "features": [
      {
        "title": "Alert_Messages",
        "data": [
          "false_negative_rate_ratio : metric value has been changed : 8.956371354087289e-08%",
          "false_ommision_rate_ratio : metric value has been changed : 1.7182778292181736e-05%",
          "sensitivity : metric value has been changed : 1.241283226986617e-08%",
          "false_discovery_rate : metric value has been changed : 5.162895667882635e-06%",
          "false_discovery_rate: metric has medium risk in production",
          "false_ommision_rate: metric has HIGH risk in production"
        ]
      }
    ],
    "name": "Bias alert",
    "des": " The bias alert bar chart only display metrics that have changed in production. \n\n        The y-axis indicates the percentage of change that occurred in these metrics. The pie chart \n\n        indicates the number of Normal, Medium and high alerts. The alert message button contains the \n\n        information of the changed metrics along with their percentage value."
  }
}

const datasetForChaild ={
  "project_name": "insurance_claim",
  "module_name": "insurance",
  "od": {
      "project_name": "insurance_claim",
      "module_name": "insurance",
      "header": "Outlier Detection",
      "values": [
          {
              "x": [
                  "-23.05",
                  "32.258",
                  "64.486",
                  "-5.415",
                  "-70.402",
                  "13.803",
                  "21.297",
                  "-64.829",
                  "61.184",
                  "-8.021",
                  "73.095",
                  "-79.755",
                  "-51.473",
                  "21.349",
                  "4.009",
                  "35.128",
                  "-82.479",
                  "-3.789",
                  "68.131",
                  "20.255",
                  "-1.98",
                  "38.391",
                  "-15.581",
                  "46.591",
                  "-50.814",
                  "-79.813",
                  "29.788",
                  "12.114",
                  "-50.58",
                  "-44.326",
                  "70.962",
                  "-42.154",
                  "-10.232",
                  "-35.557",
                  "44.901",
                  "32.251",
                  "93.956",
                  "14.826",
                  "-62.806",
                  "28.015",
                  "0.826",
                  "63.327",
                  "73.69",
                  "-58.966",
                  "14.113",
                  "2.548",
                  "30.041",
                  "-77.711",
                  "30.905",
                  "-61.504",
                  "90.357",
                  "-69.069",
                  "54.459",
                  "-38.08",
                  "24.449",
                  "-39.302",
                  "-76.284",
                  "46.028",
                  "-75.448",
                  "16.464",
                  "47.406",
                  "-80.045",
                  "-27.685",
                  "24.726",
                  "-4.578",
                  "-57.795",
                  "-11.393",
                  "-45.828",
                  "-12.895",
                  "-12.159",
                  "28.702",
                  "9.036",
                  "29.43",
                  "-35.332",
                  "57.991",
                  "13.139",
                  "13.92",
                  "61.328",
                  "-42.099",
                  "85.257",
                  "12.566",
                  "11.496",
                  "-2.994",
                  "22.816",
                  "-12.088",
                  "-77.0",
                  "8.169",
                  "-60.176",
                  "50.577",
                  "47.51",
                  "-10.439",
                  "-31.548",
                  "-22.97",
                  "-3.415",
                  "62.882",
                  "57.919",
                  "-79.082",
                  "4.336",
                  "11.064",
                  "-1.271",
                  "88.942",
                  "18.205",
                  "31.232",
                  "-16.759",
                  "58.186",
                  "-11.808",
                  "-7.508",
                  "-12.255",
                  "7.553",
                  "-32.437",
                  "-82.36",
                  "12.878",
                  "-20.926",
                  "-79.952",
                  "-72.298",
                  "21.354",
                  "34.179",
                  "28.396",
                  "-14.253",
                  "-89.198",
                  "-14.158",
                  "-76.139",
                  "-11.31",
                  "11.876",
                  "9.018",
                  "-35.138",
                  "-71.483",
                  "44.424",
                  "-49.743",
                  "-57.767",
                  "31.461",
                  "6.844",
                  "-66.626",
                  "54.918",
                  "-64.684",
                  "21.537",
                  "-40.567",
                  "-0.133",
                  "-82.581",
                  "83.11",
                  "-64.937",
                  "-78.173",
                  "-48.609",
                  "68.08",
                  "56.663",
                  "64.618",
                  "30.528",
                  "-21.986",
                  "12.581",
                  "52.393",
                  "30.837",
                  "-19.681",
                  "-66.15",
                  "50.067",
                  "45.008",
                  "3.045",
                  "26.116",
                  "-1.332",
                  "-34.303",
                  "52.913",
                  "6.593",
                  "89.661",
                  "67.989",
                  "-28.178",
                  "27.559",
                  "66.688",
                  "-69.221",
                  "53.399",
                  "51.044",
                  "48.982",
                  "15.953",
                  "35.359",
                  "-3.997",
                  "90.672",
                  "42.532",
                  "2.43",
                  "79.456",
                  "-11.613",
                  "-36.747",
                  "-18.198",
                  "-47.175",
                  "-10.793",
                  "-41.703",
                  "-4.131",
                  "-39.84",
                  "-4.688",
                  "62.881",
                  "-27.673",
                  "64.765",
                  "-0.821",
                  "-11.477",
                  "-82.644",
                  "-75.78",
                  "-5.046",
                  "48.15",
                  "-34.544",
                  "26.907",
                  "48.164",
                  "-36.346",
                  "56.707",
                  "52.97",
                  "2.941",
                  "30.974",
                  "-30.324",
                  "-84.839",
                  "-4.446",
                  "-42.481",
                  "28.575",
                  "-25.542",
                  "68.129",
                  "-51.577",
                  "24.037",
                  "69.28",
                  "-38.697",
                  "-18.776",
                  "12.644",
                  "-81.788",
                  "68.866",
                  "-11.715",
                  "94.505",
                  "18.091",
                  "-19.082",
                  "-19.549",
                  "20.438",
                  "46.56",
                  "66.064",
                  "4.082",
                  "-20.808",
                  "-48.891",
                  "-78.744",
                  "1.675",
                  "17.087",
                  "-12.394",
                  "52.543",
                  "26.894",
                  "-34.056",
                  "-41.624",
                  "-39.391",
                  "-24.587",
                  "-13.825",
                  "17.989",
                  "14.71",
                  "-71.777",
                  "-40.197",
                  "32.608",
                  "-76.495",
                  "-83.217",
                  "21.91",
                  "0.205",
                  "67.541",
                  "-41.799",
                  "-33.938",
                  "-11.45",
                  "-30.597",
                  "62.631",
                  "-27.571",
                  "-62.471",
                  "-28.292",
                  "-29.886",
                  "-23.375",
                  "11.96",
                  "-17.996",
                  "62.166",
                  "-14.472",
                  "-86.775",
                  "-22.131",
                  "-32.978",
                  "-64.645",
                  "18.466",
                  "30.46",
                  "31.969",
                  "-0.794",
                  "-20.943",
                  "-24.332",
                  "2.804",
                  "-79.739",
                  "9.013",
                  "-7.351",
                  "-74.843",
                  "50.483",
                  "-33.046",
                  "-22.096",
                  "27.906",
                  "23.436",
                  "53.114",
                  "-28.152",
                  "32.989",
                  "-10.084",
                  "33.61",
                  "15.935",
                  "-32.325",
                  "66.779",
                  "30.562",
                  "-32.866",
                  "-32.796",
                  "71.142",
                  "-54.382",
                  "-37.39",
                  "-50.383",
                  "81.799",
                  "21.045",
                  "67.383",
                  "59.516",
                  "-62.24",
                  "79.6",
                  "-54.82",
                  "74.664",
                  "-32.087",
                  "-33.941",
                  "-76.34",
                  "54.794",
                  "-71.609",
                  "-22.491",
                  "-61.691",
                  "69.673",
                  "35.661",
                  "46.454",
                  "75.738",
                  "39.82",
                  "-89.931",
                  "3.677",
                  "21.845",
                  "22.874",
                  "10.61",
                  "50.616",
                  "32.5",
                  "-28.346",
                  "-63.8",
                  "41.4",
                  "-54.421",
                  "17.325",
                  "-25.341",
                  "-82.249",
                  "-82.383",
                  "49.34",
                  "-64.599",
                  "3.257",
                  "16.072",
                  "-12.993",
                  "-3.164",
                  "55.126",
                  "12.019",
                  "74.611",
                  "6.838",
                  "72.007",
                  "-48.226",
                  "-0.895",
                  "-14.926",
                  "66.012",
                  "62.83",
                  "-33.947",
                  "48.182",
                  "21.899",
                  "-0.344",
                  "-27.176",
                  "69.729",
                  "-18.468",
                  "-31.957",
                  "-53.43",
                  "27.062",
                  "-41.531",
                  "33.819",
                  "-16.025",
                  "-41.283",
                  "1.759",
                  "-24.166",
                  "33.989",
                  "64.679",
                  "-41.421",
                  "42.238",
                  "12.608",
                  "-31.246",
                  "-80.058",
                  "-63.955",
                  "1.296",
                  "19.327",
                  "63.733",
                  "-80.008",
                  "-88.198",
                  "-24.587",
                  "-6.191",
                  "-8.14",
                  "20.673",
                  "33.27",
                  "-30.148",
                  "-15.05",
                  "43.426",
                  "-8.107",
                  "34.817",
                  "-4.61",
                  "32.431",
                  "-58.113",
                  "8.714",
                  "60.943",
                  "-46.442",
                  "-57.518",
                  "-40.421",
                  "-76.372",
                  "-27.19",
                  "-19.107",
                  "-1.678",
                  "-13.525",
                  "-19.711",
                  "5.27",
                  "5.675",
                  "-4.966",
                  "44.975",
                  "39.468",
                  "59.609",
                  "80.718",
                  "-32.576",
                  "69.74",
                  "67.512",
                  "19.981",
                  "-7.341",
                  "4.107",
                  "86.621",
                  "20.259",
                  "16.523",
                  "17.882",
                  "10.039",
                  "-65.593",
                  "-40.656",
                  "-78.683",
                  "53.888",
                  "11.082",
                  "30.025",
                  "65.971",
                  "85.782",
                  "-2.831",
                  "16.623",
                  "-1.614",
                  "-3.964",
                  "87.096",
                  "-12.909",
                  "41.638",
                  "55.939",
                  "-0.381",
                  "24.402",
                  "-30.315",
                  "14.398",
                  "-63.736",
                  "-62.568",
                  "25.678",
                  "-71.479",
                  "53.642",
                  "61.561",
                  "21.358",
                  "-22.21",
                  "61.923",
                  "-33.707",
                  "36.138",
                  "-64.102",
                  "-47.324",
                  "-27.744",
                  "-65.66",
                  "85.212",
                  "69.069",
                  "24.896",
                  "11.75",
                  "-50.846",
                  "-33.621",
                  "-23.855",
                  "-55.548",
                  "-42.782",
                  "4.327",
                  "-89.285",
                  "56.444",
                  "19.093",
                  "-77.701",
                  "42.67",
                  "31.615",
                  "-54.771",
                  "-32.346",
                  "52.824",
                  "-25.163",
                  "-64.511",
                  "31.376",
                  "-66.957",
                  "-88.698",
                  "37.558",
                  "-73.874",
                  "23.549",
                  "93.964",
                  "-2.654",
                  "-60.152",
                  "75.968",
                  "46.796",
                  "-40.498",
                  "24.552",
                  "67.025",
                  "-33.606",
                  "7.822",
                  "52.74",
                  "-46.166",
                  "-25.745",
                  "10.219",
                  "-51.182",
                  "-18.986",
                  "67.645",
                  "39.092",
                  "-25.796",
                  "-51.103",
                  "-63.759",
                  "13.433",
                  "-1.932",
                  "-19.432",
                  "42.673",
                  "-60.844",
                  "83.621",
                  "-52.324",
                  "-10.498"
              ],
              "y": [
                  "50.469",
                  "40.268",
                  "11.251",
                  "-78.569",
                  "-37.428",
                  "6.902",
                  "-67.803",
                  "-62.705",
                  "-34.901",
                  "0.108",
                  "-33.67",
                  "24.087",
                  "24.963",
                  "46.967",
                  "-30.638",
                  "-57.062",
                  "-31.457",
                  "-20.725",
                  "-6.946",
                  "-67.241",
                  "12.663",
                  "-77.086",
                  "31.073",
                  "-7.081",
                  "26.689",
                  "-35.679",
                  "11.313",
                  "63.352",
                  "-29.672",
                  "37.11",
                  "-7.868",
                  "43.008",
                  "78.241",
                  "-5.639",
                  "11.034",
                  "36.874",
                  "6.069",
                  "32.218",
                  "-69.213",
                  "-2.336",
                  "-57.407",
                  "25.132",
                  "17.819",
                  "-63.808",
                  "65.433",
                  "-15.423",
                  "-47.702",
                  "25.938",
                  "-59.652",
                  "-60.887",
                  "34.2",
                  "24.999",
                  "10.881",
                  "-50.012",
                  "-68.584",
                  "-77.734",
                  "-19.909",
                  "50.859",
                  "13.49",
                  "2.144",
                  "-45.336",
                  "-35.66",
                  "78.847",
                  "-28.421",
                  "86.163",
                  "9.967",
                  "89.259",
                  "61.848",
                  "-14.468",
                  "-84.664",
                  "-0.63",
                  "-102.008",
                  "53.94",
                  "-20.206",
                  "-20.962",
                  "80.957",
                  "3.937",
                  "28.957",
                  "20.52",
                  "-0.421",
                  "81.654",
                  "-89.683",
                  "10.379",
                  "-95.852",
                  "-81.584",
                  "-16.777",
                  "66.798",
                  "5.233",
                  "58.944",
                  "-45.703",
                  "80.704",
                  "80.051",
                  "19.726",
                  "85.466",
                  "1.544",
                  "-21.953",
                  "12.984",
                  "-91.927",
                  "2.928",
                  "-76.053",
                  "30.764",
                  "-15.684",
                  "-59.473",
                  "70.867",
                  "-22.516",
                  "14.459",
                  "-0.378",
                  "49.381",
                  "-101.592",
                  "-38.607",
                  "4.674",
                  "-40.697",
                  "84.84",
                  "-29.796",
                  "13.492",
                  "73.688",
                  "-38.267",
                  "-34.984",
                  "13.863",
                  "-7.727",
                  "71.355",
                  "-29.002",
                  "15.919",
                  "71.8",
                  "46.254",
                  "14.903",
                  "42.009",
                  "22.528",
                  "41.039",
                  "-6.814",
                  "10.284",
                  "91.162",
                  "-64.804",
                  "-19.699",
                  "-40.287",
                  "-67.71",
                  "28.327",
                  "-4.999",
                  "-12.473",
                  "33.668",
                  "-64.07",
                  "30.12",
                  "39.259",
                  "-56.659",
                  "19.41",
                  "24.937",
                  "34.969",
                  "19.408",
                  "-44.932",
                  "57.645",
                  "35.253",
                  "7.599",
                  "-64.524",
                  "54.115",
                  "80.113",
                  "-4.149",
                  "55.772",
                  "23.827",
                  "63.482",
                  "-20.126",
                  "11.899",
                  "0.632",
                  "-5.471",
                  "47.57",
                  "-68.488",
                  "26.194",
                  "-15.826",
                  "-21.798",
                  "58.733",
                  "75.995",
                  "-25.806",
                  "-56.298",
                  "-74.763",
                  "-3.156",
                  "1.636",
                  "-15.045",
                  "0.601",
                  "14.819",
                  "-17.228",
                  "83.939",
                  "41.738",
                  "81.271",
                  "15.28",
                  "40.64",
                  "20.136",
                  "55.66",
                  "25.673",
                  "79.237",
                  "24.843",
                  "86.636",
                  "71.595",
                  "-31.182",
                  "43.605",
                  "85.087",
                  "76.92",
                  "-3.081",
                  "54.175",
                  "47.927",
                  "12.194",
                  "19.533",
                  "-67.273",
                  "45.471",
                  "33.016",
                  "13.803",
                  "21.824",
                  "-31.948",
                  "38.847",
                  "54.009",
                  "48.918",
                  "17.86",
                  "-31.062",
                  "-96.899",
                  "-8.553",
                  "-57.393",
                  "27.859",
                  "-43.377",
                  "7.837",
                  "-42.698",
                  "33.996",
                  "0.046",
                  "-14.37",
                  "27.362",
                  "-69.033",
                  "-31.493",
                  "75.125",
                  "-32.534",
                  "-31.209",
                  "30.88",
                  "65.419",
                  "4.186",
                  "-52.11",
                  "-25.231",
                  "31.148",
                  "61.304",
                  "-31.946",
                  "64.505",
                  "-72.179",
                  "-77.388",
                  "-5.616",
                  "-41.73",
                  "72.523",
                  "96.435",
                  "47.057",
                  "-52.755",
                  "40.76",
                  "41.572",
                  "-33.894",
                  "-6.351",
                  "-53.529",
                  "-25.024",
                  "12.021",
                  "-0.114",
                  "-17.485",
                  "-4.459",
                  "55.32",
                  "-35.467",
                  "-63.264",
                  "25.678",
                  "-3.621",
                  "85.693",
                  "-46.522",
                  "61.398",
                  "19.767",
                  "53.351",
                  "-15.633",
                  "90.993",
                  "-53.313",
                  "16.684",
                  "47.335",
                  "10.133",
                  "13.555",
                  "0.907",
                  "-68.923",
                  "2.41",
                  "8.059",
                  "5.09",
                  "-52.415",
                  "-74.096",
                  "-37.161",
                  "73.868",
                  "-23.809",
                  "29.174",
                  "-2.51",
                  "18.358",
                  "60.725",
                  "24.093",
                  "-38.886",
                  "-7.68",
                  "-13.459",
                  "15.691",
                  "77.282",
                  "-57.479",
                  "-45.225",
                  "74.657",
                  "18.248",
                  "-26.257",
                  "-28.809",
                  "36.583",
                  "-25.753",
                  "-4.41",
                  "49.984",
                  "-46.957",
                  "-32.738",
                  "-69.45",
                  "40.234",
                  "-10.609",
                  "15.809",
                  "32.9",
                  "-9.125",
                  "24.068",
                  "-22.5",
                  "43.615",
                  "84.834",
                  "-70.329",
                  "20.446",
                  "-34.869",
                  "-47.489",
                  "22.622",
                  "-22.26",
                  "-6.163",
                  "-26.648",
                  "49.231",
                  "-95.61",
                  "-49.807",
                  "-37.274",
                  "-35.161",
                  "86.329",
                  "-34.688",
                  "24.391",
                  "-28.76",
                  "17.649",
                  "-6.364",
                  "-8.075",
                  "22.752",
                  "-38.827",
                  "-65.253",
                  "45.207",
                  "95.595",
                  "70.543",
                  "86.732",
                  "-4.136",
                  "-90.33",
                  "-34.629",
                  "-62.178",
                  "20.622",
                  "-31.847",
                  "-30.511",
                  "86.713",
                  "21.031",
                  "20.181",
                  "-9.156",
                  "48.888",
                  "-66.366",
                  "-55.589",
                  "23.996",
                  "27.261",
                  "-42.979",
                  "78.732",
                  "-28.887",
                  "52.937",
                  "39.45",
                  "-33.801",
                  "88.598",
                  "12.776",
                  "-0.345",
                  "35.11",
                  "-10.49",
                  "9.667",
                  "-53.949",
                  "62.364",
                  "3.588",
                  "-6.326",
                  "-8.574",
                  "-37.05",
                  "-3.787",
                  "72.361",
                  "3.118",
                  "24.083",
                  "-12.332",
                  "20.135",
                  "-101.62",
                  "-102.14",
                  "70.715",
                  "-11.31",
                  "13.817",
                  "71.463",
                  "-0.806",
                  "-102.096",
                  "-55.771",
                  "63.999",
                  "-35.635",
                  "9.703",
                  "28.004",
                  "-35.427",
                  "65.99",
                  "9.991",
                  "-74.359",
                  "-20.229",
                  "47.991",
                  "-70.2",
                  "14.517",
                  "75.93",
                  "88.207",
                  "11.174",
                  "9.589",
                  "39.591",
                  "-2.585",
                  "-84.098",
                  "-32.107",
                  "35.767",
                  "76.601",
                  "-48.978",
                  "18.141",
                  "73.012",
                  "-74.292",
                  "-65.767",
                  "-2.843",
                  "-9.654",
                  "2.495",
                  "-32.977",
                  "-50.611",
                  "-19.34",
                  "17.34",
                  "-23.751",
                  "54.359",
                  "47.375",
                  "-47.39",
                  "-61.206",
                  "34.788",
                  "-33.182",
                  "15.032",
                  "-77.136",
                  "-35.279",
                  "-2.333",
                  "34.334",
                  "24.329",
                  "54.724",
                  "-56.368",
                  "-28.169",
                  "-29.922",
                  "60.991",
                  "-39.133",
                  "-61.403",
                  "34.237",
                  "27.09",
                  "58.835",
                  "-34.931",
                  "-65.197",
                  "-17.225",
                  "-32.11",
                  "-50.835",
                  "11.834",
                  "-67.238",
                  "22.517",
                  "74.736",
                  "-23.036",
                  "1.786",
                  "-47.542",
                  "-70.028",
                  "71.654",
                  "26.884",
                  "21.124",
                  "-4.286",
                  "-4.081",
                  "37.401",
                  "87.573",
                  "-7.691",
                  "-67.746",
                  "-12.373",
                  "26.841",
                  "12.102",
                  "9.879",
                  "-7.665",
                  "-1.967",
                  "-67.176",
                  "-32.863",
                  "-33.599",
                  "-34.611",
                  "25.58",
                  "-5.919",
                  "-20.749",
                  "15.724",
                  "-60.992",
                  "-0.748",
                  "-74.954",
                  "3.43",
                  "8.901",
                  "52.617",
                  "28.24",
                  "-62.01",
                  "-61.106",
                  "79.111",
                  "93.206",
                  "-36.599",
                  "37.722",
                  "47.678",
                  "62.016",
                  "-66.257",
                  "27.326",
                  "17.931",
                  "-84.735",
                  "-63.769",
                  "-32.358",
                  "-38.819",
                  "5.009",
                  "-55.519",
                  "17.503",
                  "11.662",
                  "-68.264",
                  "7.332",
                  "-21.697",
                  "86.91"
              ],
              "type": "scatter",
              "mode": "markers",
              "marker": {
                  "color": "blue"
              },
              "name": "Normal"
          },
          {
              "x": [
                  "-48.93",
                  "25.225",
                  "2.642",
                  "-6.208",
                  "29.858",
                  "27.317",
                  "-31.62",
                  "45.714",
                  "86.268",
                  "9.016",
                  "-26.186",
                  "-6.305",
                  "5.437",
                  "9.582",
                  "85.838",
                  "39.247",
                  "25.799",
                  "-23.062",
                  "6.732",
                  "11.511",
                  "-37.229",
                  "5.58",
                  "4.654",
                  "24.522",
                  "26.956",
                  "8.273",
                  "42.372",
                  "34.089",
                  "-5.196",
                  "-49.006",
                  "24.593",
                  "16.839",
                  "45.707",
                  "29.609",
                  "-28.269",
                  "29.851",
                  "29.474",
                  "-41.498",
                  "40.539",
                  "85.873",
                  "84.034",
                  "-41.635",
                  "84.41",
                  "-48.794",
                  "5.776",
                  "-5.99",
                  "-50.677",
                  "79.76",
                  "24.577",
                  "51.904",
                  "3.836",
                  "-19.944",
                  "74.638",
                  "29.209",
                  "7.156",
                  "63.242",
                  "25.04",
                  "-29.415",
                  "32.811",
                  "-20.502",
                  "-28.235",
                  "11.682",
                  "-58.643",
                  "-30.24",
                  "9.771",
                  "80.077",
                  "18.166",
                  "5.884",
                  "25.904",
                  "10.435",
                  "51.282",
                  "45.728",
                  "9.004",
                  "-58.417",
                  "82.403",
                  "-36.021",
                  "34.617",
                  "75.741",
                  "84.905",
                  "-5.724",
                  "12.124",
                  "72.579",
                  "33.035",
                  "39.47",
                  "-49.034",
                  "-53.133",
                  "-72.399",
                  "30.898",
                  "-29.047",
                  "-9.911",
                  "42.592",
                  "-6.283",
                  "35.054",
                  "-72.349",
                  "12.021",
                  "45.736",
                  "16.945",
                  "-42.192",
                  "-20.031",
                  "13.173",
                  "-35.255",
                  "-18.589",
                  "-20.065",
                  "3.216",
                  "5.351",
                  "32.377",
                  "25.91",
                  "39.152",
                  "-9.507",
                  "-9.46",
                  "-5.04",
                  "86.017",
                  "-13.586",
                  "40.52",
                  "4.747",
                  "40.901",
                  "78.825",
                  "34.636",
                  "22.24",
                  "-40.416",
                  "26.969",
                  "-10.393",
                  "84.718",
                  "4.196",
                  "13.927",
                  "79.159",
                  "-34.708",
                  "14.772",
                  "-20.125",
                  "12.429",
                  "-20.402",
                  "63.095",
                  "-4.49",
                  "-32.086",
                  "-40.346",
                  "-5.173",
                  "-5.206",
                  "10.228",
                  "-4.735",
                  "39.045",
                  "88.176",
                  "-13.126",
                  "-6.269",
                  "-11.714",
                  "79.9",
                  "85.324",
                  "38.763",
                  "83.813",
                  "34.04",
                  "-16.093",
                  "96.958",
                  "-32.057",
                  "12.991",
                  "-20.645",
                  "-58.765",
                  "6.31",
                  "-13.062",
                  "-1.196",
                  "90.716",
                  "25.354",
                  "84.793",
                  "-3.794",
                  "-2.728",
                  "-40.031",
                  "63.023",
                  "40.052",
                  "24.713",
                  "22.044",
                  "63.143",
                  "24.533",
                  "34.292",
                  "4.44",
                  "-13.191",
                  "8.998",
                  "-3.225",
                  "79.529",
                  "85.895",
                  "70.138",
                  "26.927",
                  "-29.778",
                  "63.051",
                  "26.643",
                  "-57.272",
                  "79.58",
                  "-20.345",
                  "-35.887",
                  "38.492",
                  "36.469",
                  "35.193",
                  "43.0",
                  "35.715",
                  "62.618",
                  "88.799",
                  "-13.104",
                  "15.347",
                  "-58.68",
                  "4.542",
                  "2.762",
                  "-7.189",
                  "4.177",
                  "-5.974",
                  "-35.32",
                  "13.007",
                  "52.576",
                  "52.408",
                  "41.036",
                  "34.874",
                  "-29.683",
                  "29.004",
                  "-20.05",
                  "4.307",
                  "-14.574",
                  "-37.05",
                  "38.831",
                  "26.174",
                  "63.369",
                  "40.49",
                  "-4.104",
                  "32.362",
                  "10.337",
                  "-50.706",
                  "8.998",
                  "35.211",
                  "10.305",
                  "79.835",
                  "9.764",
                  "-30.442",
                  "19.508",
                  "-33.008",
                  "-20.222",
                  "6.505",
                  "24.628",
                  "49.939",
                  "34.016",
                  "32.714",
                  "0.084",
                  "51.105",
                  "21.096",
                  "-72.407",
                  "-20.0",
                  "35.824",
                  "-39.281",
                  "23.562",
                  "-35.101",
                  "43.256",
                  "32.837",
                  "48.214",
                  "-23.049",
                  "40.007",
                  "28.702",
                  "8.267",
                  "55.77",
                  "-35.156",
                  "3.797",
                  "4.049",
                  "22.124",
                  "8.982",
                  "8.328",
                  "-35.646",
                  "36.393",
                  "11.818",
                  "-54.55",
                  "-14.687",
                  "39.854",
                  "-82.184",
                  "-34.734",
                  "80.096",
                  "-51.255",
                  "15.344",
                  "-6.192",
                  "-7.959",
                  "-2.223",
                  "38.847",
                  "36.248",
                  "0.254",
                  "77.908",
                  "25.927",
                  "-2.947",
                  "-20.116",
                  "26.161",
                  "4.246",
                  "33.588",
                  "-20.146",
                  "49.209",
                  "33.14",
                  "3.076",
                  "4.606",
                  "17.903",
                  "8.149",
                  "25.891",
                  "24.145",
                  "5.115",
                  "-29.347",
                  "34.359",
                  "-75.48",
                  "18.094",
                  "-6.33",
                  "39.41",
                  "83.748",
                  "25.946",
                  "-24.878",
                  "5.017",
                  "30.308",
                  "24.586",
                  "-58.757",
                  "73.615",
                  "-29.089",
                  "41.011",
                  "-6.212",
                  "10.231",
                  "6.886",
                  "0.993",
                  "72.475",
                  "-30.497",
                  "10.229",
                  "-59.626",
                  "33.838",
                  "-11.775",
                  "85.908",
                  "-36.668",
                  "-8.558",
                  "79.257",
                  "3.08",
                  "-29.032",
                  "-41.568",
                  "21.834",
                  "4.207",
                  "-53.866",
                  "-53.521",
                  "33.874",
                  "39.109",
                  "35.851",
                  "-12.867",
                  "23.237",
                  "10.895",
                  "-29.44",
                  "44.885",
                  "-16.299",
                  "-20.195",
                  "15.642",
                  "-14.977",
                  "39.062",
                  "9.694",
                  "26.643",
                  "25.921",
                  "9.229",
                  "62.837",
                  "52.446",
                  "29.151",
                  "-40.031",
                  "-20.659",
                  "35.151",
                  "35.932",
                  "46.662",
                  "4.618",
                  "-1.166",
                  "-72.615",
                  "9.641",
                  "-41.213",
                  "-35.66",
                  "-56.078",
                  "-34.996",
                  "34.63",
                  "9.175",
                  "90.416",
                  "35.782",
                  "9.062",
                  "1.002",
                  "22.723",
                  "35.491",
                  "59.905",
                  "22.257",
                  "-26.502",
                  "-29.046",
                  "24.274",
                  "43.518",
                  "34.841",
                  "9.109",
                  "84.423",
                  "-41.514",
                  "-14.489",
                  "32.569",
                  "-56.08",
                  "-2.12",
                  "7.461",
                  "34.899",
                  "86.74",
                  "-30.353",
                  "28.131",
                  "-5.215",
                  "40.99",
                  "38.328",
                  "9.352",
                  "-6.675",
                  "27.231",
                  "32.001",
                  "-20.044",
                  "25.19",
                  "-9.518",
                  "3.96",
                  "-36.691",
                  "80.347",
                  "10.176",
                  "79.809",
                  "6.756",
                  "-35.32",
                  "39.437",
                  "-38.235",
                  "66.238",
                  "30.084",
                  "-54.766",
                  "9.279",
                  "84.372",
                  "80.039",
                  "78.138",
                  "-11.606",
                  "30.254",
                  "42.908",
                  "39.127",
                  "24.262",
                  "88.233",
                  "33.38",
                  "7.119",
                  "13.014",
                  "-32.286",
                  "32.233",
                  "3.613",
                  "6.631",
                  "85.743",
                  "-20.477",
                  "-39.105",
                  "-36.834",
                  "-20.313",
                  "-6.321",
                  "40.561",
                  "12.201",
                  "12.348",
                  "-37.359",
                  "-35.353",
                  "38.606",
                  "33.994",
                  "-26.506",
                  "7.919",
                  "3.637",
                  "3.039",
                  "34.163",
                  "36.493",
                  "51.901",
                  "52.061",
                  "66.127",
                  "42.646",
                  "5.114",
                  "17.232",
                  "25.918",
                  "21.894",
                  "7.544",
                  "15.366",
                  "5.68",
                  "90.365",
                  "-15.83",
                  "-34.709",
                  "3.356",
                  "18.71",
                  "12.449",
                  "90.397",
                  "-7.768",
                  "21.845",
                  "-18.333",
                  "35.467",
                  "6.579",
                  "27.843",
                  "15.392",
                  "18.746",
                  "6.729",
                  "33.541",
                  "-49.701"
              ],
              "y": [
                  "25.912",
                  "-7.268",
                  "67.673",
                  "-101.59",
                  "-67.17",
                  "-5.98",
                  "-29.879",
                  "-8.249",
                  "30.252",
                  "-101.998",
                  "4.308",
                  "-101.443",
                  "7.954",
                  "-98.476",
                  "34.147",
                  "-1.685",
                  "-87.131",
                  "-18.018",
                  "-11.671",
                  "-40.933",
                  "-18.301",
                  "7.859",
                  "-15.421",
                  "-99.144",
                  "-87.437",
                  "33.545",
                  "13.413",
                  "-12.424",
                  "-101.673",
                  "25.878",
                  "-99.134",
                  "30.137",
                  "74.405",
                  "16.379",
                  "-8.798",
                  "50.749",
                  "-67.171",
                  "28.838",
                  "-83.728",
                  "34.051",
                  "31.191",
                  "-3.5",
                  "30.387",
                  "-66.487",
                  "7.883",
                  "-101.733",
                  "28.996",
                  "33.534",
                  "-99.157",
                  "78.291",
                  "-91.669",
                  "-31.825",
                  "15.935",
                  "16.875",
                  "-9.88",
                  "53.949",
                  "-64.607",
                  "86.512",
                  "-16.454",
                  "-19.916",
                  "87.188",
                  "-89.346",
                  "1.068",
                  "-37.217",
                  "6.28",
                  "15.968",
                  "-91.643",
                  "-9.741",
                  "-86.123",
                  "-97.109",
                  "-47.975",
                  "74.399",
                  "-101.967",
                  "0.863",
                  "11.498",
                  "-20.043",
                  "-86.027",
                  "9.499",
                  "32.333",
                  "-101.953",
                  "-46.443",
                  "-35.349",
                  "-16.346",
                  "-82.626",
                  "28.196",
                  "27.028",
                  "-37.714",
                  "14.578",
                  "-64.408",
                  "-37.618",
                  "78.272",
                  "-101.508",
                  "-85.991",
                  "-37.617",
                  "-90.383",
                  "-8.211",
                  "29.913",
                  "-2.253",
                  "-31.353",
                  "29.717",
                  "-17.205",
                  "16.279",
                  "-31.697",
                  "45.77",
                  "-15.559",
                  "-86.314",
                  "-86.102",
                  "11.015",
                  "-45.617",
                  "-12.77",
                  "-38.682",
                  "34.094",
                  "-19.066",
                  "-84.249",
                  "-14.921",
                  "65.47",
                  "17.658",
                  "-86.024",
                  "76.908",
                  "-75.872",
                  "-87.614",
                  "-46.98",
                  "28.985",
                  "9.099",
                  "-36.235",
                  "16.335",
                  "-25.148",
                  "17.609",
                  "-32.095",
                  "-89.645",
                  "-40.573",
                  "54.753",
                  "-13.699",
                  "-23.109",
                  "-58.328",
                  "-101.598",
                  "-101.639",
                  "-97.375",
                  "-38.384",
                  "-86.089",
                  "-4.801",
                  "-48.33",
                  "-12.735",
                  "-41.837",
                  "40.023",
                  "33.197",
                  "-19.465",
                  "31.043",
                  "-11.444",
                  "-85.396",
                  "4.216",
                  "-23.191",
                  "31.913",
                  "-30.861",
                  "1.18",
                  "-101.446",
                  "-48.325",
                  "88.998",
                  "32.761",
                  "12.847",
                  "28.901",
                  "39.543",
                  "-34.663",
                  "-73.795",
                  "54.069",
                  "-19.111",
                  "-90.292",
                  "-10.058",
                  "54.304",
                  "-90.696",
                  "-58.26",
                  "28.848",
                  "-48.191",
                  "-101.972",
                  "56.553",
                  "13.888",
                  "34.418",
                  "-44.336",
                  "-87.361",
                  "-36.265",
                  "54.669",
                  "-87.014",
                  "-12.441",
                  "16.012",
                  "-40.627",
                  "-16.531",
                  "11.651",
                  "-85.309",
                  "-86.01",
                  "23.379",
                  "-20.731",
                  "53.871",
                  "31.518",
                  "-20.103",
                  "-9.725",
                  "1.095",
                  "-14.693",
                  "-92.035",
                  "-38.559",
                  "-92.32",
                  "-101.748",
                  "-24.127",
                  "81.137",
                  "53.565",
                  "53.361",
                  "-86.296",
                  "-18.403",
                  "86.69",
                  "-0.232",
                  "-31.655",
                  "-92.56",
                  "-47.097",
                  "-17.27",
                  "-85.975",
                  "-87.489",
                  "-66.049",
                  "-84.551",
                  "25.222",
                  "-86.314",
                  "0.768",
                  "28.985",
                  "-101.987",
                  "-86.013",
                  "84.769",
                  "14.759",
                  "6.266",
                  "-36.437",
                  "-72.764",
                  "-23.761",
                  "-33.069",
                  "14.417",
                  "-85.947",
                  "-43.881",
                  "-11.44",
                  "-16.439",
                  "-8.161",
                  "76.534",
                  "16.195",
                  "-37.699",
                  "-31.626",
                  "-20.444",
                  "-78.211",
                  "-95.192",
                  "-30.956",
                  "24.286",
                  "-16.459",
                  "-36.873",
                  "-18.243",
                  "-19.534",
                  "-0.629",
                  "33.552",
                  "1.919",
                  "-18.451",
                  "-92.335",
                  "31.856",
                  "-98.632",
                  "-102.14",
                  "33.564",
                  "-20.435",
                  "-85.383",
                  "29.108",
                  "-2.407",
                  "-47.033",
                  "63.788",
                  "24.813",
                  "-24.026",
                  "34.094",
                  "25.19",
                  "-9.795",
                  "-101.552",
                  "-101.903",
                  "41.006",
                  "-85.907",
                  "-85.424",
                  "-33.944",
                  "16.84",
                  "-86.063",
                  "-19.959",
                  "-31.196",
                  "-86.573",
                  "27.635",
                  "-13.482",
                  "-31.828",
                  "-38.454",
                  "-86.212",
                  "43.741",
                  "-15.577",
                  "-9.691",
                  "-44.277",
                  "-97.583",
                  "19.706",
                  "-29.647",
                  "86.498",
                  "-56.553",
                  "-37.692",
                  "-91.635",
                  "-35.361",
                  "-82.478",
                  "30.994",
                  "-86.167",
                  "31.672",
                  "-15.255",
                  "-10.856",
                  "-99.132",
                  "1.176",
                  "4.078",
                  "-34.263",
                  "-86.255",
                  "-101.578",
                  "-97.371",
                  "-62.22",
                  "-28.655",
                  "-4.179",
                  "-36.689",
                  "-97.373",
                  "5.055",
                  "-57.965",
                  "-42.477",
                  "30.218",
                  "-35.626",
                  "-0.539",
                  "13.568",
                  "43.756",
                  "-34.271",
                  "28.837",
                  "-97.815",
                  "-92.016",
                  "-11.529",
                  "-8.582",
                  "-58.362",
                  "-86.052",
                  "-20.497",
                  "14.333",
                  "20.163",
                  "28.784",
                  "86.537",
                  "23.905",
                  "-14.011",
                  "-31.342",
                  "-91.655",
                  "-46.477",
                  "-85.366",
                  "-98.27",
                  "-87.307",
                  "-86.086",
                  "64.67",
                  "55.319",
                  "53.366",
                  "57.341",
                  "-73.825",
                  "-30.859",
                  "-57.913",
                  "-20.67",
                  "-47.529",
                  "-14.789",
                  "-31.365",
                  "-37.977",
                  "27.217",
                  "29.031",
                  "-20.421",
                  "10.046",
                  "-17.005",
                  "-86.026",
                  "-99.217",
                  "33.491",
                  "-20.532",
                  "-99.352",
                  "-33.076",
                  "-96.053",
                  "-86.086",
                  "-4.777",
                  "76.939",
                  "-34.253",
                  "-64.407",
                  "-85.927",
                  "23.723",
                  "-86.008",
                  "27.107",
                  "30.601",
                  "-1.673",
                  "-20.484",
                  "-10.81",
                  "10.057",
                  "-18.014",
                  "-102.591",
                  "-18.441",
                  "30.388",
                  "-30.605",
                  "-70.736",
                  "-101.651",
                  "-86.245",
                  "-77.011",
                  "-98.896",
                  "-101.511",
                  "11.579",
                  "-86.358",
                  "-31.303",
                  "-85.997",
                  "-44.988",
                  "-12.919",
                  "-35.61",
                  "15.952",
                  "5.991",
                  "15.912",
                  "-11.432",
                  "-16.844",
                  "-82.371",
                  "-78.513",
                  "-9.522",
                  "-41.66",
                  "-2.283",
                  "29.558",
                  "30.666",
                  "-5.67",
                  "-3.905",
                  "-13.494",
                  "-59.985",
                  "20.088",
                  "-83.384",
                  "-14.807",
                  "32.657",
                  "54.884",
                  "-9.961",
                  "-89.625",
                  "-38.12",
                  "-86.33",
                  "-31.233",
                  "42.847",
                  "34.286",
                  "-19.914",
                  "-78.342",
                  "-78.837",
                  "-20.121",
                  "-101.445",
                  "-83.923",
                  "-92.286",
                  "-89.625",
                  "-18.163",
                  "-20.191",
                  "-21.788",
                  "-11.441",
                  "85.579",
                  "-103.326",
                  "-4.941",
                  "67.896",
                  "-12.457",
                  "-85.127",
                  "78.276",
                  "74.815",
                  "-21.853",
                  "19.389",
                  "-29.58",
                  "3.486",
                  "-86.101",
                  "-97.976",
                  "-101.461",
                  "-9.767",
                  "15.79",
                  "34.18",
                  "33.429",
                  "-25.201",
                  "68.026",
                  "-8.726",
                  "-89.67",
                  "30.614",
                  "-0.235",
                  "-10.224",
                  "-42.971",
                  "-86.088",
                  "-101.917",
                  "-6.004",
                  "-9.807",
                  "-8.677",
                  "-11.662",
                  "-86.161",
                  "28.001"
              ],
              "type": "scatter",
              "mode": "markers",
              "marker": {
                  "color": "red"
              },
              "name": "Outlier"
          }
      ],
      "layout": {
          "autosize": false,
          "margin": {
              "l": 50,
              "r": 50,
              "b": 50,
              "t": 50,
              "pad": 0
          },
          "height": 350,
          "width": 875,
          "xaxis": {
              "title": "X_embedded_1(TSNE)"
          },
          "yaxis": {
              "title": "X_embedded_2(TSNE)"
          },
          "showlegend": true
      },
      "features": [
          {
              "title": "Gender",
              "train_oulier": "0.0",
              "test_oulier": "0.0",
              "feat_imp": "1.9",
              "layout": [
                  {
                      "autosize": "false",
                      "margin": {
                          "l": 25,
                          "r": 12,
                          "b": 16,
                          "t": 14,
                          "pad": 0
                      },
                      "height": 240,
                      "width": 460,
                      "xaxis": {
                          "title": "categories"
                      },
                      "yaxis": {
                          "title": "counts"
                      },
                      "showlegend": "false",
                      "barmode": "group"
                  }
              ],
              "data": [
                  [
                      {
                          "x": [
                              "0",
                              "1"
                          ],
                          "y": [
                              "21014",
                              "24719"
                          ],
                          "type": "bar",
                          "name": "reference",
                          "marker": {
                              "color": "blue"
                          },
                          "width": "0.25"
                      },
                      {
                          "x": [
                              "0",
                              "1"
                          ],
                          "y": [
                              "5293",
                              "6140"
                          ],
                          "type": "bar",
                          "name": "production",
                          "marker": {
                              "color": "red"
                          },
                          "width": "0.25"
                      }
                  ]
              ]
          },
          {
              "title": "Age",
              "train_oulier": "0.0",
              "test_oulier": "0.0",
              "feat_imp": "17.4",
              "layout": [
                  {
                      "autosize": false,
                      "margin": {
                          "l": 40,
                          "r": 12,
                          "b": 30,
                          "t": 14,
                          "pad": 0
                      },
                      "height": 286,
                      "width": 455,
                      "xaxis": {
                          "title": "bins"
                      },
                      "yaxis": {
                          "title": "pdf"
                      },
                      "showlegend": true
                  },
                  {
                      "autosize": false,
                      "margin": {
                          "l": 40,
                          "r": 12,
                          "b": 30,
                          "t": 14,
                          "pad": 0
                      },
                      "height": 286,
                      "width": 455,
                      "xaxis": {
                          "title": "data"
                      },
                      "yaxis": {
                          "title": "values"
                      },
                      "showlegend": true
                  }
              ],
              "data": [
                  [
                      {
                          "x": [
                              0.0,
                              0.02,
                              0.04,
                              0.06,
                              0.08,
                              0.1,
                              0.12,
                              0.14,
                              0.16,
                              0.18,
                              0.2,
                              0.22,
                              0.24,
                              0.26,
                              0.28,
                              0.3,
                              0.32,
                              0.34,
                              0.36,
                              0.38,
                              0.4,
                              0.42,
                              0.44,
                              0.46,
                              0.48,
                              0.5,
                              0.52,
                              0.54,
                              0.56,
                              0.58,
                              0.6,
                              0.62,
                              0.64,
                              0.66,
                              0.68,
                              0.7,
                              0.72,
                              0.74,
                              0.76,
                              0.78,
                              0.8,
                              0.82,
                              0.84,
                              0.86,
                              0.88,
                              0.9,
                              0.92,
                              0.94,
                              0.96,
                              0.98,
                              1.0
                          ],
                          "y": [
                              0.059,
                              0.055,
                              0.065,
                              0.126,
                              0.034,
                              0.028,
                              0.023,
                              0.035,
                              0.013,
                              0.012,
                              0.013,
                              0.025,
                              0.014,
                              0.014,
                              0.013,
                              0.037,
                              0.022,
                              0.021,
                              0.021,
                              0.044,
                              0.021,
                              0.02,
                              0.018,
                              0.034,
                              0.015,
                              0.014,
                              0.014,
                              0.025,
                              0.011,
                              0.01,
                              0.02,
                              0.009,
                              0.009,
                              0.008,
                              0.015,
                              0.008,
                              0.007,
                              0.007,
                              0.013,
                              0.007,
                              0.005,
                              0.006,
                              0.009,
                              0.005,
                              0.004,
                              0.004,
                              0.005,
                              0.002,
                              0.0,
                              0.0
                          ],
                          "type": "lines",
                          "name": "reference",
                          "fill": "tozeroy",
                          "marker": {
                              "color": "blue"
                          }
                      },
                      {
                          "x": [
                              0.0,
                              0.019,
                              0.039,
                              0.058,
                              0.077,
                              0.097,
                              0.116,
                              0.136,
                              0.155,
                              0.174,
                              0.194,
                              0.213,
                              0.232,
                              0.252,
                              0.271,
                              0.29,
                              0.31,
                              0.329,
                              0.348,
                              0.368,
                              0.387,
                              0.407,
                              0.426,
                              0.445,
                              0.465,
                              0.484,
                              0.503,
                              0.523,
                              0.542,
                              0.561,
                              0.581,
                              0.6,
                              0.62,
                              0.639,
                              0.658,
                              0.678,
                              0.697,
                              0.716,
                              0.736,
                              0.755,
                              0.774,
                              0.794,
                              0.813,
                              0.832,
                              0.852,
                              0.871,
                              0.891,
                              0.91,
                              0.929,
                              0.949,
                              0.968
                          ],
                          "y": [
                              0.063,
                              0.055,
                              0.067,
                              0.066,
                              0.089,
                              0.027,
                              0.024,
                              0.018,
                              0.016,
                              0.026,
                              0.013,
                              0.012,
                              0.013,
                              0.028,
                              0.013,
                              0.016,
                              0.02,
                              0.02,
                              0.043,
                              0.022,
                              0.022,
                              0.02,
                              0.038,
                              0.017,
                              0.017,
                              0.015,
                              0.014,
                              0.028,
                              0.011,
                              0.012,
                              0.01,
                              0.019,
                              0.011,
                              0.012,
                              0.008,
                              0.008,
                              0.016,
                              0.007,
                              0.007,
                              0.006,
                              0.005,
                              0.011,
                              0.004,
                              0.005,
                              0.005,
                              0.009,
                              0.004,
                              0.003,
                              0.002,
                              0.003
                          ],
                          "type": "lines",
                          "name": "production",
                          "fill": "tozeroy",
                          "marker": {
                              "color": "red"
                          }
                      }
                  ],
                  [
                      {
                          "y": [
                              0.27,
                              0.143,
                              0.333,
                              0.079,
                              0.603,
                              0.333,
                              0.079,
                              0.063,
                              0.333,
                              0.111,
                              0.921,
                              0.111,
                              0.254,
                              0.302,
                              0.175,
                              0.524,
                              0.016,
                              0.095,
                              0.27,
                              0.079,
                              0.825,
                              0.286,
                              0.016,
                              0.032,
                              0.048,
                              0.0,
                              0.016,
                              0.54,
                              0.222,
                              0.365,
                              0.032,
                              0.206,
                              0.016,
                              0.508,
                              0.206,
                              0.127,
                              0.048,
                              0.0,
                              0.127,
                              0.0,
                              0.238,
                              0.46,
                              0.048,
                              0.0,
                              0.079,
                              0.032,
                              0.032,
                              0.397,
                              0.683,
                              0.032,
                              0.127,
                              0.937,
                              0.079,
                              0.032,
                              0.635,
                              0.365,
                              0.159,
                              0.238,
                              0.397,
                              0.286,
                              0.444,
                              0.333,
                              0.032,
                              0.063,
                              0.413,
                              0.54,
                              0.413,
                              0.349,
                              0.032,
                              0.429,
                              0.508,
                              0.079,
                              0.587,
                              0.063,
                              0.508,
                              0.032,
                              0.111,
                              0.016,
                              0.778,
                              0.413,
                              0.143,
                              0.778,
                              0.413,
                              0.079,
                              0.429,
                              0.095,
                              0.016,
                              0.333,
                              0.079,
                              0.079,
                              0.0,
                              0.048,
                              0.111,
                              0.048,
                              0.063,
                              0.54,
                              0.27,
                              0.016,
                              0.127,
                              0.317,
                              0.19,
                              0.492,
                              0.016,
                              0.016,
                              0.254,
                              0.143,
                              0.286,
                              0.46,
                              0.333,
                              0.54,
                              0.349,
                              0.413,
                              0.286,
                              0.571,
                              0.381,
                              0.492,
                              0.365,
                              0.413,
                              0.159,
                              0.079,
                              0.0,
                              0.333,
                              0.349,
                              0.397,
                              0.492,
                              0.079,
                              0.952,
                              0.762,
                              0.317,
                              0.095,
                              0.381,
                              0.54,
                              0.524,
                              0.048,
                              0.46,
                              0.079,
                              0.556,
                              0.333,
                              0.492,
                              0.159,
                              0.032,
                              0.111,
                              0.841,
                              0.016,
                              0.079,
                              0.746,
                              0.302,
                              0.667,
                              0.048,
                              0.492,
                              0.254,
                              0.048,
                              0.333,
                              0.079,
                              0.46,
                              0.698,
                              0.143,
                              0.27,
                              0.429,
                              0.111,
                              0.667,
                              0.095,
                              0.54,
                              0.73,
                              0.048,
                              0.286,
                              0.048,
                              0.778,
                              0.349,
                              0.127,
                              0.333,
                              0.048,
                              0.492,
                              0.095,
                              0.603,
                              0.381,
                              0.397,
                              0.857,
                              0.048,
                              0.397,
                              0.032,
                              0.063,
                              0.905,
                              0.063,
                              0.508,
                              0.032,
                              0.508,
                              0.016,
                              0.524,
                              0.032,
                              0.048,
                              0.508,
                              0.032,
                              0.698,
                              0.603,
                              0.746,
                              0.46,
                              0.444,
                              0.349,
                              0.46,
                              0.413,
                              0.048,
                              0.063,
                              0.333,
                              0.063,
                              0.19,
                              0.079,
                              0.73,
                              0.0,
                              0.873,
                              0.381,
                              0.54,
                              0.016,
                              0.571,
                              0.508,
                              0.365,
                              0.317,
                              0.286,
                              0.063,
                              0.048,
                              0.063,
                              0.095,
                              0.095,
                              0.413,
                              0.349,
                              0.54,
                              0.778,
                              0.508,
                              0.048,
                              0.063,
                              0.063,
                              0.524,
                              0.016,
                              0.333,
                              0.016,
                              0.286,
                              0.063,
                              0.349,
                              0.476,
                              0.032,
                              0.603,
                              0.667,
                              0.048,
                              0.302,
                              0.397,
                              0.54,
                              0.397,
                              0.111,
                              0.0,
                              0.159,
                              0.683,
                              0.492,
                              0.349,
                              0.079,
                              0.095,
                              0.349,
                              0.016,
                              0.063,
                              0.286,
                              0.159,
                              0.143,
                              0.222,
                              0.032,
                              0.413,
                              0.444,
                              0.095,
                              0.048,
                              0.032,
                              0.048,
                              0.952,
                              0.063,
                              0.175,
                              0.079,
                              0.889,
                              0.46,
                              0.27,
                              0.111,
                              0.048,
                              0.698,
                              0.032,
                              0.063,
                              0.254,
                              0.429,
                              0.111,
                              0.206,
                              0.413,
                              0.079,
                              0.095,
                              0.317,
                              0.111,
                              0.079,
                              0.048,
                              0.016,
                              0.317,
                              0.127,
                              0.349,
                              0.333,
                              0.952,
                              0.746,
                              0.381,
                              0.333,
                              0.032,
                              0.333,
                              0.143,
                              0.032,
                              0.063,
                              0.127,
                              0.032,
                              0.365,
                              0.016,
                              0.063,
                              0.143,
                              0.429,
                              0.54,
                              0.508,
                              0.302,
                              0.079,
                              0.016,
                              0.063,
                              0.492,
                              0.889,
                              0.508,
                              0.063,
                              0.032,
                              0.238,
                              0.27,
                              0.143,
                              0.127,
                              0.508,
                              0.048,
                              0.81,
                              0.143,
                              0.365,
                              0.095,
                              0.746,
                              0.143,
                              0.429,
                              0.651,
                              0.016,
                              0.032,
                              0.587,
                              0.0,
                              0.317,
                              0.365,
                              0.73,
                              0.127,
                              0.635,
                              0.603,
                              0.063,
                              0.286,
                              0.095,
                              0.063,
                              0.238,
                              0.016,
                              0.381,
                              0.429,
                              0.254,
                              0.079,
                              0.063,
                              0.032,
                              0.381,
                              0.381,
                              0.254,
                              0.111,
                              0.286,
                              0.048,
                              0.302,
                              0.413,
                              0.175,
                              0.397,
                              0.175,
                              0.317,
                              0.143,
                              0.048,
                              0.063,
                              0.079,
                              0.413,
                              0.063,
                              0.0,
                              0.27,
                              0.048,
                              0.0,
                              0.397,
                              0.063,
                              0.206,
                              0.444,
                              0.27,
                              0.063,
                              0.889,
                              0.111,
                              0.032,
                              0.048,
                              0.032,
                              0.079,
                              0.698,
                              0.556,
                              0.762,
                              0.397,
                              0.032,
                              0.651,
                              0.079,
                              0.032,
                              0.46,
                              0.381,
                              0.143,
                              0.063,
                              0.762,
                              0.571,
                              0.349,
                              0.048,
                              0.016,
                              0.381,
                              0.016,
                              0.317,
                              0.397,
                              0.508,
                              0.302,
                              0.476,
                              0.127,
                              0.238,
                              0.603,
                              0.127,
                              0.016,
                              0.238,
                              0.206,
                              0.46,
                              0.111,
                              0.429,
                              0.111,
                              0.619,
                              0.222,
                              0.19,
                              0.254,
                              0.159,
                              0.556,
                              0.492,
                              0.159,
                              0.032,
                              0.016,
                              0.079,
                              0.063,
                              0.667,
                              0.063,
                              0.286,
                              0.381,
                              0.317,
                              0.048,
                              0.048,
                              0.222,
                              0.048,
                              0.635,
                              0.048,
                              0.063,
                              0.159,
                              0.079,
                              0.476,
                              0.079,
                              0.444,
                              0.302,
                              0.683,
                              0.0,
                              0.619,
                              0.365,
                              0.508,
                              0.508,
                              0.333,
                              0.079,
                              0.365,
                              0.333,
                              0.397,
                              0.143,
                              0.127,
                              0.794,
                              0.905,
                              0.413,
                              0.016,
                              0.476,
                              0.476,
                              0.317,
                              0.206,
                              0.444,
                              0.048,
                              0.317,
                              0.079,
                              0.81,
                              0.127,
                              0.206,
                              0.381,
                              0.46,
                              0.032,
                              0.81,
                              0.524,
                              0.365,
                              0.603,
                              0.0,
                              0.476,
                              0.175,
                              0.016,
                              0.429,
                              0.27,
                              0.048,
                              0.079,
                              0.841,
                              0.429,
                              0.73,
                              0.079,
                              0.365,
                              0.063,
                              0.159,
                              0.492,
                              0.032,
                              0.016
                          ],
                          "type": "box",
                          "name": "reference",
                          "marker": {
                              "color": "blue"
                          }
                      },
                      {
                          "y": [
                              0.508,
                              0.159,
                              0.571,
                              0.032,
                              0.159,
                              0.651,
                              0.111,
                              0.016,
                              0.048,
                              0.333,
                              0.222,
                              0.063,
                              0.302,
                              0.238,
                              0.524,
                              0.444,
                              0.063,
                              0.238,
                              0.508,
                              0.127,
                              0.413,
                              0.667,
                              0.254,
                              0.508,
                              0.587,
                              0.079,
                              0.508,
                              0.127,
                              0.111,
                              0.429,
                              0.127,
                              0.556,
                              0.111,
                              0.508,
                              0.317,
                              0.079,
                              0.27,
                              0.54,
                              0.016,
                              0.302,
                              0.063,
                              0.286,
                              0.413,
                              0.016,
                              0.286,
                              0.81,
                              0.016,
                              0.016,
                              0.349,
                              0.0,
                              0.667,
                              0.079,
                              0.333,
                              0.159,
                              0.063,
                              0.159,
                              0.095,
                              0.349,
                              0.254,
                              0.429,
                              0.381,
                              0.143,
                              0.063,
                              0.222,
                              0.016,
                              0.333,
                              0.032,
                              0.016,
                              0.381,
                              0.016,
                              0.413,
                              0.365,
                              0.587,
                              0.238,
                              0.079,
                              0.0,
                              0.317,
                              0.397,
                              0.397,
                              0.635,
                              0.508,
                              0.476,
                              0.365,
                              0.746,
                              0.048,
                              0.032,
                              0.238,
                              0.556,
                              0.381,
                              0.619,
                              0.048,
                              0.079,
                              0.46,
                              0.063,
                              0.651,
                              0.127,
                              0.063,
                              0.651,
                              0.365,
                              0.063,
                              0.778,
                              0.27,
                              0.19,
                              0.016,
                              0.048,
                              0.873,
                              0.397,
                              0.079,
                              0.222,
                              0.444,
                              0.063,
                              0.063,
                              0.079,
                              0.143,
                              0.063,
                              0.603,
                              0.746,
                              0.016,
                              0.476,
                              0.333,
                              0.127,
                              0.143,
                              0.063,
                              0.365,
                              0.317,
                              0.873,
                              0.397,
                              0.508,
                              0.079,
                              0.524,
                              0.587,
                              0.603,
                              0.508,
                              0.063,
                              0.016,
                              0.079,
                              0.048,
                              0.048,
                              0.413,
                              0.317,
                              0.349,
                              0.032,
                              0.635,
                              0.079,
                              0.762,
                              0.317,
                              0.016,
                              0.444,
                              0.27,
                              0.175,
                              0.222,
                              0.238,
                              0.54,
                              0.063,
                              0.238,
                              0.0,
                              0.413,
                              0.302,
                              0.444,
                              0.603,
                              0.825,
                              0.048,
                              0.238,
                              0.317,
                              0.794,
                              0.762,
                              0.587,
                              0.048,
                              0.048,
                              0.365,
                              0.032,
                              0.206,
                              0.365,
                              0.317,
                              0.365,
                              0.206,
                              0.079,
                              0.492,
                              0.397,
                              0.254,
                              0.556,
                              0.27,
                              0.508,
                              0.032,
                              0.302,
                              0.048,
                              0.571,
                              0.222,
                              0.381,
                              0.063,
                              0.365,
                              0.111,
                              0.27,
                              0.063,
                              0.095,
                              0.048,
                              0.079,
                              0.032,
                              0.254,
                              0.794,
                              0.921,
                              0.159,
                              0.381,
                              0.317,
                              0.048,
                              0.683,
                              0.841,
                              0.079,
                              0.365,
                              0.063,
                              0.413,
                              0.635,
                              0.492,
                              0.032,
                              0.397,
                              0.032,
                              0.825,
                              0.254,
                              0.46,
                              0.698,
                              0.286,
                              0.079,
                              0.571,
                              0.095,
                              0.048,
                              0.111,
                              0.381,
                              0.444,
                              0.635,
                              0.333,
                              0.079,
                              0.0,
                              0.556,
                              0.016,
                              0.857,
                              0.349,
                              0.095,
                              0.19,
                              0.651,
                              0.016,
                              0.143,
                              0.698,
                              0.317,
                              0.048,
                              0.063,
                              0.127,
                              0.254,
                              0.857,
                              0.365,
                              0.254,
                              0.048,
                              0.127,
                              0.079,
                              0.032,
                              0.048,
                              0.048,
                              0.413,
                              0.032,
                              0.032,
                              0.349,
                              0.46,
                              0.556,
                              0.413,
                              0.524,
                              0.302,
                              0.016,
                              0.46,
                              0.317,
                              0.111,
                              0.0,
                              0.048,
                              0.476,
                              0.127,
                              0.048,
                              0.159,
                              0.079,
                              0.032,
                              0.175,
                              0.46,
                              0.286,
                              0.222,
                              0.048,
                              0.032,
                              0.73,
                              0.952,
                              0.016,
                              0.905,
                              0.0,
                              0.048,
                              0.063,
                              0.27,
                              0.619,
                              0.81,
                              0.635,
                              0.73,
                              0.413,
                              0.73,
                              0.063,
                              0.413,
                              0.571,
                              0.524,
                              0.095,
                              0.048,
                              0.016,
                              0.079,
                              0.317,
                              0.063,
                              0.048,
                              0.317,
                              0.254,
                              0.429,
                              0.333,
                              0.159,
                              0.079,
                              0.0,
                              0.381,
                              0.143,
                              0.508,
                              0.619,
                              0.952,
                              0.73,
                              0.81,
                              0.111,
                              0.016,
                              0.048,
                              0.063,
                              0.0,
                              0.54,
                              0.429,
                              0.698,
                              0.143,
                              0.079,
                              0.476,
                              0.079,
                              0.619,
                              0.381,
                              0.46,
                              0.016,
                              0.016,
                              0.81,
                              0.016,
                              0.095,
                              0.063,
                              0.556,
                              0.079,
                              0.159,
                              0.492,
                              0.19,
                              0.032,
                              0.286,
                              0.016,
                              0.048,
                              0.762,
                              0.159,
                              0.222,
                              0.048,
                              0.063,
                              0.794,
                              0.333,
                              0.048,
                              0.127,
                              0.365,
                              0.095,
                              0.397,
                              0.063,
                              0.889,
                              0.429,
                              0.571,
                              0.286,
                              0.127,
                              0.0,
                              0.27,
                              0.397,
                              0.429,
                              0.143,
                              0.032,
                              0.952,
                              0.476,
                              0.032,
                              0.159,
                              0.381,
                              0.095,
                              0.508,
                              0.206,
                              0.746,
                              0.063,
                              0.365,
                              0.317,
                              0.492,
                              0.841,
                              0.111,
                              0.079,
                              0.444,
                              0.444,
                              0.81,
                              0.048,
                              0.111,
                              0.825,
                              0.381,
                              0.302,
                              0.175,
                              0.651,
                              0.444,
                              0.349,
                              0.095,
                              0.524,
                              0.413,
                              0.111,
                              0.095,
                              0.016,
                              0.46,
                              0.333,
                              0.063,
                              0.032,
                              0.159,
                              0.286,
                              0.524,
                              0.048,
                              0.048,
                              0.317,
                              0.238,
                              0.175,
                              0.46,
                              0.19,
                              0.333,
                              0.016,
                              0.444,
                              0.381,
                              0.063,
                              0.476,
                              0.032,
                              0.048,
                              0.413,
                              0.206,
                              0.016,
                              0.0,
                              0.365,
                              0.238,
                              0.603,
                              0.0,
                              0.0,
                              0.032,
                              0.317,
                              0.349,
                              0.349,
                              0.46,
                              0.0,
                              0.063,
                              0.683,
                              0.397,
                              0.683,
                              0.032,
                              0.048,
                              0.54,
                              0.937,
                              0.365,
                              0.397,
                              0.032,
                              0.032,
                              0.238,
                              0.048,
                              0.048,
                              0.016,
                              0.095,
                              0.048,
                              0.492,
                              0.048,
                              0.048,
                              0.524,
                              0.127,
                              0.095,
                              0.381,
                              0.032,
                              0.032,
                              0.206,
                              0.032,
                              0.571,
                              0.079,
                              0.063,
                              0.349,
                              0.746,
                              0.54,
                              0.952,
                              0.222,
                              0.508,
                              0.413,
                              0.175,
                              0.048,
                              0.048,
                              0.365,
                              0.032,
                              0.111,
                              0.397,
                              0.27,
                              0.381,
                              0.079,
                              0.524,
                              0.063,
                              0.0,
                              0.095,
                              0.095,
                              0.46,
                              0.349,
                              0.016,
                              0.571,
                              0.127,
                              0.127,
                              0.905,
                              0.667,
                              0.714,
                              0.667,
                              0.317
                          ],
                          "type": "box",
                          "name": "production",
                          "marker": {
                              "color": "red"
                          }
                      }
                  ]
              ]
          },
          {
              "title": "Driving_License",
              "train_oulier": "0.2",
              "test_oulier": "0.2",
              "feat_imp": "0.1",
              "layout": [
                  {
                      "autosize": "false",
                      "margin": {
                          "l": 25,
                          "r": 12,
                          "b": 16,
                          "t": 14,
                          "pad": 0
                      },
                      "height": 240,
                      "width": 460,
                      "xaxis": {
                          "title": "categories"
                      },
                      "yaxis": {
                          "title": "counts"
                      },
                      "showlegend": "false",
                      "barmode": "group"
                  }
              ],
              "data": [
                  [
                      {
                          "x": [
                              "0",
                              "1"
                          ],
                          "y": [
                              "90",
                              "45643"
                          ],
                          "type": "bar",
                          "name": "reference",
                          "marker": {
                              "color": "blue"
                          },
                          "width": "0.25"
                      },
                      {
                          "x": [
                              "0",
                              "1"
                          ],
                          "y": [
                              "24",
                              "11409"
                          ],
                          "type": "bar",
                          "name": "production",
                          "marker": {
                              "color": "red"
                          },
                          "width": "0.25"
                      }
                  ]
              ]
          },
          {
              "title": "Region_Code",
              "train_oulier": "0.0",
              "test_oulier": "0.0",
              "feat_imp": "11.3",
              "layout": [
                  {
                      "autosize": "false",
                      "margin": {
                          "l": 25,
                          "r": 12,
                          "b": 16,
                          "t": 14,
                          "pad": 0
                      },
                      "height": 240,
                      "width": 460,
                      "xaxis": {
                          "title": "categories"
                      },
                      "yaxis": {
                          "title": "counts"
                      },
                      "showlegend": "false",
                      "barmode": "group"
                  }
              ],
              "data": [
                  [
                      {
                          "x": [
                              "0",
                              "1",
                              "2",
                              "3",
                              "4",
                              "5",
                              "6",
                              "7",
                              "8",
                              "9",
                              "10",
                              "11",
                              "12",
                              "13",
                              "14",
                              "15",
                              "16",
                              "17",
                              "18",
                              "19",
                              "20",
                              "21",
                              "22",
                              "23",
                              "24",
                              "25",
                              "26",
                              "27",
                              "28",
                              "29",
                              "30",
                              "31",
                              "32",
                              "33",
                              "34",
                              "35",
                              "36",
                              "37",
                              "38",
                              "39",
                              "40",
                              "41",
                              "42",
                              "43",
                              "44",
                              "45",
                              "46",
                              "47",
                              "48",
                              "49",
                              "50",
                              "51",
                              "52"
                          ],
                          "y": [
                              "234",
                              "122",
                              "491",
                              "1084",
                              "219",
                              "140",
                              "762",
                              "381",
                              "4133",
                              "375",
                              "514",
                              "1088",
                              "387",
                              "513",
                              "565",
                              "1625",
                              "237",
                              "278",
                              "614",
                              "184",
                              "222",
                              "520",
                              "154",
                              "236",
                              "293",
                              "295",
                              "274",
                              "332",
                              "12783",
                              "1390",
                              "1473",
                              "237",
                              "323",
                              "935",
                              "216",
                              "783",
                              "1084",
                              "621",
                              "256",
                              "595",
                              "142",
                              "2216",
                              "67",
                              "331",
                              "102",
                              "674",
                              "2368",
                              "885",
                              "559",
                              "206",
                              "1150",
                              "24",
                              "41"
                          ],
                          "type": "bar",
                          "name": "reference",
                          "marker": {
                              "color": "blue"
                          },
                          "width": "0.25"
                      },
                      {
                          "x": [
                              "0",
                              "1",
                              "2",
                              "3",
                              "4",
                              "5",
                              "6",
                              "7",
                              "8",
                              "9",
                              "10",
                              "11",
                              "12",
                              "13",
                              "14",
                              "15",
                              "16",
                              "17",
                              "18",
                              "19",
                              "20",
                              "21",
                              "22",
                              "23",
                              "24",
                              "25",
                              "26",
                              "27",
                              "28",
                              "29",
                              "30",
                              "31",
                              "32",
                              "33",
                              "34",
                              "35",
                              "36",
                              "37",
                              "38",
                              "39",
                              "40",
                              "41",
                              "42",
                              "43",
                              "44",
                              "45",
                              "46",
                              "47",
                              "48",
                              "49",
                              "50",
                              "51",
                              "52"
                          ],
                          "y": [
                              "54",
                              "30",
                              "120",
                              "285",
                              "59",
                              "41",
                              "164",
                              "98",
                              "1052",
                              "102",
                              "148",
                              "274",
                              "86",
                              "120",
                              "130",
                              "394",
                              "59",
                              "84",
                              "173",
                              "46",
                              "49",
                              "146",
                              "31",
                              "62",
                              "63",
                              "79",
                              "82",
                              "77",
                              "3137",
                              "339",
                              "385",
                              "55",
                              "80",
                              "229",
                              "46",
                              "207",
                              "270",
                              "139",
                              "50",
                              "147",
                              "27",
                              "553",
                              "16",
                              "69",
                              "33",
                              "173",
                              "603",
                              "215",
                              "145",
                              "53",
                              "334",
                              "9",
                              "11"
                          ],
                          "type": "bar",
                          "name": "production",
                          "marker": {
                              "color": "red"
                          },
                          "width": "0.25"
                      }
                  ]
              ]
          },
          {
              "title": "Previously_Insured",
              "train_oulier": "0.0",
              "test_oulier": "0.0",
              "feat_imp": "4.6",
              "layout": [
                  {
                      "autosize": "false",
                      "margin": {
                          "l": 25,
                          "r": 12,
                          "b": 16,
                          "t": 14,
                          "pad": 0
                      },
                      "height": 240,
                      "width": 460,
                      "xaxis": {
                          "title": "categories"
                      },
                      "yaxis": {
                          "title": "counts"
                      },
                      "showlegend": "false",
                      "barmode": "group"
                  }
              ],
              "data": [
                  [
                      {
                          "x": [
                              "0",
                              "1"
                          ],
                          "y": [
                              "24771",
                              "20962"
                          ],
                          "type": "bar",
                          "name": "reference",
                          "marker": {
                              "color": "blue"
                          },
                          "width": "0.25"
                      },
                      {
                          "x": [
                              "0",
                              "1"
                          ],
                          "y": [
                              "6184",
                              "5249"
                          ],
                          "type": "bar",
                          "name": "production",
                          "marker": {
                              "color": "red"
                          },
                          "width": "0.25"
                      }
                  ]
              ]
          },
          {
              "title": "Vehicle_Age",
              "train_oulier": "0.0",
              "test_oulier": "0.0",
              "feat_imp": "1.6",
              "layout": [
                  {
                      "autosize": "false",
                      "margin": {
                          "l": 25,
                          "r": 12,
                          "b": 16,
                          "t": 14,
                          "pad": 0
                      },
                      "height": 240,
                      "width": 460,
                      "xaxis": {
                          "title": "categories"
                      },
                      "yaxis": {
                          "title": "counts"
                      },
                      "showlegend": "false",
                      "barmode": "group"
                  }
              ],
              "data": [
                  [
                      {
                          "x": [
                              "0",
                              "1",
                              "2"
                          ],
                          "y": [
                              "24061",
                              "19753",
                              "1919"
                          ],
                          "type": "bar",
                          "name": "reference",
                          "marker": {
                              "color": "blue"
                          },
                          "width": "0.25"
                      },
                      {
                          "x": [
                              "0",
                              "1",
                              "2"
                          ],
                          "y": [
                              "5982",
                              "4961",
                              "490"
                          ],
                          "type": "bar",
                          "name": "production",
                          "marker": {
                              "color": "red"
                          },
                          "width": "0.25"
                      }
                  ]
              ]
          },
          {
              "title": "Vehicle_Damage",
              "train_oulier": "0.0",
              "test_oulier": "0.0",
              "feat_imp": "7.6",
              "layout": [
                  {
                      "autosize": "false",
                      "margin": {
                          "l": 25,
                          "r": 12,
                          "b": 16,
                          "t": 14,
                          "pad": 0
                      },
                      "height": 240,
                      "width": 460,
                      "xaxis": {
                          "title": "categories"
                      },
                      "yaxis": {
                          "title": "counts"
                      },
                      "showlegend": "false",
                      "barmode": "group"
                  }
              ],
              "data": [
                  [
                      {
                          "x": [
                              "0",
                              "1"
                          ],
                          "y": [
                              "22543",
                              "23190"
                          ],
                          "type": "bar",
                          "name": "reference",
                          "marker": {
                              "color": "blue"
                          },
                          "width": "0.25"
                      },
                      {
                          "x": [
                              "0",
                              "1"
                          ],
                          "y": [
                              "5645",
                              "5788"
                          ],
                          "type": "bar",
                          "name": "production",
                          "marker": {
                              "color": "red"
                          },
                          "width": "0.25"
                      }
                  ]
              ]
          },
          {
              "title": "Annual_Premium",
              "train_oulier": "2.7",
              "test_oulier": "2.4",
              "feat_imp": "22.6",
              "layout": [
                  {
                      "autosize": false,
                      "margin": {
                          "l": 40,
                          "r": 12,
                          "b": 30,
                          "t": 14,
                          "pad": 0
                      },
                      "height": 286,
                      "width": 455,
                      "xaxis": {
                          "title": "bins"
                      },
                      "yaxis": {
                          "title": "pdf"
                      },
                      "showlegend": true
                  },
                  {
                      "autosize": false,
                      "margin": {
                          "l": 40,
                          "r": 12,
                          "b": 30,
                          "t": 14,
                          "pad": 0
                      },
                      "height": 286,
                      "width": 455,
                      "xaxis": {
                          "title": "data"
                      },
                      "yaxis": {
                          "title": "values"
                      },
                      "showlegend": true
                  }
              ],
              "data": [
                  [
                      {
                          "x": [
                              -1.936,
                              -1.281,
                              -0.626,
                              0.029,
                              0.684,
                              1.339,
                              1.994,
                              2.649,
                              3.304,
                              3.96,
                              4.615,
                              5.27,
                              5.925,
                              6.58,
                              7.235,
                              7.89,
                              8.545,
                              9.2,
                              9.855,
                              10.51,
                              11.165,
                              11.82,
                              12.475,
                              13.13,
                              13.785,
                              14.441,
                              15.096,
                              15.751,
                              16.406,
                              17.061,
                              17.716,
                              18.371,
                              19.026,
                              19.681,
                              20.336,
                              20.991,
                              21.646,
                              22.301,
                              22.956,
                              23.611,
                              24.266,
                              24.921,
                              25.577,
                              26.232,
                              26.887,
                              27.542,
                              28.197,
                              28.852,
                              29.507,
                              30.162,
                              30.817
                          ],
                          "y": [
                              0.168,
                              0.039,
                              0.31,
                              0.287,
                              0.126,
                              0.043,
                              0.016,
                              0.005,
                              0.002,
                              0.001,
                              0.001,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0
                          ],
                          "type": "lines",
                          "name": "reference",
                          "fill": "tozeroy",
                          "marker": {
                              "color": "blue"
                          }
                      },
                      {
                          "x": [
                              -1.936,
                              -1.49,
                              -1.045,
                              -0.599,
                              -0.154,
                              0.292,
                              0.737,
                              1.183,
                              1.628,
                              2.074,
                              2.519,
                              2.965,
                              3.41,
                              3.856,
                              4.301,
                              4.747,
                              5.192,
                              5.638,
                              6.083,
                              6.529,
                              6.974,
                              7.42,
                              7.865,
                              8.311,
                              8.756,
                              9.202,
                              9.648,
                              10.093,
                              10.539,
                              10.984,
                              11.43,
                              11.875,
                              12.321,
                              12.766,
                              13.212,
                              13.657,
                              14.103,
                              14.548,
                              14.994,
                              15.439,
                              15.885,
                              16.33,
                              16.776,
                              17.221,
                              17.667,
                              18.112,
                              18.558,
                              19.003,
                              19.449,
                              19.894,
                              20.34
                          ],
                          "y": [
                              0.172,
                              0.002,
                              0.045,
                              0.198,
                              0.243,
                              0.158,
                              0.094,
                              0.045,
                              0.021,
                              0.01,
                              0.005,
                              0.002,
                              0.002,
                              0.001,
                              0.001,
                              0.001,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0
                          ],
                          "type": "lines",
                          "name": "production",
                          "fill": "tozeroy",
                          "marker": {
                              "color": "red"
                          }
                      }
                  ],
                  [
                      {
                          "y": [
                              1.43,
                              0.077,
                              0.514,
                              0.095,
                              0.281,
                              0.05,
                              0.339,
                              0.447,
                              -1.936,
                              -0.348,
                              0.529,
                              -0.079,
                              -0.026,
                              -0.069,
                              -1.936,
                              0.221,
                              -0.11,
                              0.268,
                              -0.373,
                              -0.378,
                              0.834,
                              -0.475,
                              -1.936,
                              0.347,
                              -0.138,
                              -1.936,
                              -0.728,
                              -1.936,
                              -1.936,
                              -0.266,
                              -0.308,
                              1.232,
                              0.1,
                              0.729,
                              -1.936,
                              -1.936,
                              -0.202,
                              -0.035,
                              0.691,
                              -0.303,
                              -1.936,
                              -0.242,
                              -0.049,
                              0.895,
                              -0.327,
                              0.193,
                              0.4,
                              1.573,
                              -0.519,
                              -0.034,
                              -1.936,
                              -0.262,
                              -1.936,
                              1.642,
                              0.094,
                              -1.936,
                              -1.936,
                              -1.936,
                              1.326,
                              -1.936,
                              0.195,
                              -0.377,
                              -1.936,
                              -1.936,
                              -0.701,
                              -0.428,
                              0.147,
                              0.725,
                              -0.595,
                              -1.936,
                              -1.936,
                              -0.085,
                              0.357,
                              -1.936,
                              -1.936,
                              -0.149,
                              1.119,
                              0.908,
                              0.024,
                              0.894,
                              0.051,
                              -1.936,
                              -1.936,
                              0.182,
                              -0.148,
                              -1.936,
                              0.16,
                              -0.282,
                              -0.257,
                              -1.936,
                              0.73,
                              -1.936,
                              0.081,
                              -1.936,
                              -0.011,
                              -1.936,
                              1.005,
                              0.198,
                              -1.936,
                              1.329,
                              -0.414,
                              0.746,
                              1.426,
                              0.596,
                              2.454,
                              -0.278,
                              0.605,
                              0.88,
                              0.152,
                              0.22,
                              0.185,
                              -1.936,
                              -0.566,
                              0.374,
                              -1.936,
                              -0.301,
                              0.472,
                              0.693,
                              1.149,
                              0.469,
                              0.557,
                              0.9,
                              -0.404,
                              -1.936,
                              0.208,
                              -0.842,
                              -0.275,
                              -0.389,
                              -1.936,
                              0.466,
                              0.136,
                              -0.305,
                              0.997,
                              -0.186,
                              0.466,
                              -0.445,
                              0.614,
                              2.665,
                              0.299,
                              -0.03,
                              -0.612,
                              -0.281,
                              1.315,
                              -1.936,
                              0.135,
                              -0.35,
                              -0.05,
                              0.587,
                              -0.334,
                              -0.01,
                              -0.664,
                              -0.588,
                              0.136,
                              -0.399,
                              -0.528,
                              1.795,
                              -0.273,
                              0.442,
                              -0.081,
                              0.0,
                              -0.554,
                              -1.936,
                              0.613,
                              0.649,
                              -0.045,
                              0.044,
                              -0.509,
                              0.785,
                              -0.117,
                              0.358,
                              0.105,
                              -0.505,
                              -0.516,
                              0.216,
                              0.468,
                              -1.936,
                              0.429,
                              0.352,
                              0.128,
                              0.05,
                              -1.936,
                              0.424,
                              0.44,
                              -0.069,
                              1.005,
                              0.097,
                              0.014,
                              0.411,
                              -0.264,
                              -0.13,
                              -0.279,
                              -1.936,
                              1.167,
                              -1.936,
                              -0.264,
                              0.288,
                              0.964,
                              0.168,
                              -0.087,
                              -0.053,
                              1.029,
                              -0.5,
                              0.495,
                              1.077,
                              -0.115,
                              0.29,
                              0.508,
                              -0.534,
                              -0.31,
                              -0.639,
                              0.918,
                              -0.146,
                              -0.117,
                              0.049,
                              -1.936,
                              2.38,
                              -1.936,
                              -0.604,
                              -0.427,
                              1.276,
                              -0.633,
                              -0.127,
                              0.166,
                              -1.936,
                              -0.035,
                              0.127,
                              -0.094,
                              -1.936,
                              -0.372,
                              0.762,
                              -1.936,
                              0.147,
                              -0.288,
                              0.317,
                              -1.936,
                              -1.936,
                              0.54,
                              -0.05,
                              1.153,
                              -0.461,
                              -1.936,
                              8.225,
                              0.047,
                              0.198,
                              -1.936,
                              0.681,
                              0.671,
                              2.928,
                              -1.936,
                              -0.495,
                              -0.008,
                              -1.936,
                              0.027,
                              0.059,
                              0.311,
                              0.318,
                              -0.055,
                              -0.577,
                              -0.158,
                              -0.002,
                              0.165,
                              -1.936,
                              0.14,
                              0.094,
                              0.111,
                              -0.483,
                              -0.454,
                              -0.286,
                              -0.387,
                              0.068,
                              0.054,
                              -1.936,
                              -0.403,
                              -1.936,
                              -0.264,
                              2.651,
                              0.383,
                              2.866,
                              -0.527,
                              0.114,
                              0.428,
                              -1.936,
                              2.018,
                              -0.161,
                              1.188,
                              -0.052,
                              1.145,
                              -0.305,
                              3.403,
                              1.502,
                              -0.52,
                              -0.857,
                              -0.064,
                              1.436,
                              -1.936,
                              -1.936,
                              0.674,
                              -1.936,
                              -1.936,
                              -1.936,
                              0.287,
                              0.19,
                              -1.936,
                              0.131,
                              -0.173,
                              1.076,
                              0.068,
                              1.357,
                              0.226,
                              0.146,
                              0.449,
                              0.078,
                              -1.936,
                              -0.12,
                              -0.307,
                              0.352,
                              0.258,
                              1.616,
                              -1.936,
                              -1.936,
                              0.896,
                              -1.936,
                              -0.323,
                              -0.566,
                              -1.936,
                              -0.064,
                              -0.313,
                              -0.201,
                              0.306,
                              -0.087,
                              0.104,
                              -0.564,
                              -0.019,
                              -1.936,
                              -0.721,
                              -0.379,
                              0.274,
                              -0.214,
                              -0.087,
                              -0.266,
                              0.033,
                              -1.936,
                              -0.256,
                              -1.936,
                              1.233,
                              -0.399,
                              0.184,
                              0.012,
                              -0.165,
                              -1.936,
                              0.148,
                              0.425,
                              0.238,
                              0.014,
                              0.437,
                              1.62,
                              0.667,
                              0.143,
                              0.062,
                              -0.006,
                              -0.549,
                              -1.936,
                              0.125,
                              -0.298,
                              0.397,
                              0.835,
                              0.189,
                              -0.517,
                              -0.246,
                              -0.184,
                              -0.014,
                              -1.936,
                              0.717,
                              -0.655,
                              0.171,
                              -0.148,
                              0.026,
                              0.112,
                              -1.936,
                              0.596,
                              -1.936,
                              0.289,
                              1.533,
                              0.147,
                              1.857,
                              2.251,
                              -0.074,
                              0.967,
                              0.018,
                              0.254,
                              -0.243,
                              2.759,
                              1.306,
                              -0.523,
                              0.348,
                              0.884,
                              1.301,
                              -0.559,
                              1.277,
                              0.114,
                              -0.219,
                              -0.213,
                              -0.144,
                              0.877,
                              2.55,
                              1.871,
                              0.862,
                              -0.95,
                              0.676,
                              -0.185,
                              1.011,
                              0.446,
                              0.078,
                              0.596,
                              -0.139,
                              -0.373,
                              -0.612,
                              -1.936,
                              0.023,
                              -0.138,
                              0.654,
                              -0.41,
                              -0.995,
                              -0.308,
                              1.348,
                              0.685,
                              -0.278,
                              0.219,
                              -1.936,
                              0.547,
                              -1.936,
                              0.882,
                              0.605,
                              -1.936,
                              0.672,
                              -1.936,
                              2.002,
                              1.229,
                              0.634,
                              1.415,
                              0.175,
                              -1.936,
                              0.621,
                              -0.363,
                              0.048,
                              0.169,
                              -0.701,
                              -0.372,
                              0.629,
                              -1.936,
                              -0.56,
                              0.642,
                              0.363,
                              0.814,
                              0.673,
                              0.382,
                              0.255,
                              0.814,
                              -1.936,
                              0.572,
                              0.632,
                              -1.936,
                              -1.936,
                              -0.14,
                              -1.936,
                              0.44,
                              -0.261,
                              0.453,
                              0.797,
                              0.339,
                              -0.129,
                              -1.936,
                              0.762,
                              -0.047,
                              0.356,
                              0.178,
                              0.368,
                              0.533,
                              -1.936,
                              0.522,
                              1.689,
                              -0.092,
                              0.235,
                              -0.474,
                              1.337,
                              0.01,
                              -1.936,
                              -1.936,
                              -0.369,
                              -0.453,
                              -1.936,
                              2.031,
                              0.279,
                              0.055,
                              -0.547,
                              -1.936,
                              -0.465,
                              0.031,
                              1.018,
                              0.604,
                              -0.774,
                              -1.936,
                              -0.067,
                              -1.936,
                              -1.936,
                              -1.936,
                              -0.247,
                              -0.738,
                              -0.122,
                              -0.206,
                              -1.936,
                              0.286
                          ],
                          "type": "box",
                          "name": "reference",
                          "marker": {
                              "color": "blue"
                          }
                      },
                      {
                          "y": [
                              0.038,
                              0.056,
                              0.912,
                              -0.074,
                              2.147,
                              1.007,
                              -0.454,
                              -0.43,
                              0.539,
                              0.212,
                              -1.936,
                              0.436,
                              -0.174,
                              -0.306,
                              -1.936,
                              -1.936,
                              -0.115,
                              -1.936,
                              -0.393,
                              -0.145,
                              -0.616,
                              0.723,
                              -0.156,
                              -1.936,
                              0.29,
                              0.872,
                              0.536,
                              0.149,
                              -0.612,
                              1.213,
                              0.68,
                              -0.055,
                              -0.022,
                              1.975,
                              -0.627,
                              0.085,
                              0.46,
                              2.746,
                              0.079,
                              -0.048,
                              0.666,
                              0.526,
                              2.13,
                              -1.936,
                              0.819,
                              1.843,
                              -0.206,
                              -0.276,
                              -0.176,
                              0.638,
                              -0.098,
                              0.244,
                              -0.338,
                              1.153,
                              -0.862,
                              -1.936,
                              -1.936,
                              -0.028,
                              -1.936,
                              -1.936,
                              -1.936,
                              0.782,
                              1.353,
                              -0.335,
                              0.41,
                              -1.936,
                              -0.345,
                              -0.141,
                              0.176,
                              -0.254,
                              -0.497,
                              -1.936,
                              -0.224,
                              -1.936,
                              -0.673,
                              -1.936,
                              -0.611,
                              0.135,
                              0.792,
                              0.436,
                              -1.936,
                              -1.936,
                              -1.936,
                              0.432,
                              -0.029,
                              -1.936,
                              0.242,
                              -1.936,
                              0.569,
                              -1.936,
                              0.126,
                              1.191,
                              0.535,
                              -0.393,
                              1.156,
                              -0.546,
                              -1.092,
                              0.915,
                              0.251,
                              0.069,
                              0.536,
                              1.297,
                              -0.917,
                              -0.447,
                              -0.039,
                              -1.936,
                              -0.383,
                              -0.485,
                              0.35,
                              0.946,
                              -0.412,
                              0.949,
                              0.726,
                              -0.052,
                              -1.936,
                              1.943,
                              -1.936,
                              0.311,
                              -1.936,
                              -1.936,
                              -0.69,
                              0.869,
                              0.365,
                              -1.936,
                              -1.936,
                              1.251,
                              0.447,
                              0.111,
                              0.853,
                              -0.09,
                              0.449,
                              -1.936,
                              0.316,
                              -0.121,
                              1.807,
                              0.053,
                              0.298,
                              -0.561,
                              4.237,
                              0.585,
                              3.159,
                              0.221,
                              0.961,
                              -0.424,
                              -0.764,
                              0.741,
                              -0.594,
                              -0.16,
                              0.692,
                              -0.081,
                              -0.217,
                              -0.599,
                              0.954,
                              0.414,
                              -1.936,
                              0.801,
                              1.367,
                              -1.936,
                              1.443,
                              -1.936,
                              0.506,
                              -0.43,
                              -0.189,
                              1.371,
                              0.224,
                              -1.936,
                              -0.34,
                              0.326,
                              0.256,
                              0.901,
                              -0.675,
                              -0.314,
                              0.646,
                              0.105,
                              0.414,
                              -1.936,
                              -0.009,
                              -0.452,
                              -1.936,
                              2.048,
                              1.808,
                              -1.936,
                              1.2,
                              0.553,
                              0.224,
                              0.146,
                              0.204,
                              0.04,
                              0.807,
                              -1.936,
                              0.455,
                              1.676,
                              0.71,
                              -0.49,
                              0.114,
                              -0.235,
                              -0.154,
                              -0.057,
                              -0.048,
                              0.709,
                              -0.706,
                              0.525,
                              -0.449,
                              -0.141,
                              -0.507,
                              -1.936,
                              -1.936,
                              -0.834,
                              -0.421,
                              0.109,
                              -0.005,
                              0.762,
                              -0.058,
                              -0.685,
                              1.007,
                              -1.068,
                              -0.386,
                              0.409,
                              -1.936,
                              -1.936,
                              0.061,
                              -0.574,
                              0.541,
                              0.929,
                              -0.374,
                              -1.936,
                              1.225,
                              -0.417,
                              -0.538,
                              0.164,
                              -0.883,
                              -0.623,
                              -1.936,
                              -0.193,
                              -1.936,
                              0.007,
                              -0.532,
                              0.003,
                              2.465,
                              -0.105,
                              -0.496,
                              -0.165,
                              -0.312,
                              -1.936,
                              -0.172,
                              -1.936,
                              -1.936,
                              -0.255,
                              -1.936,
                              -1.936,
                              -0.227,
                              0.081,
                              0.222,
                              -0.26,
                              -0.643,
                              0.134,
                              -0.486,
                              0.901,
                              -0.676,
                              -0.589,
                              0.535,
                              -0.33,
                              0.459,
                              0.524,
                              -0.059,
                              -0.254,
                              0.941,
                              -0.225,
                              1.374,
                              -1.936,
                              -0.715,
                              0.525,
                              -0.525,
                              -0.494,
                              -1.936,
                              0.882,
                              0.004,
                              -0.43,
                              0.353,
                              -0.268,
                              -1.936,
                              -0.61,
                              -0.086,
                              -1.936,
                              -1.936,
                              -0.349,
                              -1.936,
                              -0.37,
                              0.308,
                              2.571,
                              0.925,
                              -1.936,
                              -0.167,
                              0.841,
                              0.451,
                              0.012,
                              0.686,
                              0.978,
                              -1.936,
                              -1.936,
                              0.706,
                              0.391,
                              -0.5,
                              -0.714,
                              -0.614,
                              0.412,
                              0.45,
                              -1.936,
                              1.062,
                              -0.67,
                              0.324,
                              -0.612,
                              0.047,
                              0.052,
                              -0.079,
                              -1.936,
                              0.233,
                              1.796,
                              0.352,
                              -1.936,
                              -0.267,
                              2.629,
                              -0.264,
                              0.652,
                              -0.055,
                              1.194,
                              0.478,
                              1.132,
                              -1.936,
                              -1.936,
                              -1.936,
                              1.512,
                              -0.245,
                              0.035,
                              1.422,
                              -0.705,
                              0.962,
                              -0.141,
                              0.738,
                              1.514,
                              -0.193,
                              3.569,
                              -0.14,
                              0.101,
                              -1.936,
                              0.112,
                              0.493,
                              1.129,
                              0.969,
                              -1.936,
                              -0.36,
                              -1.936,
                              -1.936,
                              0.536,
                              1.126,
                              -0.08,
                              0.751,
                              -1.936,
                              0.297,
                              -1.936,
                              -0.517,
                              1.516,
                              -0.087,
                              0.042,
                              -0.433,
                              0.868,
                              0.608,
                              2.143,
                              1.33,
                              0.098,
                              0.497,
                              -0.018,
                              1.295,
                              -0.382,
                              0.754,
                              -1.936,
                              0.173,
                              0.598,
                              -1.936,
                              -0.261,
                              -0.2,
                              1.788,
                              1.21,
                              -1.936,
                              0.728,
                              -0.504,
                              -1.936,
                              -0.021,
                              -1.936,
                              1.128,
                              -0.505,
                              0.081,
                              0.506,
                              -1.936,
                              1.652,
                              1.335,
                              0.23,
                              1.319,
                              -1.936,
                              0.979,
                              -1.936,
                              2.237,
                              -1.936,
                              -0.435,
                              0.813,
                              -1.936,
                              0.45,
                              -1.936,
                              -1.936,
                              -0.417,
                              -1.936,
                              1.232,
                              0.505,
                              0.407,
                              -1.936,
                              -1.936,
                              -1.936,
                              -0.1,
                              0.211,
                              0.322,
                              1.214,
                              0.395,
                              0.501,
                              0.566,
                              0.313,
                              4.194,
                              -1.936,
                              0.668,
                              0.31,
                              -0.06,
                              0.15,
                              0.656,
                              0.902,
                              -1.936,
                              0.6,
                              -0.647,
                              0.189,
                              -0.118,
                              -1.936,
                              -0.217,
                              -0.247,
                              0.612,
                              0.483,
                              -0.58,
                              2.36,
                              -0.053,
                              -0.188,
                              0.103,
                              1.19,
                              0.292,
                              -0.482,
                              -0.532,
                              -0.94,
                              0.085,
                              0.988,
                              1.319,
                              0.726,
                              0.067,
                              0.101,
                              -1.936,
                              0.286,
                              -0.033,
                              -0.39,
                              -1.936,
                              0.746,
                              0.639,
                              0.061,
                              0.977,
                              -1.936,
                              -0.623,
                              1.554,
                              -1.936,
                              -0.502,
                              0.847,
                              0.099,
                              0.349,
                              0.832,
                              0.054,
                              0.034,
                              -1.936,
                              0.055,
                              0.844,
                              0.423,
                              0.18,
                              -1.936,
                              1.076,
                              0.292,
                              -0.627,
                              0.422,
                              -0.07,
                              -0.653,
                              -0.233,
                              -0.181,
                              -0.677,
                              0.333,
                              -0.627,
                              0.489,
                              0.26,
                              0.292,
                              -0.362,
                              -0.185,
                              0.701,
                              -1.936,
                              -1.936,
                              -0.511,
                              0.368,
                              -1.936,
                              2.349,
                              -0.227,
                              3.848,
                              0.378,
                              3.559
                          ],
                          "type": "box",
                          "name": "production",
                          "marker": {
                              "color": "red"
                          }
                      }
                  ]
              ]
          },
          {
              "title": "Policy_Sales_Channel",
              "train_oulier": "0.0",
              "test_oulier": "0.0",
              "feat_imp": "8.1",
              "layout": [
                  {
                      "autosize": "false",
                      "margin": {
                          "l": 25,
                          "r": 12,
                          "b": 16,
                          "t": 14,
                          "pad": 0
                      },
                      "height": 240,
                      "width": 460,
                      "xaxis": {
                          "title": "categories"
                      },
                      "yaxis": {
                          "title": "counts"
                      },
                      "showlegend": "false",
                      "barmode": "group"
                  }
              ],
              "data": [
                  [
                      {
                          "x": [
                              "1",
                              "3",
                              "4",
                              "7",
                              "8",
                              "9",
                              "10",
                              "11",
                              "12",
                              "13",
                              "14",
                              "15",
                              "16",
                              "17",
                              "18",
                              "19",
                              "20",
                              "21",
                              "22",
                              "23",
                              "24",
                              "25",
                              "26",
                              "29",
                              "30",
                              "31",
                              "32",
                              "33",
                              "34",
                              "35",
                              "36",
                              "37",
                              "38",
                              "39",
                              "40",
                              "41",
                              "42",
                              "44",
                              "45",
                              "46",
                              "47",
                              "48",
                              "49",
                              "51",
                              "52",
                              "53",
                              "54",
                              "55",
                              "56",
                              "57",
                              "58",
                              "59",
                              "60",
                              "61",
                              "63",
                              "64",
                              "65",
                              "66",
                              "67",
                              "69",
                              "70",
                              "73",
                              "78",
                              "79",
                              "80",
                              "81",
                              "83",
                              "86",
                              "87",
                              "88",
                              "89",
                              "90",
                              "91",
                              "92",
                              "93",
                              "94",
                              "95",
                              "96",
                              "97",
                              "98",
                              "99",
                              "101",
                              "103",
                              "104",
                              "106",
                              "107",
                              "108",
                              "109",
                              "110",
                              "111",
                              "113",
                              "114",
                              "115",
                              "116",
                              "117",
                              "118",
                              "119",
                              "120",
                              "121",
                              "122",
                              "124",
                              "125",
                              "127",
                              "128",
                              "129",
                              "130",
                              "131",
                              "132",
                              "133",
                              "134",
                              "135",
                              "136",
                              "137",
                              "138",
                              "139",
                              "140",
                              "143",
                              "145",
                              "146",
                              "147",
                              "148",
                              "150",
                              "151",
                              "152",
                              "153",
                              "154",
                              "155",
                              "156",
                              "157",
                              "158",
                              "159",
                              "160",
                              "163"
                          ],
                          "y": [
                              "127",
                              "57",
                              "68",
                              "207",
                              "182",
                              "15",
                              "32",
                              "131",
                              "83",
                              "220",
                              "78",
                              "112",
                              "77",
                              "2",
                              "20",
                              "29",
                              "4",
                              "19",
                              "35",
                              "54",
                              "81",
                              "217",
                              "9783",
                              "96",
                              "169",
                              "80",
                              "1",
                              "1",
                              "1",
                              "9",
                              "8",
                              "24",
                              "1",
                              "1",
                              "1",
                              "1",
                              "13",
                              "13",
                              "8",
                              "1",
                              "10",
                              "4",
                              "1",
                              "2",
                              "117",
                              "6",
                              "12",
                              "173",
                              "8",
                              "1",
                              "3",
                              "19",
                              "55",
                              "66",
                              "2",
                              "6",
                              "7",
                              "1",
                              "2",
                              "0",
                              "1",
                              "4",
                              "1",
                              "1",
                              "2",
                              "2",
                              "1",
                              "4",
                              "1",
                              "4",
                              "0",
                              "2",
                              "13",
                              "2",
                              "3",
                              "10",
                              "2",
                              "0",
                              "3",
                              "2",
                              "1",
                              "3",
                              "8",
                              "1",
                              "4",
                              "3",
                              "3",
                              "15",
                              "1",
                              "5",
                              "14",
                              "4",
                              "0",
                              "19",
                              "1",
                              "1",
                              "14",
                              "97",
                              "5",
                              "1201",
                              "8750",
                              "124",
                              "14",
                              "14",
                              "1",
                              "2",
                              "16",
                              "9",
                              "10",
                              "1",
                              "12",
                              "28",
                              "1",
                              "15",
                              "15",
                              "9",
                              "1",
                              "26",
                              "2",
                              "21",
                              "15",
                              "31",
                              "457",
                              "16131",
                              "65",
                              "710",
                              "155",
                              "1231",
                              "789",
                              "61",
                              "3",
                              "2662",
                              "338"
                          ],
                          "type": "bar",
                          "name": "reference",
                          "marker": {
                              "color": "blue"
                          },
                          "width": "0.25"
                      },
                      {
                          "x": [
                              "1",
                              "3",
                              "4",
                              "7",
                              "8",
                              "9",
                              "10",
                              "11",
                              "12",
                              "13",
                              "14",
                              "15",
                              "16",
                              "17",
                              "18",
                              "19",
                              "20",
                              "21",
                              "22",
                              "23",
                              "24",
                              "25",
                              "26",
                              "29",
                              "30",
                              "31",
                              "32",
                              "33",
                              "34",
                              "35",
                              "36",
                              "37",
                              "38",
                              "39",
                              "40",
                              "41",
                              "42",
                              "44",
                              "45",
                              "46",
                              "47",
                              "48",
                              "49",
                              "51",
                              "52",
                              "53",
                              "54",
                              "55",
                              "56",
                              "57",
                              "58",
                              "59",
                              "60",
                              "61",
                              "63",
                              "64",
                              "65",
                              "66",
                              "67",
                              "69",
                              "70",
                              "73",
                              "78",
                              "79",
                              "80",
                              "81",
                              "83",
                              "86",
                              "87",
                              "88",
                              "89",
                              "90",
                              "91",
                              "92",
                              "93",
                              "94",
                              "95",
                              "96",
                              "97",
                              "98",
                              "99",
                              "101",
                              "103",
                              "104",
                              "106",
                              "107",
                              "108",
                              "109",
                              "110",
                              "111",
                              "113",
                              "114",
                              "115",
                              "116",
                              "117",
                              "118",
                              "119",
                              "120",
                              "121",
                              "122",
                              "124",
                              "125",
                              "127",
                              "128",
                              "129",
                              "130",
                              "131",
                              "132",
                              "133",
                              "134",
                              "135",
                              "136",
                              "137",
                              "138",
                              "139",
                              "140",
                              "143",
                              "145",
                              "146",
                              "147",
                              "148",
                              "150",
                              "151",
                              "152",
                              "153",
                              "154",
                              "155",
                              "156",
                              "157",
                              "158",
                              "159",
                              "160",
                              "163"
                          ],
                          "y": [
                              "37",
                              "12",
                              "23",
                              "50",
                              "49",
                              "5",
                              "9",
                              "28",
                              "30",
                              "60",
                              "17",
                              "24",
                              "16",
                              "0",
                              "8",
                              "7",
                              "1",
                              "4",
                              "16",
                              "15",
                              "27",
                              "53",
                              "2419",
                              "25",
                              "39",
                              "21",
                              "1",
                              "1",
                              "0",
                              "3",
                              "1",
                              "5",
                              "0",
                              "0",
                              "0",
                              "0",
                              "2",
                              "1",
                              "4",
                              "1",
                              "5",
                              "0",
                              "2",
                              "0",
                              "33",
                              "2",
                              "6",
                              "34",
                              "1",
                              "1",
                              "0",
                              "6",
                              "18",
                              "9",
                              "0",
                              "1",
                              "4",
                              "1",
                              "0",
                              "1",
                              "0",
                              "0",
                              "0",
                              "0",
                              "0",
                              "1",
                              "0",
                              "1",
                              "1",
                              "1",
                              "2",
                              "1",
                              "8",
                              "2",
                              "0",
                              "1",
                              "0",
                              "1",
                              "0",
                              "0",
                              "0",
                              "0",
                              "3",
                              "0",
                              "2",
                              "0",
                              "1",
                              "4",
                              "0",
                              "4",
                              "1",
                              "0",
                              "1",
                              "2",
                              "0",
                              "2",
                              "6",
                              "16",
                              "0",
                              "292",
                              "2135",
                              "30",
                              "3",
                              "6",
                              "2",
                              "1",
                              "2",
                              "3",
                              "2",
                              "1",
                              "2",
                              "4",
                              "0",
                              "6",
                              "6",
                              "0",
                              "0",
                              "2",
                              "1",
                              "11",
                              "2",
                              "6",
                              "123",
                              "4051",
                              "20",
                              "186",
                              "39",
                              "312",
                              "202",
                              "22",
                              "0",
                              "671",
                              "91"
                          ],
                          "type": "bar",
                          "name": "production",
                          "marker": {
                              "color": "red"
                          },
                          "width": "0.25"
                      }
                  ]
              ]
          },
          {
              "title": "Vintage",
              "train_oulier": "0.0",
              "test_oulier": "0.0",
              "feat_imp": "24.7",
              "layout": [
                  {
                      "autosize": false,
                      "margin": {
                          "l": 40,
                          "r": 12,
                          "b": 30,
                          "t": 14,
                          "pad": 0
                      },
                      "height": 286,
                      "width": 455,
                      "xaxis": {
                          "title": "bins"
                      },
                      "yaxis": {
                          "title": "pdf"
                      },
                      "showlegend": true
                  },
                  {
                      "autosize": false,
                      "margin": {
                          "l": 40,
                          "r": 12,
                          "b": 30,
                          "t": 14,
                          "pad": 0
                      },
                      "height": 286,
                      "width": 455,
                      "xaxis": {
                          "title": "data"
                      },
                      "yaxis": {
                          "title": "values"
                      },
                      "showlegend": true
                  }
              ],
              "data": [
                  [
                      {
                          "x": [
                              -0.986,
                              -0.946,
                              -0.907,
                              -0.867,
                              -0.828,
                              -0.788,
                              -0.749,
                              -0.709,
                              -0.669,
                              -0.63,
                              -0.59,
                              -0.551,
                              -0.511,
                              -0.471,
                              -0.432,
                              -0.392,
                              -0.353,
                              -0.313,
                              -0.274,
                              -0.234,
                              -0.194,
                              -0.155,
                              -0.115,
                              -0.076,
                              -0.036,
                              0.004,
                              0.043,
                              0.083,
                              0.122,
                              0.162,
                              0.201,
                              0.241,
                              0.281,
                              0.32,
                              0.36,
                              0.399,
                              0.439,
                              0.478,
                              0.518,
                              0.558,
                              0.597,
                              0.637,
                              0.676,
                              0.716,
                              0.756,
                              0.795,
                              0.835,
                              0.874,
                              0.914,
                              0.953,
                              0.993
                          ],
                          "y": [
                              0.02,
                              0.02,
                              0.02,
                              0.022,
                              0.018,
                              0.022,
                              0.02,
                              0.021,
                              0.021,
                              0.017,
                              0.021,
                              0.021,
                              0.022,
                              0.021,
                              0.017,
                              0.021,
                              0.02,
                              0.02,
                              0.018,
                              0.02,
                              0.02,
                              0.02,
                              0.017,
                              0.02,
                              0.02,
                              0.021,
                              0.02,
                              0.018,
                              0.02,
                              0.02,
                              0.021,
                              0.018,
                              0.021,
                              0.02,
                              0.02,
                              0.02,
                              0.018,
                              0.021,
                              0.021,
                              0.02,
                              0.017,
                              0.021,
                              0.021,
                              0.02,
                              0.02,
                              0.017,
                              0.02,
                              0.021,
                              0.021,
                              0.021
                          ],
                          "type": "lines",
                          "name": "reference",
                          "fill": "tozeroy",
                          "marker": {
                              "color": "blue"
                          }
                      },
                      {
                          "x": [
                              -0.986,
                              -0.946,
                              -0.907,
                              -0.867,
                              -0.828,
                              -0.788,
                              -0.749,
                              -0.709,
                              -0.669,
                              -0.63,
                              -0.59,
                              -0.551,
                              -0.511,
                              -0.471,
                              -0.432,
                              -0.392,
                              -0.353,
                              -0.313,
                              -0.274,
                              -0.234,
                              -0.194,
                              -0.155,
                              -0.115,
                              -0.076,
                              -0.036,
                              0.004,
                              0.043,
                              0.083,
                              0.122,
                              0.162,
                              0.201,
                              0.241,
                              0.281,
                              0.32,
                              0.36,
                              0.399,
                              0.439,
                              0.478,
                              0.518,
                              0.558,
                              0.597,
                              0.637,
                              0.676,
                              0.716,
                              0.756,
                              0.795,
                              0.835,
                              0.874,
                              0.914,
                              0.953,
                              0.993
                          ],
                          "y": [
                              0.021,
                              0.019,
                              0.023,
                              0.02,
                              0.018,
                              0.021,
                              0.02,
                              0.021,
                              0.021,
                              0.016,
                              0.021,
                              0.02,
                              0.021,
                              0.02,
                              0.018,
                              0.022,
                              0.019,
                              0.02,
                              0.017,
                              0.022,
                              0.023,
                              0.021,
                              0.017,
                              0.022,
                              0.021,
                              0.022,
                              0.022,
                              0.018,
                              0.017,
                              0.022,
                              0.019,
                              0.018,
                              0.021,
                              0.02,
                              0.02,
                              0.02,
                              0.018,
                              0.02,
                              0.021,
                              0.022,
                              0.017,
                              0.02,
                              0.022,
                              0.02,
                              0.018,
                              0.019,
                              0.018,
                              0.021,
                              0.022,
                              0.023
                          ],
                          "type": "lines",
                          "name": "production",
                          "fill": "tozeroy",
                          "marker": {
                              "color": "red"
                          }
                      }
                  ],
                  [
                      {
                          "y": [
                              -0.89,
                              0.993,
                              0.801,
                              -0.39,
                              -0.479,
                              -0.39,
                              0.685,
                              -0.5,
                              -0.432,
                              0.007,
                              -0.651,
                              -0.493,
                              0.308,
                              0.281,
                              -0.527,
                              -0.911,
                              0.76,
                              0.76,
                              0.76,
                              0.959,
                              -0.534,
                              0.342,
                              -0.527,
                              0.753,
                              0.911,
                              -0.534,
                              0.445,
                              0.61,
                              0.288,
                              -0.007,
                              0.39,
                              -0.623,
                              -0.384,
                              -0.123,
                              0.801,
                              -0.664,
                              0.87,
                              -0.274,
                              0.877,
                              -0.068,
                              -0.918,
                              0.959,
                              0.671,
                              -0.63,
                              0.959,
                              -0.959,
                              0.973,
                              0.24,
                              0.212,
                              -0.116,
                              0.774,
                              -0.349,
                              -0.103,
                              -0.096,
                              0.048,
                              -0.267,
                              0.308,
                              0.623,
                              0.027,
                              -0.192,
                              0.24,
                              -0.247,
                              0.336,
                              0.055,
                              0.247,
                              0.781,
                              -0.877,
                              -0.336,
                              0.644,
                              0.021,
                              -0.253,
                              0.014,
                              -0.233,
                              0.63,
                              -0.11,
                              0.788,
                              0.151,
                              0.582,
                              0.096,
                              -0.651,
                              -0.856,
                              0.753,
                              0.747,
                              -0.473,
                              0.993,
                              -0.075,
                              -0.349,
                              0.5,
                              0.459,
                              0.692,
                              0.603,
                              0.623,
                              0.5,
                              0.479,
                              -0.404,
                              -0.349,
                              0.774,
                              -0.342,
                              0.411,
                              -0.877,
                              0.253,
                              0.712,
                              0.932,
                              -0.349,
                              0.562,
                              0.575,
                              0.877,
                              0.151,
                              -0.918,
                              -0.699,
                              -0.247,
                              -0.582,
                              0.589,
                              -0.616,
                              -0.486,
                              -0.123,
                              -0.863,
                              0.836,
                              0.199,
                              -0.24,
                              0.781,
                              -0.068,
                              0.534,
                              -0.425,
                              -0.664,
                              0.555,
                              0.164,
                              -0.301,
                              0.068,
                              -0.39,
                              -0.685,
                              0.075,
                              -0.144,
                              0.87,
                              -0.623,
                              -0.5,
                              -0.616,
                              -0.884,
                              -0.959,
                              0.527,
                              0.438,
                              -0.568,
                              -0.719,
                              0.795,
                              0.158,
                              -0.664,
                              0.493,
                              -0.5,
                              0.274,
                              0.918,
                              -0.61,
                              -0.397,
                              0.89,
                              0.473,
                              0.253,
                              -0.089,
                              -0.185,
                              -0.651,
                              -0.466,
                              0.151,
                              0.945,
                              -0.829,
                              0.911,
                              0.925,
                              0.705,
                              -0.836,
                              0.932,
                              0.301,
                              0.103,
                              -0.733,
                              -0.986,
                              -0.856,
                              0.075,
                              0.603,
                              -0.068,
                              -0.89,
                              -0.411,
                              -0.63,
                              0.466,
                              -0.473,
                              0.575,
                              0.493,
                              -0.616,
                              -0.315,
                              -0.685,
                              0.226,
                              -0.747,
                              0.096,
                              0.541,
                              -0.822,
                              0.76,
                              0.815,
                              0.027,
                              -0.966,
                              -0.411,
                              0.253,
                              -0.562,
                              -0.26,
                              0.11,
                              0.555,
                              0.295,
                              -0.055,
                              -0.342,
                              0.329,
                              -0.082,
                              0.418,
                              0.842,
                              -0.37,
                              -0.555,
                              0.349,
                              -0.377,
                              -0.438,
                              -0.562,
                              0.027,
                              0.055,
                              0.418,
                              -0.822,
                              0.404,
                              0.253,
                              -0.5,
                              0.541,
                              0.589,
                              0.212,
                              -0.404,
                              0.5,
                              -0.144,
                              0.5,
                              0.5,
                              -0.459,
                              0.116,
                              -0.534,
                              -0.247,
                              -0.904,
                              0.267,
                              0.685,
                              0.767,
                              0.445,
                              0.24,
                              0.055,
                              0.514,
                              -0.281,
                              -0.205,
                              -0.295,
                              -0.089,
                              -0.829,
                              -0.26,
                              -0.144,
                              -0.226,
                              0.247,
                              0.021,
                              0.973,
                              0.13,
                              0.712,
                              0.055,
                              0.808,
                              -0.534,
                              0.842,
                              0.527,
                              0.774,
                              -0.274,
                              0.103,
                              -0.473,
                              -0.733,
                              -0.418,
                              -0.021,
                              0.301,
                              -0.301,
                              -0.349,
                              0.226,
                              0.89,
                              0.062,
                              0.918,
                              -0.151,
                              -0.205,
                              0.808,
                              -0.103,
                              0.486,
                              -0.37,
                              -0.945,
                              -0.568,
                              0.062,
                              -0.678,
                              -0.253,
                              -0.479,
                              0.836,
                              -0.267,
                              0.897,
                              -0.74,
                              0.589,
                              0.0,
                              0.678,
                              -0.911,
                              -0.123,
                              -0.849,
                              0.103,
                              -0.616,
                              0.5,
                              0.103,
                              -0.822,
                              -0.973,
                              0.027,
                              -0.527,
                              -0.103,
                              -0.233,
                              -0.288,
                              0.438,
                              -0.541,
                              0.062,
                              -0.979,
                              0.815,
                              -0.192,
                              0.884,
                              -0.342,
                              0.219,
                              -0.849,
                              0.247,
                              -0.945,
                              0.856,
                              -0.849,
                              0.178,
                              0.377,
                              -0.096,
                              -0.877,
                              0.76,
                              0.171,
                              0.596,
                              -0.253,
                              -0.589,
                              0.836,
                              -0.336,
                              0.623,
                              -0.87,
                              0.315,
                              0.267,
                              -0.897,
                              -0.473,
                              -0.445,
                              -0.137,
                              -0.308,
                              -0.021,
                              0.13,
                              -0.699,
                              -0.192,
                              -0.123,
                              0.534,
                              0.466,
                              0.158,
                              0.096,
                              -0.548,
                              0.603,
                              -0.349,
                              0.486,
                              -0.048,
                              -0.137,
                              0.911,
                              0.171,
                              0.212,
                              -0.575,
                              -0.24,
                              -0.507,
                              0.596,
                              0.007,
                              -0.849,
                              -0.301,
                              0.404,
                              -0.411,
                              0.507,
                              0.986,
                              -0.425,
                              -0.466,
                              0.075,
                              -0.144,
                              -0.062,
                              0.445,
                              0.945,
                              0.062,
                              -0.911,
                              0.034,
                              0.527,
                              -0.966,
                              0.548,
                              0.253,
                              0.774,
                              0.11,
                              0.137,
                              -0.979,
                              -0.822,
                              -0.062,
                              -0.123,
                              0.185,
                              -0.644,
                              -0.062,
                              -0.24,
                              -0.589,
                              0.068,
                              -0.192,
                              -0.651,
                              -0.274,
                              0.61,
                              0.89,
                              -0.658,
                              0.753,
                              -0.911,
                              0.212,
                              -0.575,
                              0.842,
                              -0.5,
                              -0.664,
                              0.212,
                              0.103,
                              -0.911,
                              0.699,
                              -0.301,
                              0.342,
                              -0.089,
                              0.973,
                              -0.116,
                              0.164,
                              -0.301,
                              0.514,
                              -0.918,
                              -0.74,
                              0.438,
                              -0.336,
                              0.178,
                              -0.041,
                              0.596,
                              0.349,
                              -0.63,
                              0.514,
                              -0.39,
                              0.884,
                              -0.377,
                              -0.253,
                              0.267,
                              0.925,
                              0.664,
                              0.253,
                              0.918,
                              -0.418,
                              0.288,
                              -0.233,
                              -0.226,
                              0.699,
                              0.788,
                              0.699,
                              -0.082,
                              0.493,
                              -0.432,
                              0.014,
                              -0.336,
                              0.726,
                              -0.438,
                              -0.767,
                              -0.425,
                              -0.007,
                              0.788,
                              -0.068,
                              0.932,
                              -0.103,
                              0.295,
                              -0.959,
                              0.055,
                              0.925,
                              0.144,
                              0.336,
                              -0.322,
                              -0.226,
                              0.897,
                              0.877,
                              0.623,
                              -0.966,
                              0.397,
                              -0.959,
                              0.568,
                              0.699,
                              -0.541,
                              -0.548,
                              0.514,
                              0.13,
                              0.952,
                              -0.815,
                              0.658,
                              -0.986,
                              0.26,
                              -0.048,
                              0.185,
                              -0.384,
                              0.137,
                              0.555,
                              0.39,
                              0.253,
                              -0.336,
                              -0.74,
                              0.301,
                              -0.253,
                              0.534,
                              0.959,
                              0.164,
                              -0.699,
                              0.164,
                              0.959,
                              -0.075,
                              0.479,
                              -0.274,
                              0.37,
                              0.726,
                              -0.473,
                              -0.479,
                              0.39,
                              0.397,
                              0.795
                          ],
                          "type": "box",
                          "name": "reference",
                          "marker": {
                              "color": "blue"
                          }
                      },
                      {
                          "y": [
                              0.384,
                              0.568,
                              0.322,
                              -0.356,
                              0.144,
                              0.952,
                              0.014,
                              0.301,
                              0.11,
                              -0.027,
                              0.486,
                              -0.795,
                              -0.863,
                              -0.925,
                              -0.144,
                              -0.267,
                              -0.322,
                              0.267,
                              0.185,
                              0.116,
                              0.76,
                              0.87,
                              -0.616,
                              0.493,
                              0.555,
                              -0.822,
                              0.514,
                              -0.384,
                              -0.164,
                              -0.349,
                              -0.61,
                              -0.61,
                              0.986,
                              -0.884,
                              0.137,
                              -0.479,
                              -0.808,
                              -0.068,
                              0.021,
                              -0.562,
                              0.075,
                              -0.274,
                              0.568,
                              0.192,
                              0.384,
                              -0.13,
                              0.877,
                              -0.658,
                              -0.164,
                              0.61,
                              -0.925,
                              -0.568,
                              -0.212,
                              0.685,
                              -0.555,
                              0.37,
                              0.281,
                              0.226,
                              0.24,
                              -0.671,
                              0.733,
                              -0.884,
                              0.493,
                              -0.233,
                              0.932,
                              -0.815,
                              -0.849,
                              0.74,
                              -0.801,
                              0.397,
                              -0.39,
                              -0.945,
                              -0.534,
                              0.329,
                              0.048,
                              -0.788,
                              0.103,
                              -0.774,
                              0.959,
                              0.904,
                              -0.788,
                              -0.247,
                              -0.116,
                              0.705,
                              -0.575,
                              -0.5,
                              0.24,
                              0.479,
                              0.589,
                              0.253,
                              -0.151,
                              -0.753,
                              -0.644,
                              -0.226,
                              -0.363,
                              0.596,
                              -0.938,
                              -0.322,
                              -0.774,
                              0.671,
                              0.884,
                              0.651,
                              0.068,
                              0.87,
                              0.959,
                              -0.692,
                              -0.055,
                              0.795,
                              0.164,
                              0.884,
                              -0.705,
                              -0.103,
                              0.692,
                              0.247,
                              0.438,
                              -0.808,
                              -0.521,
                              -0.048,
                              -0.897,
                              -0.212,
                              0.733,
                              -0.103,
                              0.925,
                              0.288,
                              -0.61,
                              0.329,
                              -0.651,
                              -0.185,
                              0.205,
                              0.74,
                              0.911,
                              0.623,
                              0.589,
                              0.171,
                              -0.342,
                              -0.596,
                              -0.904,
                              -0.212,
                              -0.63,
                              0.918,
                              0.925,
                              0.137,
                              0.11,
                              -0.562,
                              -0.185,
                              0.479,
                              0.966,
                              0.918,
                              -0.253,
                              -0.712,
                              -0.548,
                              -0.425,
                              -0.068,
                              -0.815,
                              0.363,
                              -0.753,
                              -0.568,
                              -0.623,
                              -0.829,
                              -0.952,
                              -0.466,
                              -0.247,
                              0.308,
                              0.788,
                              0.178,
                              -0.068,
                              0.808,
                              0.705,
                              -0.521,
                              -0.479,
                              -0.274,
                              0.356,
                              0.342,
                              0.897,
                              0.171,
                              -0.932,
                              0.151,
                              0.507,
                              -0.808,
                              -0.062,
                              0.041,
                              0.062,
                              -0.884,
                              0.404,
                              0.308,
                              -0.925,
                              0.733,
                              -0.61,
                              0.418,
                              0.274,
                              -0.37,
                              0.527,
                              -0.212,
                              0.411,
                              -0.904,
                              -0.336,
                              0.836,
                              0.616,
                              -0.445,
                              -0.301,
                              0.651,
                              0.959,
                              0.027,
                              0.767,
                              0.925,
                              0.363,
                              0.418,
                              0.281,
                              -0.842,
                              0.897,
                              0.712,
                              -0.726,
                              -0.37,
                              0.144,
                              0.603,
                              0.829,
                              0.075,
                              0.356,
                              0.288,
                              0.863,
                              -0.315,
                              0.678,
                              0.014,
                              -0.836,
                              0.534,
                              -0.774,
                              0.795,
                              -0.336,
                              0.911,
                              0.678,
                              -0.596,
                              -0.185,
                              0.445,
                              -0.329,
                              -0.473,
                              -0.103,
                              -0.541,
                              0.918,
                              0.616,
                              0.575,
                              -0.63,
                              0.603,
                              0.014,
                              -0.979,
                              -0.815,
                              -0.233,
                              0.753,
                              -0.096,
                              -0.774,
                              0.432,
                              0.541,
                              -0.788,
                              -0.226,
                              -0.027,
                              0.075,
                              -0.945,
                              -0.904,
                              -0.959,
                              -0.425,
                              0.87,
                              0.753,
                              0.253,
                              -0.774,
                              -0.678,
                              0.411,
                              -0.979,
                              0.075,
                              -0.945,
                              0.356,
                              0.856,
                              0.342,
                              0.445,
                              -0.288,
                              -0.541,
                              -0.575,
                              -0.89,
                              0.048,
                              -0.836,
                              -0.671,
                              -0.11,
                              0.24,
                              -0.199,
                              0.486,
                              0.466,
                              0.432,
                              0.068,
                              0.603,
                              0.932,
                              0.726,
                              -0.479,
                              -0.164,
                              0.788,
                              0.664,
                              -0.144,
                              0.521,
                              -0.226,
                              -0.432,
                              -0.836,
                              0.123,
                              0.959,
                              0.979,
                              -0.726,
                              0.342,
                              -0.534,
                              -0.966,
                              -0.452,
                              0.932,
                              -0.007,
                              -0.158,
                              -0.897,
                              0.822,
                              0.459,
                              0.356,
                              0.185,
                              -0.979,
                              -0.247,
                              0.555,
                              0.199,
                              0.575,
                              -0.795,
                              -0.979,
                              -0.445,
                              -0.384,
                              0.712,
                              0.021,
                              0.836,
                              0.329,
                              0.226,
                              -0.842,
                              -0.829,
                              0.521,
                              0.795,
                              0.096,
                              0.507,
                              0.616,
                              -0.986,
                              0.589,
                              -0.39,
                              0.158,
                              -0.685,
                              -0.212,
                              -0.185,
                              0.904,
                              -0.452,
                              -0.479,
                              -0.959,
                              0.623,
                              0.849,
                              -0.555,
                              0.719,
                              -0.527,
                              -0.11,
                              0.466,
                              0.226,
                              -0.808,
                              0.171,
                              -0.021,
                              0.301,
                              -0.514,
                              -0.603,
                              -0.062,
                              0.055,
                              -0.452,
                              -0.822,
                              0.39,
                              0.205,
                              0.363,
                              -0.356,
                              0.89,
                              -0.664,
                              0.945,
                              -0.534,
                              -0.959,
                              -0.199,
                              -0.664,
                              -0.39,
                              -0.829,
                              -0.87,
                              -0.459,
                              -0.082,
                              0.651,
                              0.062,
                              -0.349,
                              0.884,
                              -0.616,
                              -0.082,
                              -0.493,
                              0.582,
                              -0.575,
                              -0.308,
                              0.411,
                              0.0,
                              -0.082,
                              0.432,
                              -0.226,
                              -0.849,
                              0.664,
                              -0.829,
                              0.315,
                              -0.466,
                              0.027,
                              0.863,
                              -0.171,
                              -0.979,
                              0.418,
                              0.329,
                              -0.425,
                              -0.411,
                              0.747,
                              0.651,
                              -0.678,
                              -0.479,
                              0.432,
                              -0.336,
                              0.041,
                              -0.459,
                              0.925,
                              0.418,
                              0.075,
                              -0.397,
                              0.555,
                              -0.144,
                              -0.493,
                              0.575,
                              0.705,
                              -0.719,
                              0.473,
                              -0.055,
                              -0.493,
                              0.39,
                              -0.856,
                              -0.205,
                              0.527,
                              -0.493,
                              0.89,
                              0.829,
                              0.986,
                              -0.801,
                              -0.37,
                              0.144,
                              0.548,
                              0.116,
                              0.418,
                              -0.103,
                              0.247,
                              -0.356,
                              -0.548,
                              -0.945,
                              -0.863,
                              -0.521,
                              -0.712,
                              -0.979,
                              -0.178,
                              0.747,
                              0.171,
                              -0.527,
                              0.815,
                              0.158,
                              -0.623,
                              -0.925,
                              -0.24,
                              -0.425,
                              0.39,
                              -0.288,
                              0.185,
                              -0.418,
                              0.329,
                              -0.308,
                              -0.856,
                              -0.952,
                              0.007,
                              -0.041,
                              0.952,
                              0.63,
                              0.808,
                              -0.726,
                              0.699,
                              -0.801,
                              0.103,
                              -0.747,
                              0.884,
                              -0.418,
                              0.212,
                              -0.527,
                              0.63,
                              -0.973,
                              -0.815,
                              0.753,
                              0.678,
                              0.041,
                              -0.212,
                              -0.164,
                              -0.932,
                              -0.897,
                              0.075,
                              0.911,
                              0.281,
                              0.438,
                              0.747,
                              0.336,
                              0.267,
                              0.986,
                              0.671,
                              -0.349,
                              -0.219,
                              0.041,
                              -0.932,
                              0.199,
                              0.911,
                              0.534,
                              -0.795,
                              -0.507
                          ],
                          "type": "box",
                          "name": "production",
                          "marker": {
                              "color": "red"
                          }
                      }
                  ]
              ]
          }
      ],
      "timestamp": "2025-10-23 18:51:51.967794",
      "name": "Outlier Detection",
      "des": "An outlier represents the data points that are not in the normal range as specified by \n        threshold values. Any data point outside the threshold values will be highlighted as an outlier/anomaly. \n        We have given an overall scatter plot for the entire production dataset after reducing the data’s\n        dimensionality if required. Apart from this, we have also given two plots for each feature. \n        One of them is a Probability Density Plot and the other one is a Box Plot. These plots represent \n        outliers with respect to the reference and production data.\n        "
  },
  "dd": {
      "project_name": "insurance_claim",
      "module_name": "insurance",
      "header": "Drift Detection",
      "timestamp": "2025-10-23 18:52:13.211811",
      "name": "Drift Detection",
      "des": "Data drift identifies potential changes in the data inputs that may cause performance\n        degradation of the model. This drift is detected by measuring and comparing probability distributions \n        of reference and production data using multiple, best in class, statistical methods. We have provided \n        a bar plot with p-values highlighting the drift in production data. Apart from this, for every \n        feature we have provided three graphs. They are, a Probability Density Plot, a Cumulative Distribution \n        Function plot and a Mean Bar Plot.\n        "
      ,"values": [
          {
              "x": [],
              "y": [],
              "type": "bar",
              "marker": {
                  "color": "blue"
              }
          },
          {
              "x": [],
              "y": [],
              "mode": "lines+markers",
              "type": "scatter",
              "marker": {
                  "color": "red"
              }
          }
      ],
      "layout": {
          "autosize": "false",
          "margin": {
              "l": 50,
              "r": 50,
              "b": 50,
              "t": 50,
              "pad": 0
          },
          "height": 470,
          "width": 990,
          "xaxis": {
              "title": "feature names"
          },
          "yaxis": {
              "title": "p-values"
          },
          "showlegend": "true"
      },
      "features": [
          {
              "title": "Gender",
              "status": "Not Detected",
              "pvalue": "1.0",
              "feat_imp": 1.8,
              "layout": [
                  {
                      "autosize": "false",
                      "margin": {
                          "l": 25,
                          "r": 12,
                          "b": 16,
                          "t": 14,
                          "pad": 0
                      },
                      "height": 240,
                      "width": 460,
                      "xaxis": {
                          "title": "categories"
                      },
                      "yaxis": {
                          "title": "counts"
                      },
                      "showlegend": "false",
                      "bargap": 0.05,
                      "barmode": "group"
                  }
              ],
              "data": [
                  [
                      {
                          "x": [
                              "0",
                              "1"
                          ],
                          "y": [
                              "21014",
                              "24719"
                          ],
                          "type": "bar",
                          "name": "reference",
                          "marker": {
                              "color": "blue"
                          },
                          "width": "0.25"
                      },
                      {
                          "x": [
                              "0",
                              "1"
                          ],
                          "y": [
                              "5293",
                              "6140"
                          ],
                          "type": "bar",
                          "name": "production",
                          "marker": {
                              "color": "red"
                          },
                          "width": "0.25"
                      }
                  ]
              ]
          },
          {
              "title": "Age",
              "status": "Not Detected",
              "pvalue": "0.89",
              "feat_imp": 16.9,
              "layout": [
                  {
                      "autosize": "false",
                      "margin": {
                          "l": 25,
                          "r": 12,
                          "b": 16,
                          "t": 14,
                          "pad": 0
                      },
                      "height": 240,
                      "width": 460,
                      "xaxis": {
                          "title": "bins"
                      },
                      "yaxis": {
                          "title": "pdf"
                      },
                      "showlegend": "false",
                      "barmode": "group"
                  },
                  {
                      "autosize": "false",
                      "margin": {
                          "l": 25,
                          "r": 12,
                          "b": 16,
                          "t": 14,
                          "pad": 0
                      },
                      "height": 240,
                      "width": 460,
                      "xaxis": {
                          "title": "bins"
                      },
                      "yaxis": {
                          "title": "cdf"
                      },
                      "showlegend": "false"
                  },
                  {
                      "autosize": "false",
                      "margin": {
                          "l": 25,
                          "r": 12,
                          "b": 16,
                          "t": 14,
                          "pad": 0
                      },
                      "height": 240,
                      "width": 360,
                      "xaxis": {
                          "title": "data"
                      },
                      "yaxis": {
                          "title": "mean"
                      },
                      "showlegend": "false"
                  }
              ],
              "data": [
                  [
                      {
                          "x": [
                              0.0,
                              0.02,
                              0.04,
                              0.06,
                              0.08,
                              0.1,
                              0.12,
                              0.14,
                              0.16,
                              0.18,
                              0.2,
                              0.22,
                              0.24,
                              0.26,
                              0.28,
                              0.3,
                              0.32,
                              0.34,
                              0.36,
                              0.38,
                              0.4,
                              0.42,
                              0.44,
                              0.46,
                              0.48,
                              0.5,
                              0.52,
                              0.54,
                              0.56,
                              0.58,
                              0.6,
                              0.62,
                              0.64,
                              0.66,
                              0.68,
                              0.7,
                              0.72,
                              0.74,
                              0.76,
                              0.78,
                              0.8,
                              0.82,
                              0.84,
                              0.86,
                              0.88,
                              0.9,
                              0.92,
                              0.94,
                              0.96,
                              0.98,
                              1.0
                          ],
                          "y": [
                              0.059,
                              0.055,
                              0.065,
                              0.126,
                              0.034,
                              0.028,
                              0.023,
                              0.035,
                              0.013,
                              0.012,
                              0.013,
                              0.025,
                              0.014,
                              0.014,
                              0.013,
                              0.037,
                              0.022,
                              0.021,
                              0.021,
                              0.044,
                              0.021,
                              0.02,
                              0.018,
                              0.034,
                              0.015,
                              0.014,
                              0.014,
                              0.025,
                              0.011,
                              0.01,
                              0.02,
                              0.009,
                              0.009,
                              0.008,
                              0.015,
                              0.008,
                              0.007,
                              0.007,
                              0.013,
                              0.007,
                              0.005,
                              0.006,
                              0.009,
                              0.005,
                              0.004,
                              0.004,
                              0.005,
                              0.002,
                              0.0,
                              0.0
                          ],
                          "type": "lines",
                          "fill": "tozeroy",
                          "name": "reference",
                          "marker": {
                              "color": "blue"
                          }
                      },
                      {
                          "x": [
                              0.0,
                              0.019,
                              0.039,
                              0.058,
                              0.077,
                              0.097,
                              0.116,
                              0.136,
                              0.155,
                              0.174,
                              0.194,
                              0.213,
                              0.232,
                              0.252,
                              0.271,
                              0.29,
                              0.31,
                              0.329,
                              0.348,
                              0.368,
                              0.387,
                              0.407,
                              0.426,
                              0.445,
                              0.465,
                              0.484,
                              0.503,
                              0.523,
                              0.542,
                              0.561,
                              0.581,
                              0.6,
                              0.62,
                              0.639,
                              0.658,
                              0.678,
                              0.697,
                              0.716,
                              0.736,
                              0.755,
                              0.774,
                              0.794,
                              0.813,
                              0.832,
                              0.852,
                              0.871,
                              0.891,
                              0.91,
                              0.929,
                              0.949,
                              0.968
                          ],
                          "y": [
                              0.063,
                              0.055,
                              0.067,
                              0.066,
                              0.089,
                              0.027,
                              0.024,
                              0.018,
                              0.016,
                              0.026,
                              0.013,
                              0.012,
                              0.013,
                              0.028,
                              0.013,
                              0.016,
                              0.02,
                              0.02,
                              0.043,
                              0.022,
                              0.022,
                              0.02,
                              0.038,
                              0.017,
                              0.017,
                              0.015,
                              0.014,
                              0.028,
                              0.011,
                              0.012,
                              0.01,
                              0.019,
                              0.011,
                              0.012,
                              0.008,
                              0.008,
                              0.016,
                              0.007,
                              0.007,
                              0.006,
                              0.005,
                              0.011,
                              0.004,
                              0.005,
                              0.005,
                              0.009,
                              0.004,
                              0.003,
                              0.002,
                              0.003
                          ],
                          "type": "lines",
                          "fill": "tozeroy",
                          "name": "production",
                          "marker": {
                              "color": "red"
                          }
                      }
                  ],
                  [
                      {
                          "x": [
                              0.0,
                              0.005,
                              0.01,
                              0.015,
                              0.02,
                              0.025,
                              0.03,
                              0.035,
                              0.04,
                              0.045,
                              0.05,
                              0.055,
                              0.06,
                              0.065,
                              0.07,
                              0.075,
                              0.08,
                              0.085,
                              0.09,
                              0.095,
                              0.1,
                              0.105,
                              0.11,
                              0.115,
                              0.12,
                              0.125,
                              0.13,
                              0.135,
                              0.14,
                              0.145,
                              0.15,
                              0.155,
                              0.16,
                              0.165,
                              0.17,
                              0.175,
                              0.18,
                              0.185,
                              0.19,
                              0.195,
                              0.2,
                              0.205,
                              0.21,
                              0.215,
                              0.22,
                              0.225,
                              0.23,
                              0.235,
                              0.24,
                              0.245,
                              0.25,
                              0.255,
                              0.26,
                              0.265,
                              0.27,
                              0.275,
                              0.28,
                              0.285,
                              0.29,
                              0.295,
                              0.3,
                              0.305,
                              0.31,
                              0.315,
                              0.32,
                              0.325,
                              0.33,
                              0.335,
                              0.34,
                              0.345,
                              0.35,
                              0.355,
                              0.36,
                              0.365,
                              0.37,
                              0.375,
                              0.38,
                              0.385,
                              0.39,
                              0.395,
                              0.4,
                              0.405,
                              0.41,
                              0.415,
                              0.42,
                              0.425,
                              0.43,
                              0.435,
                              0.44,
                              0.445,
                              0.45,
                              0.455,
                              0.46,
                              0.465,
                              0.47,
                              0.475,
                              0.48,
                              0.485,
                              0.49,
                              0.495,
                              0.5,
                              0.505,
                              0.51,
                              0.515,
                              0.52,
                              0.525,
                              0.53,
                              0.535,
                              0.54,
                              0.545,
                              0.55,
                              0.555,
                              0.56,
                              0.565,
                              0.57,
                              0.575,
                              0.58,
                              0.585,
                              0.59,
                              0.595,
                              0.6,
                              0.605,
                              0.61,
                              0.615,
                              0.62,
                              0.625,
                              0.63,
                              0.635,
                              0.64,
                              0.645,
                              0.65,
                              0.655,
                              0.66,
                              0.665,
                              0.67,
                              0.675,
                              0.68,
                              0.685,
                              0.69,
                              0.695,
                              0.7,
                              0.705,
                              0.71,
                              0.715,
                              0.72,
                              0.725,
                              0.73,
                              0.735,
                              0.74,
                              0.745,
                              0.75,
                              0.755,
                              0.76,
                              0.765,
                              0.77,
                              0.775,
                              0.78,
                              0.785,
                              0.79,
                              0.795,
                              0.8,
                              0.805,
                              0.81,
                              0.815,
                              0.82,
                              0.825,
                              0.83,
                              0.835,
                              0.84,
                              0.845,
                              0.85,
                              0.855,
                              0.86,
                              0.865,
                              0.87,
                              0.875,
                              0.88,
                              0.885,
                              0.89,
                              0.895,
                              0.9,
                              0.905,
                              0.91,
                              0.915,
                              0.92,
                              0.925,
                              0.93,
                              0.935,
                              0.94,
                              0.945,
                              0.95,
                              0.955,
                              0.96,
                              0.965,
                              0.97,
                              0.975,
                              0.98,
                              0.985,
                              0.99,
                              0.995,
                              1.0
                          ],
                          "y": [
                              0.016,
                              0.016,
                              0.016,
                              0.059,
                              0.059,
                              0.059,
                              0.114,
                              0.114,
                              0.114,
                              0.179,
                              0.179,
                              0.179,
                              0.249,
                              0.249,
                              0.249,
                              0.305,
                              0.305,
                              0.305,
                              0.305,
                              0.339,
                              0.339,
                              0.339,
                              0.367,
                              0.367,
                              0.367,
                              0.39,
                              0.39,
                              0.39,
                              0.408,
                              0.408,
                              0.408,
                              0.425,
                              0.425,
                              0.425,
                              0.438,
                              0.438,
                              0.438,
                              0.438,
                              0.451,
                              0.451,
                              0.451,
                              0.464,
                              0.464,
                              0.464,
                              0.476,
                              0.476,
                              0.476,
                              0.488,
                              0.488,
                              0.488,
                              0.502,
                              0.502,
                              0.502,
                              0.502,
                              0.516,
                              0.516,
                              0.516,
                              0.529,
                              0.529,
                              0.529,
                              0.547,
                              0.547,
                              0.547,
                              0.567,
                              0.567,
                              0.567,
                              0.588,
                              0.588,
                              0.588,
                              0.609,
                              0.609,
                              0.609,
                              0.609,
                              0.63,
                              0.63,
                              0.63,
                              0.652,
                              0.652,
                              0.652,
                              0.674,
                              0.674,
                              0.674,
                              0.695,
                              0.695,
                              0.695,
                              0.714,
                              0.714,
                              0.714,
                              0.732,
                              0.732,
                              0.732,
                              0.732,
                              0.75,
                              0.75,
                              0.75,
                              0.767,
                              0.767,
                              0.767,
                              0.782,
                              0.782,
                              0.782,
                              0.796,
                              0.796,
                              0.796,
                              0.81,
                              0.81,
                              0.81,
                              0.81,
                              0.822,
                              0.822,
                              0.822,
                              0.834,
                              0.834,
                              0.834,
                              0.845,
                              0.845,
                              0.845,
                              0.855,
                              0.855,
                              0.855,
                              0.865,
                              0.865,
                              0.865,
                              0.875,
                              0.875,
                              0.875,
                              0.875,
                              0.884,
                              0.884,
                              0.884,
                              0.893,
                              0.893,
                              0.893,
                              0.902,
                              0.902,
                              0.902,
                              0.909,
                              0.909,
                              0.909,
                              0.916,
                              0.916,
                              0.916,
                              0.924,
                              0.924,
                              0.924,
                              0.924,
                              0.932,
                              0.932,
                              0.932,
                              0.939,
                              0.939,
                              0.939,
                              0.946,
                              0.946,
                              0.946,
                              0.953,
                              0.953,
                              0.953,
                              0.959,
                              0.959,
                              0.959,
                              0.959,
                              0.965,
                              0.965,
                              0.971,
                              0.971,
                              0.971,
                              0.971,
                              0.976,
                              0.976,
                              0.976,
                              0.98,
                              0.98,
                              0.98,
                              0.985,
                              0.985,
                              0.985,
                              0.989,
                              0.989,
                              0.989,
                              0.989,
                              0.992,
                              0.992,
                              0.992,
                              0.995,
                              0.995,
                              0.995,
                              0.997,
                              0.997,
                              0.997,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0
                          ],
                          "type": "line",
                          "name": "reference",
                          "marker": {
                              "color": "blue"
                          },
                          "shape": "spline"
                      },
                      {
                          "x": [
                              0.0,
                              0.005,
                              0.01,
                              0.015,
                              0.019,
                              0.024,
                              0.029,
                              0.034,
                              0.039,
                              0.044,
                              0.048,
                              0.053,
                              0.058,
                              0.063,
                              0.068,
                              0.073,
                              0.077,
                              0.082,
                              0.087,
                              0.092,
                              0.097,
                              0.102,
                              0.106,
                              0.111,
                              0.116,
                              0.121,
                              0.126,
                              0.131,
                              0.136,
                              0.14,
                              0.145,
                              0.15,
                              0.155,
                              0.16,
                              0.165,
                              0.169,
                              0.174,
                              0.179,
                              0.184,
                              0.189,
                              0.194,
                              0.198,
                              0.203,
                              0.208,
                              0.213,
                              0.218,
                              0.223,
                              0.227,
                              0.232,
                              0.237,
                              0.242,
                              0.247,
                              0.252,
                              0.257,
                              0.261,
                              0.266,
                              0.271,
                              0.276,
                              0.281,
                              0.286,
                              0.29,
                              0.295,
                              0.3,
                              0.305,
                              0.31,
                              0.315,
                              0.319,
                              0.324,
                              0.329,
                              0.334,
                              0.339,
                              0.344,
                              0.348,
                              0.353,
                              0.358,
                              0.363,
                              0.368,
                              0.373,
                              0.378,
                              0.382,
                              0.387,
                              0.392,
                              0.397,
                              0.402,
                              0.407,
                              0.411,
                              0.416,
                              0.421,
                              0.426,
                              0.431,
                              0.436,
                              0.44,
                              0.445,
                              0.45,
                              0.455,
                              0.46,
                              0.465,
                              0.469,
                              0.474,
                              0.479,
                              0.484,
                              0.489,
                              0.494,
                              0.499,
                              0.503,
                              0.508,
                              0.513,
                              0.518,
                              0.523,
                              0.528,
                              0.532,
                              0.537,
                              0.542,
                              0.547,
                              0.552,
                              0.557,
                              0.561,
                              0.566,
                              0.571,
                              0.576,
                              0.581,
                              0.586,
                              0.59,
                              0.595,
                              0.6,
                              0.605,
                              0.61,
                              0.615,
                              0.62,
                              0.624,
                              0.629,
                              0.634,
                              0.639,
                              0.644,
                              0.649,
                              0.653,
                              0.658,
                              0.663,
                              0.668,
                              0.673,
                              0.678,
                              0.682,
                              0.687,
                              0.692,
                              0.697,
                              0.702,
                              0.707,
                              0.711,
                              0.716,
                              0.721,
                              0.726,
                              0.731,
                              0.736,
                              0.741,
                              0.745,
                              0.75,
                              0.755,
                              0.76,
                              0.765,
                              0.77,
                              0.774,
                              0.779,
                              0.784,
                              0.789,
                              0.794,
                              0.799,
                              0.803,
                              0.808,
                              0.813,
                              0.818,
                              0.823,
                              0.828,
                              0.832,
                              0.837,
                              0.842,
                              0.847,
                              0.852,
                              0.857,
                              0.862,
                              0.866,
                              0.871,
                              0.876,
                              0.881,
                              0.886,
                              0.891,
                              0.895,
                              0.9,
                              0.905,
                              0.91,
                              0.915,
                              0.92,
                              0.924,
                              0.929,
                              0.934,
                              0.939,
                              0.944,
                              0.949,
                              0.953,
                              0.958,
                              0.963,
                              0.968
                          ],
                          "y": [
                              0.017,
                              0.017,
                              0.017,
                              0.063,
                              0.063,
                              0.063,
                              0.118,
                              0.118,
                              0.118,
                              0.185,
                              0.185,
                              0.185,
                              0.185,
                              0.25,
                              0.25,
                              0.25,
                              0.304,
                              0.304,
                              0.304,
                              0.339,
                              0.339,
                              0.339,
                              0.367,
                              0.367,
                              0.367,
                              0.367,
                              0.39,
                              0.39,
                              0.39,
                              0.408,
                              0.408,
                              0.408,
                              0.424,
                              0.424,
                              0.424,
                              0.424,
                              0.439,
                              0.439,
                              0.439,
                              0.45,
                              0.45,
                              0.45,
                              0.464,
                              0.464,
                              0.464,
                              0.476,
                              0.476,
                              0.476,
                              0.476,
                              0.489,
                              0.489,
                              0.489,
                              0.502,
                              0.502,
                              0.502,
                              0.517,
                              0.517,
                              0.517,
                              0.517,
                              0.53,
                              0.53,
                              0.53,
                              0.547,
                              0.547,
                              0.547,
                              0.567,
                              0.567,
                              0.567,
                              0.586,
                              0.586,
                              0.586,
                              0.586,
                              0.607,
                              0.607,
                              0.607,
                              0.629,
                              0.629,
                              0.629,
                              0.651,
                              0.651,
                              0.651,
                              0.651,
                              0.673,
                              0.673,
                              0.673,
                              0.693,
                              0.693,
                              0.693,
                              0.71,
                              0.71,
                              0.71,
                              0.73,
                              0.73,
                              0.73,
                              0.73,
                              0.747,
                              0.747,
                              0.747,
                              0.764,
                              0.764,
                              0.764,
                              0.779,
                              0.779,
                              0.779,
                              0.793,
                              0.793,
                              0.793,
                              0.793,
                              0.808,
                              0.808,
                              0.808,
                              0.821,
                              0.821,
                              0.821,
                              0.833,
                              0.833,
                              0.833,
                              0.845,
                              0.845,
                              0.845,
                              0.845,
                              0.855,
                              0.855,
                              0.855,
                              0.865,
                              0.865,
                              0.865,
                              0.874,
                              0.874,
                              0.874,
                              0.874,
                              0.884,
                              0.884,
                              0.884,
                              0.896,
                              0.896,
                              0.896,
                              0.904,
                              0.904,
                              0.904,
                              0.904,
                              0.912,
                              0.912,
                              0.912,
                              0.919,
                              0.919,
                              0.919,
                              0.928,
                              0.928,
                              0.928,
                              0.935,
                              0.935,
                              0.935,
                              0.935,
                              0.942,
                              0.942,
                              0.942,
                              0.948,
                              0.948,
                              0.948,
                              0.953,
                              0.953,
                              0.953,
                              0.953,
                              0.96,
                              0.96,
                              0.96,
                              0.964,
                              0.964,
                              0.964,
                              0.969,
                              0.969,
                              0.969,
                              0.974,
                              0.974,
                              0.974,
                              0.974,
                              0.979,
                              0.979,
                              0.979,
                              0.984,
                              0.984,
                              0.984,
                              0.987,
                              0.987,
                              0.987,
                              0.992,
                              0.992,
                              0.992,
                              0.992,
                              0.995,
                              0.995,
                              0.995,
                              0.997,
                              0.997,
                              0.997,
                              1.0,
                              1.0,
                              1.0,
                              1.0
                          ],
                          "type": "line",
                          "name": "production",
                          "marker": {
                              "color": "red"
                          },
                          "shape": "spline"
                      }
                  ],
                  [
                      {
                          "y": [
                              0.3
                          ],
                          "type": "bar",
                          "name": "reference",
                          "marker": {
                              "color": "blue"
                          },
                          "width": "0.25"
                      },
                      {
                          "y": [
                              0.299
                          ],
                          "type": "bar",
                          "name": "production",
                          "marker": {
                              "color": "red"
                          },
                          "width": "0.25"
                      }
                  ]
              ]
          },
          {
              "title": "Driving_License",
              "status": "Not Detected",
              "pvalue": "1.0",
              "feat_imp": 0.1,
              "layout": [
                  {
                      "autosize": "false",
                      "margin": {
                          "l": 25,
                          "r": 12,
                          "b": 16,
                          "t": 14,
                          "pad": 0
                      },
                      "height": 240,
                      "width": 460,
                      "xaxis": {
                          "title": "categories"
                      },
                      "yaxis": {
                          "title": "counts"
                      },
                      "showlegend": "false",
                      "bargap": 0.05,
                      "barmode": "group"
                  }
              ],
              "data": [
                  [
                      {
                          "x": [
                              "0",
                              "1"
                          ],
                          "y": [
                              "90",
                              "45643"
                          ],
                          "type": "bar",
                          "name": "reference",
                          "marker": {
                              "color": "blue"
                          },
                          "width": "0.25"
                      },
                      {
                          "x": [
                              "0",
                              "1"
                          ],
                          "y": [
                              "24",
                              "11409"
                          ],
                          "type": "bar",
                          "name": "production",
                          "marker": {
                              "color": "red"
                          },
                          "width": "0.25"
                      }
                  ]
              ]
          },
          {
              "title": "Region_Code",
              "status": "Not Detected",
              "pvalue": "0.84",
              "feat_imp": 11.8,
              "layout": [
                  {
                      "autosize": "false",
                      "margin": {
                          "l": 25,
                          "r": 12,
                          "b": 16,
                          "t": 14,
                          "pad": 0
                      },
                      "height": 240,
                      "width": 460,
                      "xaxis": {
                          "title": "categories"
                      },
                      "yaxis": {
                          "title": "counts"
                      },
                      "showlegend": "false",
                      "bargap": 0.05,
                      "barmode": "group"
                  }
              ],
              "data": [
                  [
                      {
                          "x": [
                              "0",
                              "1",
                              "2",
                              "3",
                              "4",
                              "5",
                              "6",
                              "7",
                              "8",
                              "9",
                              "10",
                              "11",
                              "12",
                              "13",
                              "14",
                              "15",
                              "16",
                              "17",
                              "18",
                              "19",
                              "20",
                              "21",
                              "22",
                              "23",
                              "24",
                              "25",
                              "26",
                              "27",
                              "28",
                              "29",
                              "30",
                              "31",
                              "32",
                              "33",
                              "34",
                              "35",
                              "36",
                              "37",
                              "38",
                              "39",
                              "40",
                              "41",
                              "42",
                              "43",
                              "44",
                              "45",
                              "46",
                              "47",
                              "48",
                              "49",
                              "50",
                              "51",
                              "52"
                          ],
                          "y": [
                              "234",
                              "122",
                              "491",
                              "1084",
                              "219",
                              "140",
                              "762",
                              "381",
                              "4133",
                              "375",
                              "514",
                              "1088",
                              "387",
                              "513",
                              "565",
                              "1625",
                              "237",
                              "278",
                              "614",
                              "184",
                              "222",
                              "520",
                              "154",
                              "236",
                              "293",
                              "295",
                              "274",
                              "332",
                              "12783",
                              "1390",
                              "1473",
                              "237",
                              "323",
                              "935",
                              "216",
                              "783",
                              "1084",
                              "621",
                              "256",
                              "595",
                              "142",
                              "2216",
                              "67",
                              "331",
                              "102",
                              "674",
                              "2368",
                              "885",
                              "559",
                              "206",
                              "1150",
                              "24",
                              "41"
                          ],
                          "type": "bar",
                          "name": "reference",
                          "marker": {
                              "color": "blue"
                          },
                          "width": "0.25"
                      },
                      {
                          "x": [
                              "0",
                              "1",
                              "2",
                              "3",
                              "4",
                              "5",
                              "6",
                              "7",
                              "8",
                              "9",
                              "10",
                              "11",
                              "12",
                              "13",
                              "14",
                              "15",
                              "16",
                              "17",
                              "18",
                              "19",
                              "20",
                              "21",
                              "22",
                              "23",
                              "24",
                              "25",
                              "26",
                              "27",
                              "28",
                              "29",
                              "30",
                              "31",
                              "32",
                              "33",
                              "34",
                              "35",
                              "36",
                              "37",
                              "38",
                              "39",
                              "40",
                              "41",
                              "42",
                              "43",
                              "44",
                              "45",
                              "46",
                              "47",
                              "48",
                              "49",
                              "50",
                              "51",
                              "52"
                          ],
                          "y": [
                              "54",
                              "30",
                              "120",
                              "285",
                              "59",
                              "41",
                              "164",
                              "98",
                              "1052",
                              "102",
                              "148",
                              "274",
                              "86",
                              "120",
                              "130",
                              "394",
                              "59",
                              "84",
                              "173",
                              "46",
                              "49",
                              "146",
                              "31",
                              "62",
                              "63",
                              "79",
                              "82",
                              "77",
                              "3137",
                              "339",
                              "385",
                              "55",
                              "80",
                              "229",
                              "46",
                              "207",
                              "270",
                              "139",
                              "50",
                              "147",
                              "27",
                              "553",
                              "16",
                              "69",
                              "33",
                              "173",
                              "603",
                              "215",
                              "145",
                              "53",
                              "334",
                              "9",
                              "11"
                          ],
                          "type": "bar",
                          "name": "production",
                          "marker": {
                              "color": "red"
                          },
                          "width": "0.25"
                      }
                  ]
              ]
          },
          {
              "title": "Previously_Insured",
              "status": "Not Detected",
              "pvalue": "1.0",
              "feat_imp": 4.9,
              "layout": [
                  {
                      "autosize": "false",
                      "margin": {
                          "l": 25,
                          "r": 12,
                          "b": 16,
                          "t": 14,
                          "pad": 0
                      },
                      "height": 240,
                      "width": 460,
                      "xaxis": {
                          "title": "categories"
                      },
                      "yaxis": {
                          "title": "counts"
                      },
                      "showlegend": "false",
                      "bargap": 0.05,
                      "barmode": "group"
                  }
              ],
              "data": [
                  [
                      {
                          "x": [
                              "0",
                              "1"
                          ],
                          "y": [
                              "24771",
                              "20962"
                          ],
                          "type": "bar",
                          "name": "reference",
                          "marker": {
                              "color": "blue"
                          },
                          "width": "0.25"
                      },
                      {
                          "x": [
                              "0",
                              "1"
                          ],
                          "y": [
                              "6184",
                              "5249"
                          ],
                          "type": "bar",
                          "name": "production",
                          "marker": {
                              "color": "red"
                          },
                          "width": "0.25"
                      }
                  ]
              ]
          },
          {
              "title": "Vehicle_Age",
              "status": "Not Detected",
              "pvalue": "1.0",
              "feat_imp": 1.7,
              "layout": [
                  {
                      "autosize": "false",
                      "margin": {
                          "l": 25,
                          "r": 12,
                          "b": 16,
                          "t": 14,
                          "pad": 0
                      },
                      "height": 240,
                      "width": 460,
                      "xaxis": {
                          "title": "categories"
                      },
                      "yaxis": {
                          "title": "counts"
                      },
                      "showlegend": "false",
                      "bargap": 0.05,
                      "barmode": "group"
                  }
              ],
              "data": [
                  [
                      {
                          "x": [
                              "0",
                              "1",
                              "2"
                          ],
                          "y": [
                              "24061",
                              "19753",
                              "1919"
                          ],
                          "type": "bar",
                          "name": "reference",
                          "marker": {
                              "color": "blue"
                          },
                          "width": "0.25"
                      },
                      {
                          "x": [
                              "0",
                              "1",
                              "2"
                          ],
                          "y": [
                              "5982",
                              "4961",
                              "490"
                          ],
                          "type": "bar",
                          "name": "production",
                          "marker": {
                              "color": "red"
                          },
                          "width": "0.25"
                      }
                  ]
              ]
          },
          {
              "title": "Vehicle_Damage",
              "status": "Not Detected",
              "pvalue": "1.0",
              "feat_imp": 7.4,
              "layout": [
                  {
                      "autosize": "false",
                      "margin": {
                          "l": 25,
                          "r": 12,
                          "b": 16,
                          "t": 14,
                          "pad": 0
                      },
                      "height": 240,
                      "width": 460,
                      "xaxis": {
                          "title": "categories"
                      },
                      "yaxis": {
                          "title": "counts"
                      },
                      "showlegend": "false",
                      "bargap": 0.05,
                      "barmode": "group"
                  }
              ],
              "data": [
                  [
                      {
                          "x": [
                              "0",
                              "1"
                          ],
                          "y": [
                              "22543",
                              "23190"
                          ],
                          "type": "bar",
                          "name": "reference",
                          "marker": {
                              "color": "blue"
                          },
                          "width": "0.25"
                      },
                      {
                          "x": [
                              "0",
                              "1"
                          ],
                          "y": [
                              "5645",
                              "5788"
                          ],
                          "type": "bar",
                          "name": "production",
                          "marker": {
                              "color": "red"
                          },
                          "width": "0.25"
                      }
                  ]
              ]
          },
          {
              "title": "Annual_Premium",
              "status": "Not Detected",
              "pvalue": "0.28",
              "feat_imp": 22.6,
              "layout": [
                  {
                      "autosize": "false",
                      "margin": {
                          "l": 25,
                          "r": 12,
                          "b": 16,
                          "t": 14,
                          "pad": 0
                      },
                      "height": 240,
                      "width": 460,
                      "xaxis": {
                          "title": "bins"
                      },
                      "yaxis": {
                          "title": "pdf"
                      },
                      "showlegend": "false",
                      "barmode": "group"
                  },
                  {
                      "autosize": "false",
                      "margin": {
                          "l": 25,
                          "r": 12,
                          "b": 16,
                          "t": 14,
                          "pad": 0
                      },
                      "height": 240,
                      "width": 460,
                      "xaxis": {
                          "title": "bins"
                      },
                      "yaxis": {
                          "title": "cdf"
                      },
                      "showlegend": "false"
                  },
                  {
                      "autosize": "false",
                      "margin": {
                          "l": 25,
                          "r": 12,
                          "b": 16,
                          "t": 14,
                          "pad": 0
                      },
                      "height": 240,
                      "width": 360,
                      "xaxis": {
                          "title": "data"
                      },
                      "yaxis": {
                          "title": "mean"
                      },
                      "showlegend": "false"
                  }
              ],
              "data": [
                  [
                      {
                          "x": [
                              -1.936,
                              -1.281,
                              -0.626,
                              0.029,
                              0.684,
                              1.339,
                              1.994,
                              2.649,
                              3.304,
                              3.96,
                              4.615,
                              5.27,
                              5.925,
                              6.58,
                              7.235,
                              7.89,
                              8.545,
                              9.2,
                              9.855,
                              10.51,
                              11.165,
                              11.82,
                              12.475,
                              13.13,
                              13.785,
                              14.441,
                              15.096,
                              15.751,
                              16.406,
                              17.061,
                              17.716,
                              18.371,
                              19.026,
                              19.681,
                              20.336,
                              20.991,
                              21.646,
                              22.301,
                              22.956,
                              23.611,
                              24.266,
                              24.921,
                              25.577,
                              26.232,
                              26.887,
                              27.542,
                              28.197,
                              28.852,
                              29.507,
                              30.162,
                              30.817
                          ],
                          "y": [
                              0.168,
                              0.039,
                              0.31,
                              0.287,
                              0.126,
                              0.043,
                              0.016,
                              0.005,
                              0.002,
                              0.001,
                              0.001,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0
                          ],
                          "type": "lines",
                          "fill": "tozeroy",
                          "name": "reference",
                          "marker": {
                              "color": "blue"
                          }
                      },
                      {
                          "x": [
                              -1.936,
                              -1.49,
                              -1.045,
                              -0.599,
                              -0.154,
                              0.292,
                              0.737,
                              1.183,
                              1.628,
                              2.074,
                              2.519,
                              2.965,
                              3.41,
                              3.856,
                              4.301,
                              4.747,
                              5.192,
                              5.638,
                              6.083,
                              6.529,
                              6.974,
                              7.42,
                              7.865,
                              8.311,
                              8.756,
                              9.202,
                              9.648,
                              10.093,
                              10.539,
                              10.984,
                              11.43,
                              11.875,
                              12.321,
                              12.766,
                              13.212,
                              13.657,
                              14.103,
                              14.548,
                              14.994,
                              15.439,
                              15.885,
                              16.33,
                              16.776,
                              17.221,
                              17.667,
                              18.112,
                              18.558,
                              19.003,
                              19.449,
                              19.894,
                              20.34
                          ],
                          "y": [
                              0.172,
                              0.002,
                              0.045,
                              0.198,
                              0.243,
                              0.158,
                              0.094,
                              0.045,
                              0.021,
                              0.01,
                              0.005,
                              0.002,
                              0.002,
                              0.001,
                              0.001,
                              0.001,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0,
                              0.0
                          ],
                          "type": "lines",
                          "fill": "tozeroy",
                          "name": "production",
                          "marker": {
                              "color": "red"
                          }
                      }
                  ],
                  [
                      {
                          "x": [
                              -1.936,
                              -1.772,
                              -1.608,
                              -1.445,
                              -1.281,
                              -1.117,
                              -0.953,
                              -0.79,
                              -0.626,
                              -0.462,
                              -0.298,
                              -0.135,
                              0.029,
                              0.193,
                              0.357,
                              0.52,
                              0.684,
                              0.848,
                              1.012,
                              1.176,
                              1.339,
                              1.503,
                              1.667,
                              1.831,
                              1.994,
                              2.158,
                              2.322,
                              2.486,
                              2.649,
                              2.813,
                              2.977,
                              3.141,
                              3.304,
                              3.468,
                              3.632,
                              3.796,
                              3.96,
                              4.123,
                              4.287,
                              4.451,
                              4.615,
                              4.778,
                              4.942,
                              5.106,
                              5.27,
                              5.433,
                              5.597,
                              5.761,
                              5.925,
                              6.088,
                              6.252,
                              6.416,
                              6.58,
                              6.744,
                              6.907,
                              7.071,
                              7.235,
                              7.399,
                              7.562,
                              7.726,
                              7.89,
                              8.054,
                              8.217,
                              8.381,
                              8.545,
                              8.709,
                              8.872,
                              9.036,
                              9.2,
                              9.364,
                              9.528,
                              9.691,
                              9.855,
                              10.019,
                              10.183,
                              10.346,
                              10.51,
                              10.674,
                              10.838,
                              11.001,
                              11.165,
                              11.329,
                              11.493,
                              11.656,
                              11.82,
                              11.984,
                              12.148,
                              12.312,
                              12.475,
                              12.639,
                              12.803,
                              12.967,
                              13.13,
                              13.294,
                              13.458,
                              13.622,
                              13.785,
                              13.949,
                              14.113,
                              14.277,
                              14.441,
                              14.604,
                              14.768,
                              14.932,
                              15.096,
                              15.259,
                              15.423,
                              15.587,
                              15.751,
                              15.914,
                              16.078,
                              16.242,
                              16.406,
                              16.569,
                              16.733,
                              16.897,
                              17.061,
                              17.225,
                              17.388,
                              17.552,
                              17.716,
                              17.88,
                              18.043,
                              18.207,
                              18.371,
                              18.535,
                              18.698,
                              18.862,
                              19.026,
                              19.19,
                              19.353,
                              19.517,
                              19.681,
                              19.845,
                              20.009,
                              20.172,
                              20.336,
                              20.5,
                              20.664,
                              20.827,
                              20.991,
                              21.155,
                              21.319,
                              21.482,
                              21.646,
                              21.81,
                              21.974,
                              22.137,
                              22.301,
                              22.465,
                              22.629,
                              22.793,
                              22.956,
                              23.12,
                              23.284,
                              23.448,
                              23.611,
                              23.775,
                              23.939,
                              24.103,
                              24.266,
                              24.43,
                              24.594,
                              24.758,
                              24.921,
                              25.085,
                              25.249,
                              25.413,
                              25.577,
                              25.74,
                              25.904,
                              26.068,
                              26.232,
                              26.395,
                              26.559,
                              26.723,
                              26.887,
                              27.05,
                              27.214,
                              27.378,
                              27.542,
                              27.705,
                              27.869,
                              28.033,
                              28.197,
                              28.361,
                              28.524,
                              28.688,
                              28.852,
                              29.016,
                              29.179,
                              29.343,
                              29.507,
                              29.671,
                              29.834,
                              29.998,
                              30.162,
                              30.326,
                              30.489,
                              30.653,
                              30.817
                          ],
                          "y": [
                              0.168,
                              0.168,
                              0.168,
                              0.168,
                              0.168,
                              0.172,
                              0.182,
                              0.207,
                              0.256,
                              0.33,
                              0.422,
                              0.517,
                              0.605,
                              0.684,
                              0.751,
                              0.804,
                              0.847,
                              0.882,
                              0.909,
                              0.93,
                              0.946,
                              0.957,
                              0.966,
                              0.973,
                              0.978,
                              0.982,
                              0.986,
                              0.989,
                              0.991,
                              0.993,
                              0.994,
                              0.994,
                              0.995,
                              0.996,
                              0.996,
                              0.997,
                              0.997,
                              0.998,
                              0.998,
                              0.998,
                              0.999,
                              0.999,
                              0.999,
                              0.999,
                              0.999,
                              0.999,
                              0.999,
                              0.999,
                              0.999,
                              0.999,
                              0.999,
                              0.999,
                              0.999,
                              0.999,
                              0.999,
                              0.999,
                              0.999,
                              0.999,
                              0.999,
                              0.999,
                              0.999,
                              0.999,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0
                          ],
                          "type": "line",
                          "name": "reference",
                          "marker": {
                              "color": "blue"
                          },
                          "shape": "spline"
                      },
                      {
                          "x": [
                              -1.936,
                              -1.825,
                              -1.713,
                              -1.602,
                              -1.49,
                              -1.379,
                              -1.268,
                              -1.156,
                              -1.045,
                              -0.934,
                              -0.822,
                              -0.711,
                              -0.599,
                              -0.488,
                              -0.377,
                              -0.265,
                              -0.154,
                              -0.043,
                              0.069,
                              0.18,
                              0.292,
                              0.403,
                              0.514,
                              0.626,
                              0.737,
                              0.849,
                              0.96,
                              1.071,
                              1.183,
                              1.294,
                              1.405,
                              1.517,
                              1.628,
                              1.74,
                              1.851,
                              1.962,
                              2.074,
                              2.185,
                              2.296,
                              2.408,
                              2.519,
                              2.631,
                              2.742,
                              2.853,
                              2.965,
                              3.076,
                              3.187,
                              3.299,
                              3.41,
                              3.522,
                              3.633,
                              3.744,
                              3.856,
                              3.967,
                              4.079,
                              4.19,
                              4.301,
                              4.413,
                              4.524,
                              4.635,
                              4.747,
                              4.858,
                              4.97,
                              5.081,
                              5.192,
                              5.304,
                              5.415,
                              5.526,
                              5.638,
                              5.749,
                              5.861,
                              5.972,
                              6.083,
                              6.195,
                              6.306,
                              6.417,
                              6.529,
                              6.64,
                              6.752,
                              6.863,
                              6.974,
                              7.086,
                              7.197,
                              7.309,
                              7.42,
                              7.531,
                              7.643,
                              7.754,
                              7.865,
                              7.977,
                              8.088,
                              8.2,
                              8.311,
                              8.422,
                              8.534,
                              8.645,
                              8.756,
                              8.868,
                              8.979,
                              9.091,
                              9.202,
                              9.313,
                              9.425,
                              9.536,
                              9.648,
                              9.759,
                              9.87,
                              9.982,
                              10.093,
                              10.204,
                              10.316,
                              10.427,
                              10.539,
                              10.65,
                              10.761,
                              10.873,
                              10.984,
                              11.095,
                              11.207,
                              11.318,
                              11.43,
                              11.541,
                              11.652,
                              11.764,
                              11.875,
                              11.986,
                              12.098,
                              12.209,
                              12.321,
                              12.432,
                              12.543,
                              12.655,
                              12.766,
                              12.878,
                              12.989,
                              13.1,
                              13.212,
                              13.323,
                              13.434,
                              13.546,
                              13.657,
                              13.769,
                              13.88,
                              13.991,
                              14.103,
                              14.214,
                              14.325,
                              14.437,
                              14.548,
                              14.66,
                              14.771,
                              14.882,
                              14.994,
                              15.105,
                              15.217,
                              15.328,
                              15.439,
                              15.551,
                              15.662,
                              15.773,
                              15.885,
                              15.996,
                              16.108,
                              16.219,
                              16.33,
                              16.442,
                              16.553,
                              16.664,
                              16.776,
                              16.887,
                              16.999,
                              17.11,
                              17.221,
                              17.333,
                              17.444,
                              17.555,
                              17.667,
                              17.778,
                              17.89,
                              18.001,
                              18.112,
                              18.224,
                              18.335,
                              18.447,
                              18.558,
                              18.669,
                              18.781,
                              18.892,
                              19.003,
                              19.115,
                              19.226,
                              19.338,
                              19.449,
                              19.56,
                              19.672,
                              19.783,
                              19.894,
                              20.006,
                              20.117,
                              20.229,
                              20.34
                          ],
                          "y": [
                              0.172,
                              0.172,
                              0.172,
                              0.172,
                              0.172,
                              0.172,
                              0.172,
                              0.174,
                              0.177,
                              0.184,
                              0.196,
                              0.219,
                              0.253,
                              0.301,
                              0.355,
                              0.418,
                              0.477,
                              0.543,
                              0.603,
                              0.66,
                              0.707,
                              0.75,
                              0.785,
                              0.819,
                              0.846,
                              0.872,
                              0.894,
                              0.912,
                              0.928,
                              0.94,
                              0.95,
                              0.957,
                              0.964,
                              0.971,
                              0.974,
                              0.977,
                              0.98,
                              0.983,
                              0.985,
                              0.987,
                              0.989,
                              0.99,
                              0.991,
                              0.992,
                              0.993,
                              0.993,
                              0.994,
                              0.995,
                              0.995,
                              0.995,
                              0.996,
                              0.996,
                              0.997,
                              0.997,
                              0.997,
                              0.997,
                              0.998,
                              0.998,
                              0.998,
                              0.998,
                              0.998,
                              0.998,
                              0.999,
                              0.999,
                              0.999,
                              0.999,
                              0.999,
                              0.999,
                              0.999,
                              0.999,
                              0.999,
                              0.999,
                              0.999,
                              0.999,
                              0.999,
                              0.999,
                              0.999,
                              0.999,
                              0.999,
                              0.999,
                              0.999,
                              0.999,
                              0.999,
                              0.999,
                              0.999,
                              0.999,
                              0.999,
                              0.999,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0,
                              1.0
                          ],
                          "type": "line",
                          "name": "production",
                          "marker": {
                              "color": "red"
                          },
                          "shape": "spline"
                      }
                  ],
                  [
                      {
                          "y": [
                              -0.071
                          ],
                          "type": "bar",
                          "name": "reference",
                          "marker": {
                              "color": "blue"
                          },
                          "width": "0.25"
                      },
                      {
                          "y": [
                              -0.086
                          ],
                          "type": "bar",
                          "name": "production",
                          "marker": {
                              "color": "red"
                          },
                          "width": "0.25"
                      }
                  ]
              ]
          },
          {
              "title": "Policy_Sales_Channel",
              "status": "Not Detected",
              "pvalue": "0.89",
              "feat_imp": 8.2,
              "layout": [
                  {
                      "autosize": "false",
                      "margin": {
                          "l": 25,
                          "r": 12,
                          "b": 16,
                          "t": 14,
                          "pad": 0
                      },
                      "height": 240,
                      "width": 460,
                      "xaxis": {
                          "title": "categories"
                      },
                      "yaxis": {
                          "title": "counts"
                      },
                      "showlegend": "false",
                      "bargap": 0.05,
                      "barmode": "group"
                  }
              ],
              "data": [
                  [
                      {
                          "x": [
                              "1",
                              "3",
                              "4",
                              "7",
                              "8",
                              "9",
                              "10",
                              "11",
                              "12",
                              "13",
                              "14",
                              "15",
                              "16",
                              "17",
                              "18",
                              "19",
                              "20",
                              "21",
                              "22",
                              "23",
                              "24",
                              "25",
                              "26",
                              "29",
                              "30",
                              "31",
                              "32",
                              "33",
                              "34",
                              "35",
                              "36",
                              "37",
                              "38",
                              "39",
                              "40",
                              "41",
                              "42",
                              "44",
                              "45",
                              "46",
                              "47",
                              "48",
                              "49",
                              "51",
                              "52",
                              "53",
                              "54",
                              "55",
                              "56",
                              "57",
                              "58",
                              "59",
                              "60",
                              "61",
                              "63",
                              "64",
                              "65",
                              "66",
                              "67",
                              "69",
                              "70",
                              "73",
                              "78",
                              "79",
                              "80",
                              "81",
                              "83",
                              "86",
                              "87",
                              "88",
                              "89",
                              "90",
                              "91",
                              "92",
                              "93",
                              "94",
                              "95",
                              "96",
                              "97",
                              "98",
                              "99",
                              "101",
                              "103",
                              "104",
                              "106",
                              "107",
                              "108",
                              "109",
                              "110",
                              "111",
                              "113",
                              "114",
                              "115",
                              "116",
                              "117",
                              "118",
                              "119",
                              "120",
                              "121",
                              "122",
                              "124",
                              "125",
                              "127",
                              "128",
                              "129",
                              "130",
                              "131",
                              "132",
                              "133",
                              "134",
                              "135",
                              "136",
                              "137",
                              "138",
                              "139",
                              "140",
                              "143",
                              "145",
                              "146",
                              "147",
                              "148",
                              "150",
                              "151",
                              "152",
                              "153",
                              "154",
                              "155",
                              "156",
                              "157",
                              "158",
                              "159",
                              "160",
                              "163"
                          ],
                          "y": [
                              "127",
                              "57",
                              "68",
                              "207",
                              "182",
                              "15",
                              "32",
                              "131",
                              "83",
                              "220",
                              "78",
                              "112",
                              "77",
                              "2",
                              "20",
                              "29",
                              "4",
                              "19",
                              "35",
                              "54",
                              "81",
                              "217",
                              "9783",
                              "96",
                              "169",
                              "80",
                              "1",
                              "1",
                              "1",
                              "9",
                              "8",
                              "24",
                              "1",
                              "1",
                              "1",
                              "1",
                              "13",
                              "13",
                              "8",
                              "1",
                              "10",
                              "4",
                              "1",
                              "2",
                              "117",
                              "6",
                              "12",
                              "173",
                              "8",
                              "1",
                              "3",
                              "19",
                              "55",
                              "66",
                              "2",
                              "6",
                              "7",
                              "1",
                              "2",
                              "0",
                              "1",
                              "4",
                              "1",
                              "1",
                              "2",
                              "2",
                              "1",
                              "4",
                              "1",
                              "4",
                              "0",
                              "2",
                              "13",
                              "2",
                              "3",
                              "10",
                              "2",
                              "0",
                              "3",
                              "2",
                              "1",
                              "3",
                              "8",
                              "1",
                              "4",
                              "3",
                              "3",
                              "15",
                              "1",
                              "5",
                              "14",
                              "4",
                              "0",
                              "19",
                              "1",
                              "1",
                              "14",
                              "97",
                              "5",
                              "1201",
                              "8750",
                              "124",
                              "14",
                              "14",
                              "1",
                              "2",
                              "16",
                              "9",
                              "10",
                              "1",
                              "12",
                              "28",
                              "1",
                              "15",
                              "15",
                              "9",
                              "1",
                              "26",
                              "2",
                              "21",
                              "15",
                              "31",
                              "457",
                              "16131",
                              "65",
                              "710",
                              "155",
                              "1231",
                              "789",
                              "61",
                              "3",
                              "2662",
                              "338"
                          ],
                          "type": "bar",
                          "name": "reference",
                          "marker": {
                              "color": "blue"
                          },
                          "width": "0.25"
                      },
                      {
                          "x": [
                              "1",
                              "3",
                              "4",
                              "7",
                              "8",
                              "9",
                              "10",
                              "11",
                              "12",
                              "13",
                              "14",
                              "15",
                              "16",
                              "17",
                              "18",
                              "19",
                              "20",
                              "21",
                              "22",
                              "23",
                              "24",
                              "25",
                              "26",
                              "29",
                              "30",
                              "31",
                              "32",
                              "33",
                              "34",
                              "35",
                              "36",
                              "37",
                              "38",
                              "39",
                              "40",
                              "41",
                              "42",
                              "44",
                              "45",
                              "46",
                              "47",
                              "48",
                              "49",
                              "51",
                              "52",
                              "53",
                              "54",
                              "55",
                              "56",
                              "57",
                              "58",
                              "59",
                              "60",
                              "61",
                              "63",
                              "64",
                              "65",
                              "66",
                              "67",
                              "69",
                              "70",
                              "73",
                              "78",
                              "79",
                              "80",
                              "81",
                              "83",
                              "86",
                              "87",
                              "88",
                              "89",
                              "90",
                              "91",
                              "92",
                              "93",
                              "94",
                              "95",
                              "96",
                              "97",
                              "98",
                              "99",
                              "101",
                              "103",
                              "104",
                              "106",
                              "107",
                              "108",
                              "109",
                              "110",
                              "111",
                              "113",
                              "114",
                              "115",
                              "116",
                              "117",
                              "118",
                              "119",
                              "120",
                              "121",
                              "122",
                              "124",
                              "125",
                              "127",
                              "128",
                              "129",
                              "130",
                              "131",
                              "132",
                              "133",
                              "134",
                              "135",
                              "136",
                              "137",
                              "138",
                              "139",
                              "140",
                              "143",
                              "145",
                              "146",
                              "147",
                              "148",
                              "150",
                              "151",
                              "152",
                              "153",
                              "154",
                              "155",
                              "156",
                              "157",
                              "158",
                              "159",
                              "160",
                              "163"
                          ],
                          "y": [
                              "37",
                              "12",
                              "23",
                              "50",
                              "49",
                              "5",
                              "9",
                              "28",
                              "30",
                              "60",
                              "17",
                              "24",
                              "16",
                              "0",
                              "8",
                              "7",
                              "1",
                              "4",
                              "16",
                              "15",
                              "27",
                              "53",
                              "2419",
                              "25",
                              "39",
                              "21",
                              "1",
                              "1",
                              "0",
                              "3",
                              "1",
                              "5",
                              "0",
                              "0",
                              "0",
                              "0",
                              "2",
                              "1",
                              "4",
                              "1",
                              "5",
                              "0",
                              "2",
                              "0",
                              "33",
                              "2",
                              "6",
                              "34",
                              "1",
                              "1",
                              "0",
                              "6",
                              "18",
                              "9",
                              "0",
                              "1",
                              "4",
                              "1",
                              "0",
                              "1",
                              "0",
                              "0",
                              "0",
                              "0",
                              "0",
                              "1",
                              "0",
                              "1",
                              "1",
                              "1",
                              "2",
                              "1",
                              "8",
                              "2",
                              "0",
                              "1",
                              "0",
                              "1",
                              "0",
                              "0",
                              "0",
                              "0",
                              "3",
                              "0",
                              "2",
                              "0",
                              "1",
                              "4",
                              "0",
                              "4",
                              "1",
                              "0",
                              "1",
                              "2",
                              "0",
                              "2",
                              "6",
                              "16",
                              "0",
                              "292",
                              "2135",
                              "30",
                              "3",
                              "6",
                              "2",
                              "1",
                              "2",
                              "3",
                              "2",
                              "1",
                              "2",
                              "4",
                              "0",
                              "6",
                              "6",
                              "0",
                              "0",
                              "2",
                              "1",
                              "11",
                              "2",
                              "6",
                              "123",
                              "4051",
                              "20",
                              "186",
                              "39",
                              "312",
                              "202",
                              "22",
                              "0",
                              "671",
                              "91"
                          ],
                          "type": "bar",
                          "name": "production",
                          "marker": {
                              "color": "red"
                          },
                          "width": "0.25"
                      }
                  ]
              ]
          },
          {
              "title": "Vintage",
              "status": "Not Detected",
              "pvalue": "0.37",
              "feat_imp": 24.6,
              "layout": [
                  {
                      "autosize": "false",
                      "margin": {
                          "l": 25,
                          "r": 12,
                          "b": 16,
                          "t": 14,
                          "pad": 0
                      },
                      "height": 240,
                      "width": 460,
                      "xaxis": {
                          "title": "bins"
                      },
                      "yaxis": {
                          "title": "pdf"
                      },
                      "showlegend": "false",
                      "barmode": "group"
                  },
                  {
                      "autosize": "false",
                      "margin": {
                          "l": 25,
                          "r": 12,
                          "b": 16,
                          "t": 14,
                          "pad": 0
                      },
                      "height": 240,
                      "width": 460,
                      "xaxis": {
                          "title": "bins"
                      },
                      "yaxis": {
                          "title": "cdf"
                      },
                      "showlegend": "false"
                  },
                  {
                      "autosize": "false",
                      "margin": {
                          "l": 25,
                          "r": 12,
                          "b": 16,
                          "t": 14,
                          "pad": 0
                      },
                      "height": 240,
                      "width": 360,
                      "xaxis": {
                          "title": "data"
                      },
                      "yaxis": {
                          "title": "mean"
                      },
                      "showlegend": "false"
                  }
              ],
              "data": [
                  [
                      {
                          "x": [
                              -0.986,
                              -0.946,
                              -0.907,
                              -0.867,
                              -0.828,
                              -0.788,
                              -0.749,
                              -0.709,
                              -0.669,
                              -0.63,
                              -0.59,
                              -0.551,
                              -0.511,
                              -0.471,
                              -0.432,
                              -0.392,
                              -0.353,
                              -0.313,
                              -0.274,
                              -0.234,
                              -0.194,
                              -0.155,
                              -0.115,
                              -0.076,
                              -0.036,
                              0.004,
                              0.043,
                              0.083,
                              0.122,
                              0.162,
                              0.201,
                              0.241,
                              0.281,
                              0.32,
                              0.36,
                              0.399,
                              0.439,
                              0.478,
                              0.518,
                              0.558,
                              0.597,
                              0.637,
                              0.676,
                              0.716,
                              0.756,
                              0.795,
                              0.835,
                              0.874,
                              0.914,
                              0.953,
                              0.993
                          ],
                          "y": [
                              0.02,
                              0.02,
                              0.02,
                              0.022,
                              0.018,
                              0.022,
                              0.02,
                              0.021,
                              0.021,
                              0.017,
                              0.021,
                              0.021,
                              0.022,
                              0.021,
                              0.017,
                              0.021,
                              0.02,
                              0.02,
                              0.018,
                              0.02,
                              0.02,
                              0.02,
                              0.017,
                              0.02,
                              0.02,
                              0.021,
                              0.02,
                              0.018,
                              0.02,
                              0.02,
                              0.021,
                              0.018,
                              0.021,
                              0.02,
                              0.02,
                              0.02,
                              0.018,
                              0.021,
                              0.021,
                              0.02,
                              0.017,
                              0.021,
                              0.021,
                              0.02,
                              0.02,
                              0.017,
                              0.02,
                              0.021,
                              0.021,
                              0.021
                          ],
                          "type": "lines",
                          "fill": "tozeroy",
                          "name": "reference",
                          "marker": {
                              "color": "blue"
                          }
                      },
                      {
                          "x": [
                              -0.986,
                              -0.946,
                              -0.907,
                              -0.867,
                              -0.828,
                              -0.788,
                              -0.749,
                              -0.709,
                              -0.669,
                              -0.63,
                              -0.59,
                              -0.551,
                              -0.511,
                              -0.471,
                              -0.432,
                              -0.392,
                              -0.353,
                              -0.313,
                              -0.274,
                              -0.234,
                              -0.194,
                              -0.155,
                              -0.115,
                              -0.076,
                              -0.036,
                              0.004,
                              0.043,
                              0.083,
                              0.122,
                              0.162,
                              0.201,
                              0.241,
                              0.281,
                              0.32,
                              0.36,
                              0.399,
                              0.439,
                              0.478,
                              0.518,
                              0.558,
                              0.597,
                              0.637,
                              0.676,
                              0.716,
                              0.756,
                              0.795,
                              0.835,
                              0.874,
                              0.914,
                              0.953,
                              0.993
                          ],
                          "y": [
                              0.021,
                              0.019,
                              0.023,
                              0.02,
                              0.018,
                              0.021,
                              0.02,
                              0.021,
                              0.021,
                              0.016,
                              0.021,
                              0.02,
                              0.021,
                              0.02,
                              0.018,
                              0.022,
                              0.019,
                              0.02,
                              0.017,
                              0.022,
                              0.023,
                              0.021,
                              0.017,
                              0.022,
                              0.021,
                              0.022,
                              0.022,
                              0.018,
                              0.017,
                              0.022,
                              0.019,
                              0.018,
                              0.021,
                              0.02,
                              0.02,
                              0.02,
                              0.018,
                              0.02,
                              0.021,
                              0.022,
                              0.017,
                              0.02,
                              0.022,
                              0.02,
                              0.018,
                              0.019,
                              0.018,
                              0.021,
                              0.022,
                              0.023
                          ],
                          "type": "lines",
                          "fill": "tozeroy",
                          "name": "production",
                          "marker": {
                              "color": "red"
                          }
                      }
                  ],
                  [
                      {
                          "x": [
                              -0.986,
                              -0.976,
                              -0.966,
                              -0.956,
                              -0.946,
                              -0.937,
                              -0.927,
                              -0.917,
                              -0.907,
                              -0.897,
                              -0.887,
                              -0.877,
                              -0.867,
                              -0.857,
                              -0.847,
                              -0.838,
                              -0.828,
                              -0.818,
                              -0.808,
                              -0.798,
                              -0.788,
                              -0.778,
                              -0.768,
                              -0.758,
                              -0.749,
                              -0.739,
                              -0.729,
                              -0.719,
                              -0.709,
                              -0.699,
                              -0.689,
                              -0.679,
                              -0.669,
                              -0.659,
                              -0.65,
                              -0.64,
                              -0.63,
                              -0.62,
                              -0.61,
                              -0.6,
                              -0.59,
                              -0.58,
                              -0.57,
                              -0.561,
                              -0.551,
                              -0.541,
                              -0.531,
                              -0.521,
                              -0.511,
                              -0.501,
                              -0.491,
                              -0.481,
                              -0.471,
                              -0.462,
                              -0.452,
                              -0.442,
                              -0.432,
                              -0.422,
                              -0.412,
                              -0.402,
                              -0.392,
                              -0.382,
                              -0.373,
                              -0.363,
                              -0.353,
                              -0.343,
                              -0.333,
                              -0.323,
                              -0.313,
                              -0.303,
                              -0.293,
                              -0.283,
                              -0.274,
                              -0.264,
                              -0.254,
                              -0.244,
                              -0.234,
                              -0.224,
                              -0.214,
                              -0.204,
                              -0.194,
                              -0.185,
                              -0.175,
                              -0.165,
                              -0.155,
                              -0.145,
                              -0.135,
                              -0.125,
                              -0.115,
                              -0.105,
                              -0.095,
                              -0.086,
                              -0.076,
                              -0.066,
                              -0.056,
                              -0.046,
                              -0.036,
                              -0.026,
                              -0.016,
                              -0.006,
                              0.004,
                              0.013,
                              0.023,
                              0.033,
                              0.043,
                              0.053,
                              0.063,
                              0.073,
                              0.083,
                              0.093,
                              0.102,
                              0.112,
                              0.122,
                              0.132,
                              0.142,
                              0.152,
                              0.162,
                              0.172,
                              0.182,
                              0.192,
                              0.201,
                              0.211,
                              0.221,
                              0.231,
                              0.241,
                              0.251,
                              0.261,
                              0.271,
                              0.281,
                              0.29,
                              0.3,
                              0.31,
                              0.32,
                              0.33,
                              0.34,
                              0.35,
                              0.36,
                              0.37,
                              0.38,
                              0.389,
                              0.399,
                              0.409,
                              0.419,
                              0.429,
                              0.439,
                              0.449,
                              0.459,
                              0.469,
                              0.478,
                              0.488,
                              0.498,
                              0.508,
                              0.518,
                              0.528,
                              0.538,
                              0.548,
                              0.558,
                              0.568,
                              0.577,
                              0.587,
                              0.597,
                              0.607,
                              0.617,
                              0.627,
                              0.637,
                              0.647,
                              0.657,
                              0.666,
                              0.676,
                              0.686,
                              0.696,
                              0.706,
                              0.716,
                              0.726,
                              0.736,
                              0.746,
                              0.756,
                              0.765,
                              0.775,
                              0.785,
                              0.795,
                              0.805,
                              0.815,
                              0.825,
                              0.835,
                              0.845,
                              0.854,
                              0.864,
                              0.874,
                              0.884,
                              0.894,
                              0.904,
                              0.914,
                              0.924,
                              0.934,
                              0.944,
                              0.953,
                              0.963,
                              0.973,
                              0.983,
                              0.993
                          ],
                          "y": [
                              0.007,
                              0.01,
                              0.017,
                              0.02,
                              0.027,
                              0.03,
                              0.037,
                              0.04,
                              0.047,
                              0.05,
                              0.054,
                              0.061,
                              0.064,
                              0.072,
                              0.076,
                              0.083,
                              0.086,
                              0.094,
                              0.097,
                              0.101,
                              0.108,
                              0.112,
                              0.12,
                              0.123,
                              0.129,
                              0.133,
                              0.14,
                              0.143,
                              0.146,
                              0.153,
                              0.157,
                              0.164,
                              0.167,
                              0.174,
                              0.177,
                              0.184,
                              0.188,
                              0.195,
                              0.198,
                              0.202,
                              0.208,
                              0.212,
                              0.219,
                              0.223,
                              0.23,
                              0.233,
                              0.241,
                              0.244,
                              0.248,
                              0.255,
                              0.259,
                              0.267,
                              0.27,
                              0.277,
                              0.28,
                              0.287,
                              0.29,
                              0.294,
                              0.301,
                              0.304,
                              0.311,
                              0.314,
                              0.322,
                              0.325,
                              0.329,
                              0.336,
                              0.339,
                              0.346,
                              0.349,
                              0.356,
                              0.359,
                              0.366,
                              0.369,
                              0.373,
                              0.38,
                              0.384,
                              0.39,
                              0.394,
                              0.4,
                              0.404,
                              0.411,
                              0.414,
                              0.417,
                              0.424,
                              0.427,
                              0.434,
                              0.437,
                              0.444,
                              0.448,
                              0.454,
                              0.458,
                              0.461,
                              0.468,
                              0.471,
                              0.478,
                              0.481,
                              0.488,
                              0.491,
                              0.497,
                              0.501,
                              0.504,
                              0.511,
                              0.514,
                              0.522,
                              0.525,
                              0.532,
                              0.535,
                              0.542,
                              0.546,
                              0.549,
                              0.556,
                              0.56,
                              0.567,
                              0.57,
                              0.577,
                              0.58,
                              0.587,
                              0.59,
                              0.593,
                              0.601,
                              0.604,
                              0.611,
                              0.614,
                              0.621,
                              0.625,
                              0.632,
                              0.636,
                              0.639,
                              0.646,
                              0.65,
                              0.657,
                              0.66,
                              0.667,
                              0.671,
                              0.678,
                              0.681,
                              0.684,
                              0.691,
                              0.694,
                              0.701,
                              0.704,
                              0.71,
                              0.714,
                              0.721,
                              0.725,
                              0.728,
                              0.735,
                              0.739,
                              0.745,
                              0.749,
                              0.756,
                              0.76,
                              0.767,
                              0.771,
                              0.774,
                              0.781,
                              0.785,
                              0.791,
                              0.795,
                              0.802,
                              0.805,
                              0.811,
                              0.815,
                              0.819,
                              0.826,
                              0.829,
                              0.836,
                              0.84,
                              0.847,
                              0.85,
                              0.857,
                              0.861,
                              0.865,
                              0.871,
                              0.874,
                              0.881,
                              0.884,
                              0.89,
                              0.894,
                              0.901,
                              0.904,
                              0.907,
                              0.914,
                              0.918,
                              0.924,
                              0.927,
                              0.934,
                              0.937,
                              0.945,
                              0.949,
                              0.952,
                              0.958,
                              0.962,
                              0.968,
                              0.972,
                              0.979,
                              0.982,
                              0.99,
                              0.993,
                              1.0
                          ],
                          "type": "line",
                          "name": "reference",
                          "marker": {
                              "color": "blue"
                          },
                          "shape": "spline"
                      },
                      {
                          "x": [
                              -0.986,
                              -0.976,
                              -0.966,
                              -0.956,
                              -0.946,
                              -0.937,
                              -0.927,
                              -0.917,
                              -0.907,
                              -0.897,
                              -0.887,
                              -0.877,
                              -0.867,
                              -0.857,
                              -0.847,
                              -0.838,
                              -0.828,
                              -0.818,
                              -0.808,
                              -0.798,
                              -0.788,
                              -0.778,
                              -0.768,
                              -0.758,
                              -0.749,
                              -0.739,
                              -0.729,
                              -0.719,
                              -0.709,
                              -0.699,
                              -0.689,
                              -0.679,
                              -0.669,
                              -0.659,
                              -0.65,
                              -0.64,
                              -0.63,
                              -0.62,
                              -0.61,
                              -0.6,
                              -0.59,
                              -0.58,
                              -0.57,
                              -0.561,
                              -0.551,
                              -0.541,
                              -0.531,
                              -0.521,
                              -0.511,
                              -0.501,
                              -0.491,
                              -0.481,
                              -0.471,
                              -0.462,
                              -0.452,
                              -0.442,
                              -0.432,
                              -0.422,
                              -0.412,
                              -0.402,
                              -0.392,
                              -0.382,
                              -0.373,
                              -0.363,
                              -0.353,
                              -0.343,
                              -0.333,
                              -0.323,
                              -0.313,
                              -0.303,
                              -0.293,
                              -0.283,
                              -0.274,
                              -0.264,
                              -0.254,
                              -0.244,
                              -0.234,
                              -0.224,
                              -0.214,
                              -0.204,
                              -0.194,
                              -0.185,
                              -0.175,
                              -0.165,
                              -0.155,
                              -0.145,
                              -0.135,
                              -0.125,
                              -0.115,
                              -0.105,
                              -0.095,
                              -0.086,
                              -0.076,
                              -0.066,
                              -0.056,
                              -0.046,
                              -0.036,
                              -0.026,
                              -0.016,
                              -0.006,
                              0.004,
                              0.013,
                              0.023,
                              0.033,
                              0.043,
                              0.053,
                              0.063,
                              0.073,
                              0.083,
                              0.093,
                              0.102,
                              0.112,
                              0.122,
                              0.132,
                              0.142,
                              0.152,
                              0.162,
                              0.172,
                              0.182,
                              0.192,
                              0.201,
                              0.211,
                              0.221,
                              0.231,
                              0.241,
                              0.251,
                              0.261,
                              0.271,
                              0.281,
                              0.29,
                              0.3,
                              0.31,
                              0.32,
                              0.33,
                              0.34,
                              0.35,
                              0.36,
                              0.37,
                              0.38,
                              0.389,
                              0.399,
                              0.409,
                              0.419,
                              0.429,
                              0.439,
                              0.449,
                              0.459,
                              0.469,
                              0.478,
                              0.488,
                              0.498,
                              0.508,
                              0.518,
                              0.528,
                              0.538,
                              0.548,
                              0.558,
                              0.568,
                              0.577,
                              0.587,
                              0.597,
                              0.607,
                              0.617,
                              0.627,
                              0.637,
                              0.647,
                              0.657,
                              0.666,
                              0.676,
                              0.686,
                              0.696,
                              0.706,
                              0.716,
                              0.726,
                              0.736,
                              0.746,
                              0.756,
                              0.765,
                              0.775,
                              0.785,
                              0.795,
                              0.805,
                              0.815,
                              0.825,
                              0.835,
                              0.845,
                              0.854,
                              0.864,
                              0.874,
                              0.884,
                              0.894,
                              0.904,
                              0.914,
                              0.924,
                              0.934,
                              0.944,
                              0.953,
                              0.963,
                              0.973,
                              0.983,
                              0.993
                          ],
                          "y": [
                              0.007,
                              0.01,
                              0.017,
                              0.021,
                              0.028,
                              0.03,
                              0.035,
                              0.04,
                              0.048,
                              0.052,
                              0.055,
                              0.062,
                              0.066,
                              0.073,
                              0.076,
                              0.083,
                              0.086,
                              0.093,
                              0.097,
                              0.1,
                              0.108,
                              0.111,
                              0.117,
                              0.121,
                              0.128,
                              0.131,
                              0.138,
                              0.141,
                              0.144,
                              0.152,
                              0.155,
                              0.162,
                              0.165,
                              0.172,
                              0.176,
                              0.182,
                              0.185,
                              0.192,
                              0.195,
                              0.198,
                              0.206,
                              0.21,
                              0.216,
                              0.219,
                              0.225,
                              0.229,
                              0.236,
                              0.239,
                              0.242,
                              0.248,
                              0.253,
                              0.26,
                              0.263,
                              0.27,
                              0.273,
                              0.279,
                              0.283,
                              0.286,
                              0.294,
                              0.297,
                              0.304,
                              0.308,
                              0.316,
                              0.319,
                              0.323,
                              0.329,
                              0.332,
                              0.337,
                              0.341,
                              0.347,
                              0.35,
                              0.357,
                              0.361,
                              0.364,
                              0.371,
                              0.375,
                              0.383,
                              0.387,
                              0.392,
                              0.396,
                              0.404,
                              0.408,
                              0.411,
                              0.419,
                              0.423,
                              0.431,
                              0.435,
                              0.441,
                              0.444,
                              0.45,
                              0.454,
                              0.458,
                              0.465,
                              0.469,
                              0.476,
                              0.48,
                              0.488,
                              0.491,
                              0.497,
                              0.501,
                              0.505,
                              0.512,
                              0.516,
                              0.523,
                              0.526,
                              0.534,
                              0.537,
                              0.544,
                              0.549,
                              0.552,
                              0.559,
                              0.563,
                              0.568,
                              0.571,
                              0.576,
                              0.579,
                              0.587,
                              0.59,
                              0.594,
                              0.601,
                              0.604,
                              0.612,
                              0.615,
                              0.62,
                              0.623,
                              0.631,
                              0.634,
                              0.638,
                              0.644,
                              0.648,
                              0.656,
                              0.658,
                              0.665,
                              0.668,
                              0.675,
                              0.678,
                              0.681,
                              0.688,
                              0.692,
                              0.698,
                              0.701,
                              0.707,
                              0.71,
                              0.718,
                              0.722,
                              0.725,
                              0.733,
                              0.737,
                              0.743,
                              0.747,
                              0.753,
                              0.757,
                              0.764,
                              0.767,
                              0.77,
                              0.778,
                              0.781,
                              0.788,
                              0.791,
                              0.8,
                              0.803,
                              0.81,
                              0.814,
                              0.817,
                              0.823,
                              0.827,
                              0.834,
                              0.838,
                              0.845,
                              0.848,
                              0.855,
                              0.859,
                              0.862,
                              0.869,
                              0.873,
                              0.879,
                              0.882,
                              0.888,
                              0.891,
                              0.897,
                              0.9,
                              0.904,
                              0.911,
                              0.916,
                              0.922,
                              0.925,
                              0.931,
                              0.934,
                              0.941,
                              0.945,
                              0.948,
                              0.955,
                              0.959,
                              0.966,
                              0.97,
                              0.977,
                              0.981,
                              0.989,
                              0.992,
                              1.0
                          ],
                          "type": "line",
                          "name": "production",
                          "marker": {
                              "color": "red"
                          },
                          "shape": "spline"
                      }
                  ],
                  [
                      {
                          "y": [
                              0.0
                          ],
                          "type": "bar",
                          "name": "reference",
                          "marker": {
                              "color": "blue"
                          },
                          "width": "0.25"
                      },
                      {
                          "y": [
                              0.005
                          ],
                          "type": "bar",
                          "name": "production",
                          "marker": {
                              "color": "red"
                          },
                          "width": "0.25"
                      }
                  ]
              ]
          }
      ]
  },
  "cd": {
      "project_name": "insurance_claim",
      "model_name": "insurance",
      "header": "Concept Drift",
      "values": [
          {
              "x": [
                  "accuracy",
                  "auc_roc",
                  "f1_score"
              ],
              "y": [
                  0.95,
                  0.02,
                  0.03
              ],
              "type": "bar",
              "marker": {
                  "color": "green"
              },
              "width": "0.25",
              "barmode": "stack"
          }
      ],
      "layout": {
          "autosize": "false",
          "margin": {
              "l": 50,
              "r": 50,
              "b": 50,
              "t": 50,
              "pad": 0
          },
          "height": 350,
          "width": 875,
          "xaxis": {
              "title": "metrics"
          },
          "yaxis": {
              "title": "Percentage"
          },
          "showlegend": "true"
      },
      "timestamp": "2025-10-23 18:52:12.381070",
      "name": "production metric drift",
      "des": "Concept drift indicates the changes in model performance with respect to various metrics like\n      Accuracy, AUC-ROC, F1 score etc. The Bar Plot given represents percentage concept drift with \n      respect to these metrics."
  },
  "ae": {
      "project_name": "insurance_claim",
      "module_name": "insurance",
      "header": "Adversarial Detection",
      "values": [
          {
              "x": [
                  "Reference Data",
                  "Production Data"
              ],
              "y": [
                  94.999,
                  94.682
              ],
              "type": "bar",
              "mode": "lines+markers",
              "marker": {
                  "color": "blue"
              },
              "width": "0.20",
              "name": "normal"
          },
          {
              "x": [
                  "Reference Data",
                  "Production Data"
              ],
              "y": [
                  5.001,
                  5.318
              ],
              "type": "bar",
              "mode": "lines+markers",
              "marker": {
                  "color": "red"
              },
              "width": "0.20",
              "name": "adversarial"
          }
      ],
      "layout": {
          "autosize": "false",
          "margin": {
              "l": 50,
              "r": 50,
              "b": 50,
              "t": 50,
              "pad": 0
          },
          "height": 350,
          "width": 875,
          "xaxis": {
              "title": "data"
          },
          "yaxis": {
              "title": "Percentage"
          },
          "showlegend": "true"
      },
      "timestamp": "2025-10-23 18:52:14.498710",
      "name": "AE",
      "des": "Adversarial detection indicates the percentage of data points which are adversarial in nature \n      when compared to all data points in reference and production data. We have deployed multiple best in \n      class techniques to identify and detect data points that are perturbated. We are representing \n      adversarial perturbation in reference and production data through a Paired Bar Plot.\n  "},
  "di": {
      "project_name": "insurance_claim",
      "module_name": "insurance",
      "header": "Data Integrity",
      "values": [
          {
              "x": [
                  "Null_values",
                  "Out_of_range_values"
              ],
              "y": [
                  0.0,
                  0.001
              ],
              "type": "bar",
              "mode": "lines+markers",
              "width": "0.25",
              "marker": {
                  "color": "blue"
              },
              "barmode": "stack"
          }
      ],
      "layout": {
          "autosize": "false",
          "margin": {
              "l": 50,
              "r": 50,
              "b": 50,
              "t": 50,
              "pad": 0
          },
          "height": 350,
          "width": 875,
          "xaxis": {
              "title": "metrics"
          },
          "yaxis": {
              "title": "Percentage"
          },
          "showlegend": "true"
      },
      "features": [
          {
              "title": "Gender",
              "nan": "0.0",
              "oor": "0.0",
              "feature_imp": "1.9",
              "layout": [
                  {
                      "autosize": false,
                      "margin": {
                          "l": 40,
                          "r": 12,
                          "b": 30,
                          "t": 14,
                          "pad": 0
                      },
                      "height": 286,
                      "width": 455,
                      "xaxis": {
                          "automargin": "true",
                          "title": ""
                      },
                      "yaxis": {
                          "title": "Percentage"
                      }
                  }
              ],
              "data": [
                  [
                      {
                          "x": [
                              "Feature_importance",
                              "NaN(Null)",
                              "Out of range(OOR)"
                          ],
                          "y": [
                              "1.9",
                              "0.0",
                              "0.0"
                          ],
                          "type": "bar",
                          "marker": {
                              "color": [
                                  "skyblue",
                                  "blue",
                                  "blue"
                              ]
                          },
                          "width": "0.25"
                      }
                  ]
              ]
          },
          {
              "title": "Age",
              "nan": "0.0",
              "oor": "0.0",
              "feature_imp": "17.4",
              "layout": [
                  {
                      "autosize": false,
                      "margin": {
                          "l": 40,
                          "r": 12,
                          "b": 30,
                          "t": 14,
                          "pad": 0
                      },
                      "height": 286,
                      "width": 455,
                      "xaxis": {
                          "automargin": "true",
                          "title": ""
                      },
                      "yaxis": {
                          "title": "Percentage"
                      }
                  }
              ],
              "data": [
                  [
                      {
                          "x": [
                              "Feature_importance",
                              "NaN(Null)",
                              "Out of range(OOR)"
                          ],
                          "y": [
                              "17.4",
                              "0.0",
                              "0.0"
                          ],
                          "type": "bar",
                          "marker": {
                              "color": [
                                  "skyblue",
                                  "blue",
                                  "blue"
                              ]
                          },
                          "width": "0.25"
                      }
                  ]
              ]
          },
          {
              "title": "Driving_License",
              "nan": "0.0",
              "oor": "0.0",
              "feature_imp": "0.1",
              "layout": [
                  {
                      "autosize": false,
                      "margin": {
                          "l": 40,
                          "r": 12,
                          "b": 30,
                          "t": 14,
                          "pad": 0
                      },
                      "height": 286,
                      "width": 455,
                      "xaxis": {
                          "automargin": "true",
                          "title": ""
                      },
                      "yaxis": {
                          "title": "Percentage"
                      }
                  }
              ],
              "data": [
                  [
                      {
                          "x": [
                              "Feature_importance",
                              "NaN(Null)",
                              "Out of range(OOR)"
                          ],
                          "y": [
                              "0.1",
                              "0.0",
                              "0.0"
                          ],
                          "type": "bar",
                          "marker": {
                              "color": [
                                  "skyblue",
                                  "blue",
                                  "blue"
                              ]
                          },
                          "width": "0.25"
                      }
                  ]
              ]
          },
          {
              "title": "Region_Code",
              "nan": "0.0",
              "oor": "0.0",
              "feature_imp": "11.3",
              "layout": [
                  {
                      "autosize": false,
                      "margin": {
                          "l": 40,
                          "r": 12,
                          "b": 30,
                          "t": 14,
                          "pad": 0
                      },
                      "height": 286,
                      "width": 455,
                      "xaxis": {
                          "automargin": "true",
                          "title": ""
                      },
                      "yaxis": {
                          "title": "Percentage"
                      }
                  }
              ],
              "data": [
                  [
                      {
                          "x": [
                              "Feature_importance",
                              "NaN(Null)",
                              "Out of range(OOR)"
                          ],
                          "y": [
                              "11.3",
                              "0.0",
                              "0.0"
                          ],
                          "type": "bar",
                          "marker": {
                              "color": [
                                  "skyblue",
                                  "blue",
                                  "blue"
                              ]
                          },
                          "width": "0.25"
                      }
                  ]
              ]
          },
          {
              "title": "Previously_Insured",
              "nan": "0.0",
              "oor": "0.0",
              "feature_imp": "4.6",
              "layout": [
                  {
                      "autosize": false,
                      "margin": {
                          "l": 40,
                          "r": 12,
                          "b": 30,
                          "t": 14,
                          "pad": 0
                      },
                      "height": 286,
                      "width": 455,
                      "xaxis": {
                          "automargin": "true",
                          "title": ""
                      },
                      "yaxis": {
                          "title": "Percentage"
                      }
                  }
              ],
              "data": [
                  [
                      {
                          "x": [
                              "Feature_importance",
                              "NaN(Null)",
                              "Out of range(OOR)"
                          ],
                          "y": [
                              "4.6",
                              "0.0",
                              "0.0"
                          ],
                          "type": "bar",
                          "marker": {
                              "color": [
                                  "skyblue",
                                  "blue",
                                  "blue"
                              ]
                          },
                          "width": "0.25"
                      }
                  ]
              ]
          },
          {
              "title": "Vehicle_Age",
              "nan": "0.0",
              "oor": "0.0",
              "feature_imp": "1.6",
              "layout": [
                  {
                      "autosize": false,
                      "margin": {
                          "l": 40,
                          "r": 12,
                          "b": 30,
                          "t": 14,
                          "pad": 0
                      },
                      "height": 286,
                      "width": 455,
                      "xaxis": {
                          "automargin": "true",
                          "title": ""
                      },
                      "yaxis": {
                          "title": "Percentage"
                      }
                  }
              ],
              "data": [
                  [
                      {
                          "x": [
                              "Feature_importance",
                              "NaN(Null)",
                              "Out of range(OOR)"
                          ],
                          "y": [
                              "1.6",
                              "0.0",
                              "0.0"
                          ],
                          "type": "bar",
                          "marker": {
                              "color": [
                                  "skyblue",
                                  "blue",
                                  "blue"
                              ]
                          },
                          "width": "0.25"
                      }
                  ]
              ]
          },
          {
              "title": "Vehicle_Damage",
              "nan": "0.0",
              "oor": "0.0",
              "feature_imp": "7.6",
              "layout": [
                  {
                      "autosize": false,
                      "margin": {
                          "l": 40,
                          "r": 12,
                          "b": 30,
                          "t": 14,
                          "pad": 0
                      },
                      "height": 286,
                      "width": 455,
                      "xaxis": {
                          "automargin": "true",
                          "title": ""
                      },
                      "yaxis": {
                          "title": "Percentage"
                      }
                  }
              ],
              "data": [
                  [
                      {
                          "x": [
                              "Feature_importance",
                              "NaN(Null)",
                              "Out of range(OOR)"
                          ],
                          "y": [
                              "7.6",
                              "0.0",
                              "0.0"
                          ],
                          "type": "bar",
                          "marker": {
                              "color": [
                                  "skyblue",
                                  "blue",
                                  "blue"
                              ]
                          },
                          "width": "0.25"
                      }
                  ]
              ]
          },
          {
              "title": "Annual_Premium",
              "nan": "0.0",
              "oor": "0.52",
              "feature_imp": "22.6",
              "layout": [
                  {
                      "autosize": false,
                      "margin": {
                          "l": 40,
                          "r": 12,
                          "b": 30,
                          "t": 14,
                          "pad": 0
                      },
                      "height": 286,
                      "width": 455,
                      "xaxis": {
                          "automargin": "true",
                          "title": ""
                      },
                      "yaxis": {
                          "title": "Percentage"
                      }
                  }
              ],
              "data": [
                  [
                      {
                          "x": [
                              "Feature_importance",
                              "NaN(Null)",
                              "Out of range(OOR)"
                          ],
                          "y": [
                              "22.6",
                              "0.0",
                              "0.52"
                          ],
                          "type": "bar",
                          "marker": {
                              "color": [
                                  "skyblue",
                                  "blue",
                                  "blue"
                              ]
                          },
                          "width": "0.25"
                      }
                  ]
              ]
          },
          {
              "title": "Policy_Sales_Channel",
              "nan": "0.0",
              "oor": "0.04",
              "feature_imp": "8.1",
              "layout": [
                  {
                      "autosize": false,
                      "margin": {
                          "l": 40,
                          "r": 12,
                          "b": 30,
                          "t": 14,
                          "pad": 0
                      },
                      "height": 286,
                      "width": 455,
                      "xaxis": {
                          "automargin": "true",
                          "title": ""
                      },
                      "yaxis": {
                          "title": "Percentage"
                      }
                  }
              ],
              "data": [
                  [
                      {
                          "x": [
                              "Feature_importance",
                              "NaN(Null)",
                              "Out of range(OOR)"
                          ],
                          "y": [
                              "8.1",
                              "0.0",
                              "0.04"
                          ],
                          "type": "bar",
                          "marker": {
                              "color": [
                                  "skyblue",
                                  "blue",
                                  "blue"
                              ]
                          },
                          "width": "0.25"
                      }
                  ]
              ]
          },
          {
              "title": "Vintage",
              "nan": "0.0",
              "oor": "0.0",
              "feature_imp": "24.7",
              "layout": [
                  {
                      "autosize": false,
                      "margin": {
                          "l": 40,
                          "r": 12,
                          "b": 30,
                          "t": 14,
                          "pad": 0
                      },
                      "height": 286,
                      "width": 455,
                      "xaxis": {
                          "automargin": "true",
                          "title": ""
                      },
                      "yaxis": {
                          "title": "Percentage"
                      }
                  }
              ],
              "data": [
                  [
                      {
                          "x": [
                              "Feature_importance",
                              "NaN(Null)",
                              "Out of range(OOR)"
                          ],
                          "y": [
                              "24.7",
                              "0.0",
                              "0.0"
                          ],
                          "type": "bar",
                          "marker": {
                              "color": [
                                  "skyblue",
                                  "blue",
                                  "blue"
                              ]
                          },
                          "width": "0.25"
                      }
                  ]
              ]
          }
      ],
      "timestamp": "2021-06-15 18:52:14.911152",
      "name": "Data Integrity",
      "des": " Data integrity indicates the total percentage of NaN(null) and OOR(Out of range)\n\n        values in the production data as a bar plot. Apart from this, for every feature, we have provided\n\n        the graphs which indicate the feature importance, Nan(null) and OOR(Out of range) percenatge\n\n        of each feature."}
}

const useStyles = makeStyles((theme) => ({
  bar: {
    // display: 'flex',
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
  root: {
    width: '100%',
  },
  margin: {
    margin: theme.spacing(1),
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
  backgroundColor: "red"
}));

// const Plot = createPlotlyComponent(Plotly);

export default function Mlmonitor() {
  const classes = useStyles();
  const executeScroll = (params) => { document.getElementById(params).scrollIntoView() }

  const [progress, setProgress] = React.useState(20);

  const [overallEthics, setOverallScore] = useState("0");
  const [outlier, setOutlier] = useState({});
  const [dataInteg, setDataIntegrity] = useState({});
  const [drift, setDrift] = useState({});
  const [adversarial, setAdversarial] = useState({});
  const [concept, setConcept] = useState({});
  const [bias, setBias] = useState({});
  const [transparency, setTransparency] = useState({});
  const [spinner, setSpinner] = useState(true);


  useEffect(() => {
    
    getData("all")
  }, []);

  const getData = (value) => {
    setSpinner(true)

    if (Object.keys(datasets).length) {
      

      if (datasets['bias']) {
        // setBias(datasets['bias'])
        setBias((sessionStorage.getItem("currentModelName") === "Credit Lending") ? datasets['bias'] : datasetForChaild['bias'])

      }

      if (datasets['transparency']) {
        // setTransparency(datasets['transparency'])
        setTransparency((sessionStorage.getItem("currentModelName") === "Credit Lending") ? datasets['transparency'] : datasetForChaild['transparency'])

      }

      if (datasets['cd']) {
        // setConcept(datasets['cd'])
        setConcept((sessionStorage.getItem("currentModelName") === "Credit Lending") ? datasets['cd'] : datasetForChaild['cd'])

      }
      if (datasets['dd']) {
        // setDrift(datasets['dd'])
        setDrift((sessionStorage.getItem("currentModelName") === "Credit Lending") ? datasets['dd'] : datasetForChaild['dd'])

      }
      if (datasets['od']) {
        // setOutlier(datasets['od'])
        setOutlier((sessionStorage.getItem("currentModelName") === "Credit Lending") ? datasets['od'] : datasetForChaild['od'])

      }
      if (datasets['di']) {
        // setDataIntegrity(datasets['di'])
        setDataIntegrity((sessionStorage.getItem("currentModelName") === "Credit Lending") ? datasets['di'] : datasetForChaild['di'])

      }
    }
    setSpinner(false)

    let localData = JSON.parse(sessionStorage.getItem('MODULE_DATA'))
    // http://127.0.0.1:8000/v2/${value}/`


  }


  return (
    <>
      {/* <Header show={overallEthics}  type=""/> */}
      {/* Page content */}
      {/* {console.log(outlier?.values, "outvalue", data)} */}
      <Container  fluid >
        <PageTitle title="ML Monitoring"/>
        <br/>
        {(spinner) ? <div className={classes.bar}>
          {/* <LinearProgress color="secondary" style={{ backgroundColor: 'rgb(181 29 25)' }} /> */}
          <CircularProgress /> <h5>Loading...</h5>
        </div>
          :
          <>
            
            <Accordion
            style={{
              marginBottom: "10px",
              border: "1px solid #EAECF0",
              borderRadius: "12px",
              boxShadow: "0px 1px 2px 0px #1018280D",
              backgroundColor: "#fff",
            }}
            expanded
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <div className="mlmonitor-accordian-header" >
                      <div
                       style={{color: "#101828", fontWeight:"bold", fontSize: "24px"}}

                      > {outlier.header} </div>
                </div>
            </AccordionSummary>
            <AccordionDetails style={{ width: "100%" }}>
            <Row  id="outlier">
              <Col className=" " xl="12" style={{
                "background-color": "#fff",
              }}>
                {/* <Card className="" style={{ "box-shadow": "1px 1px 7px 0px black", transitionDelay: "1.5s" }}> */}
                

                <Table className="align-items-center table-flush" responsive>

                  <tbody>
                    <tr>
                      <div className="text-wrap" style={{"fontSize":"14px","fontWeight":"400","lineHeight":"22px","textAlign":"left"}}>{outlier.des} </div>
                    </tr>
                    {/* <tr>
                  <th scope="row">Acceptable 
                  Threshold</th>
                  <td>{outlier.threshold}</td>
                </tr> */}
                    <tr>
                      <div  style={{"fontSize":"14px","fontWeight":"400","lineHeight":"28px","textAlign":"left", color: "#101828"}}>Last Calculated: 2025-10-23</div>

                    </tr>
                  </tbody>
                </Table>
                <Col xl="12" className="mt-3" style={{ marginLeft: '0%' }}>

                  
                  {/* </Card> */}

                  <br />
                  
                  {outlier.features && outlier.features.map(x => <div className={classes.root}>
                    <Accordion style={{ marginBottom: "10px", backgroundColor: "#fff" }}>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        <Typography className={classes.heading} style={{ width: "100%" }}>
                          <small style={{ float: "left", width: "200px" }}>Feature : {x.title}</small>
                          <small style={{ marginLeft: (x.status==='Not Detected') ? "19%" : "21%", width: "100px" }}>Impact : {x.feat_imp}</small>

                          <small style={{ marginLeft: "13%", width: "100px" }}>Reference Outlier(%) : {x.train_oulier}</small>
                          <small style={{ float: "right", width: "168px" }} >Production Outlier(%) : {x.test_oulier}</small>
                        </Typography>

                      </AccordionSummary>
                      <AccordionDetails >
                        <Row className="tttt" >

                          <div style={{ display: "inline-flex" }}>
                            {x?.data.length && x.data.map((inlineGrapth, index) =>
                              <Col xl="8" className="" >
                                <Plot
                                  style={{ marginTop: "-2.5%", borderRadius: "25px", marginLeft: "9%" }}
                                  data={inlineGrapth}
                                  layout={x.layout[index]}
                           
                                  config={{
                                    showLink: false,
                                    displayModeBar: false,
                                    responsive: true
                                  }}
                                />
                              </Col>

                            )}
                          </div>
                        </Row>
                      </AccordionDetails>
                    </Accordion>

                  </div>)}

                  {/* <Button className="my-2" type="button" onClick={() => { getData('od') }} style={{ padding: "10px 18px", backgroundColor: "#b82422", marginLeft: "44%", color: "#fff" }}>
                    <small><b>Calculate</b></small>
                  </Button> */}
                </Col>
                <br />
                {/* </Card> */}
              </Col>
            </Row>
            </AccordionDetails>
            </Accordion>
            <Accordion
            style={{
              marginBottom: "10px",
              border: "1px solid #EAECF0",
              borderRadius: "12px",
              boxShadow: "0px 1px 2px 0px #1018280D",
              backgroundColor: "#fff",
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <div className="mlmonitor-accordian-header" >
                      <div
                       style={{color: "#101828", fontWeight:"bold", fontSize: "24px"}}

                      > {drift.header} </div>
                </div>
            </AccordionSummary>
            <AccordionDetails style={{ width: "100%" }}>
            <Row  >
              <Col style={{
                "background-color": "#fff",
              }}>
               

                <Table className="align-items-center " style={{width:"100%",                 "maxWidth": "1000px"}} responsive>
                  <tbody>
                  <tr>
                      <div className="text-wrap" style={{"fontSize":"14px","fontWeight":"400","lineHeight":"22px","textAlign":"left"}}>{drift.des} </div>
                    </tr>
                    
                    <tr>
                      <div  style={{"fontSize":"14px","fontWeight":"400","lineHeight":"28px","textAlign":"left", color: "#101828"}}>Last Calculated: 2025-10-23</div>

                    </tr>
                    
                 
                  </tbody>
                </Table>
                  <Row className="mt-5">

                      <Plot
                        style={{ marginTop: "-2.5%", borderRadius: "25px", alignItems: "center", display: "flex", justifyContent: "center" }}
                        data={drift.values}
                        layout={drift.layout}
                        config={{
                          showLink: false,
                          displayModeBar: false,
                          responsive: true
                        }}
                      />
                  </Row>
                  {/* </Card> */}

                  <br />
                 <Row>
                  {drift.features && drift.features.map(x => <div className={classes.root}>
                    <Accordion style={{ marginBottom: "10px", backgroundColor: "#fff" }}>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        <Typography className={classes.heading} style={{ width: "100%" }}>
                          <small style={{ float: "left", width: "100px" }}>Feature : {x.title}</small>
                          <small style={{ marginLeft: "26%", width: "100px" }}>Drift : {x.status}</small>
                          <small style={{ marginLeft: (x.status === 'Not Detected') ? "19%" : "21%", width: "100px" }}>Impact : {x.feat_imp}</small>
                          <small style={{ float: "right", width: "100px" }} >P-value : {x.pvalue}</small>
                        </Typography>
                      </AccordionSummary>

                      <AccordionDetails >
                        <Row className="tttt" >

                          <div style={{ display: "inline-flex" }}>
                            {x?.data.length && x.data.map((inlineGrapth, index) =>
                              <Col xl="3" className="" style={{ margin: "0 20px", width1: "100%" }}>
                                {/* {console.log(index,'index')} */}

                                <Plot
                                  style={{ marginTop: "-2.5%", borderRadius: "25px" }}
                                  data={inlineGrapth}
                                  layout={x.layout[index]}
                               
                                  config={{
                                    showLink: false,
                                    displayModeBar: false,
                                    responsive: true
                                  }}
                                />
                              </Col>

                            )}
                          </div>
                        </Row>

                      </AccordionDetails>
                    </Accordion>
                  </div>)}
                  </Row>            
                 
                </Col>
                <br />
                {/* </Card> */}
            </Row>
            </AccordionDetails>
            </Accordion>
           
           {/* Adverserial_Detection */}
            {/* <Accordion
            style={{
              marginBottom: "10px",
              border: "1px solid #EAECF0",
              borderRadius: "12px",
              boxShadow: "0px 1px 2px 0px #1018280D",
              backgroundColor: "#fff",
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <div className="mlmonitor-accordian-header" >
                      <div
                       style={{color: "#101828", fontWeight:"bold", fontSize: "24px"}}

                      > {adversarial.header} </div>
                </div>
            </AccordionSummary>   
            <AccordionDetails style={{ width: "100%" }}>
     
            <Row  id="adversarial">
              <Col className=" " xl="12" style={{
                "background-color": "#fff",
          
              }}>
                
                <Table className="align-items-center table-flush" responsive>

                  <tbody>
                  <tr>
                      <div className="text-wrap" style={{"fontSize":"14px","fontWeight":"400","lineHeight":"22px","textAlign":"left"}}>{adversarial.des} </div>
                    </tr>
                    
                    <tr>
                      <div  style={{"fontSize":"14px","fontWeight":"400","lineHeight":"28px","textAlign":"left", color: "#101828"}}>Last Calculated: 2025-10-23</div>

                    </tr>
                    
                 
                  </tbody>
                </Table>
                <Col xl="12" className="mt-3" style={{ marginLeft: '0%' }}>

                  <Plot
                    style={{ marginTop: "-2.5%", borderRadius: "25px", alignItems: "center", display: "flex", justifyContent: "center" }}
                    data={adversarial.values}
                    layout={adversarial.layout}
                    config={{
                      showLink: false,
                      displayModeBar: false,
                      responsive: true
                    }}
                  />
                  

                  <br />
                  {adversarial.features && adversarial.features.map(x => <div className={classes.root}>
                    <Accordion style={{ backgroundColor: " #fff" }}>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        <Typography className={classes.heading} style={{ width: "100%" }}>
                          <span style={{ float: "left", width: "100px" }}>{x.title}</span>
                          <span style={{ marginLeft: "34%", width: "100px" }}>{x.status}</span>
                          <span style={{ float: "right", width: "100px" }} >P-value - {x.pvalue}</span>
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails >
                        <Row className="tttt" >

                          <div style={{ display: "inline-flex" }}>
                            {x?.data.length && x.data.map((inlineGrapth, index) =>
                              <Col xl="6" className="" >

                                <Plot
                                  style={{ marginTop: "-2.5%", borderRadius: "25px", marginLeft: "8%" }}
                                  data={inlineGrapth}
                                  layout={x.layout[index]}
                                  config={{
                                    showLink: false,
                                    displayModeBar: false,
                                    responsive: true
                                  }}
                                />
                              </Col>

                            )}
                          </div>
                        </Row>
                      </AccordionDetails>
                    </Accordion>

                  </div>)}

               
                </Col>
                <br />
               
              </Col>
            </Row>
            </AccordionDetails>
            </Accordion> */}



           {/* Concept Drift */}
            {/* <Accordion
            style={{
              marginBottom: "10px",
              border: "1px solid #EAECF0",
              borderRadius: "12px",
              boxShadow: "0px 1px 2px 0px #1018280D",
              backgroundColor: "#fff",
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <div className="mlmonitor-accordian-header" >
                      <div
                       style={{color: "#101828", fontWeight:"bold", fontSize: "24px"}}

                      > {concept.header} </div>
                </div>
            </AccordionSummary>   
            <AccordionDetails style={{ width: "100%" }}>     
            <Row  id="concept">
              <Col className=" " xl="12" style={{
               
              }}>
               

                <Table className="align-items-center table-flush" responsive>

                  <tbody>
                  <tr>
                      <div className="text-wrap" style={{"fontSize":"14px","fontWeight":"400","lineHeight":"22px","textAlign":"left"}}>{concept.des} </div>
                    </tr>
                    
                    <tr>
                      <div  style={{"fontSize":"14px","fontWeight":"400","lineHeight":"28px","textAlign":"left", color: "#101828"}}>Last Calculated: 2025-10-23</div>

                    </tr>
                   
                  </tbody>
                </Table>
                <Col xl="15" className="mt-3" style={{ marginLeft: '0%' }}>

                  <Plot
                    style={{ marginTop: "-2.5%", borderRadius: "25px", alignItems: "center", display: "flex", justifyContent: "center" }}
                    data={concept.values}
                    layout={concept.layout}
                    config={{
                      showLink: false,
                      displayModeBar: false,
                      responsive: true
                    }}
                  />

                  <br />
                  {concept.features && concept.features.map(x => <div className={classes.root}>
                    <Accordion style={{ backgroundColor: " #fff" }}>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"

                      >
                        <Typography className={classes.heading} style={{ width: "100%" }}>
                          <span style={{ float: "left", width: "100px" }}>{x.title}</span>
                          <span style={{ marginLeft: "34%", width: "100px" }}>{x.status}</span>
                          <span style={{ float: "right", width: "100px" }} >P-value - {x.pvalue}</span>
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails >
                        <Row className="tttt" >

                          <div style={{ display: "inline-flex" }}>
                            {x?.data.length && x.data.map((inlineGrapth, index) =>
                              <Col xl="6" className="" >

                                <Plot
                                  style={{ marginTop: "-2.5%", borderRadius: "25px", marginLeft: "8%" }}
                                  data={inlineGrapth}
                                  layout={x.layout[index]}
                                  config={{
                                    showLink: false,
                                    displayModeBar: false,
                                    responsive: true
                                  }}
                                />
                              </Col>

                            )}
                          </div>
                        </Row>
                      </AccordionDetails>
                    </Accordion>

                  </div>)}

                </Col>
                <br />
              </Col>
            </Row>
            </AccordionDetails>  
            </Accordion> */}
           
            <Accordion
            style={{
              marginBottom: "10px",
              border: "1px solid #EAECF0",
              borderRadius: "12px",
              boxShadow: "0px 1px 2px 0px #1018280D",
              backgroundColor: "#fff",
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <div className="mlmonitor-accordian-header" >
                      <div
                       style={{color: "#101828", fontWeight:"bold", fontSize: "24px"}}

                      >  {dataInteg.header} </div>
                </div>
            </AccordionSummary>   
            <AccordionDetails style={{ width: "100%" }}>     
            <Row  id="DataIntegrity">
              <Col className=" " xl="12" style={{
               
              }}>
               

                <Table className="align-items-center table-flush" responsive>
                  <tbody>
                  <tr>
                      <div className="text-wrap" style={{"fontSize":"14px","fontWeight":"400","lineHeight":"22px","textAlign":"left"}}>{dataInteg.des} </div>
                    </tr>
                    
                    <tr>
                      <div  style={{"fontSize":"14px","fontWeight":"400","lineHeight":"28px","textAlign":"left", color: "#101828"}}>Last Calculated: 2025-10-23</div>

                    </tr>
                    
                  </tbody>
                </Table>
                <Col xl="12" className="" >
                  <Row className="mt-5 tttt">

                    <Col xl="12" className="" >
                      <Plot
                        style={{ marginTop: "-2.5%", borderRadius: "25px", alignItems: "center", display: "flex", justifyContent: "center" }}
                        data={dataInteg.values}
                        layout={dataInteg.layout}

                        config={{
                          showLink: false,
                          displayModeBar: false,
                          responsive: true
                        }}
                      />
                    </Col>
                  </Row>
                  {/* </Card> */}

                  <br />
                  {dataInteg.features && dataInteg.features.map(x => <div className={classes.root}>
                    <Accordion style={{ marginBottom: "10px", backgroundColor: "#fff" }}>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        <Typography className={classes.heading} style={{ width: "100%" }}>
                          <small style={{ float: "left", width: "100px" }}>Feature : {x.title}</small>
                          <small style={{ marginLeft: "23%", width: "100px" }}>Nan(null)(%) : {x.nan}</small>
                          <small style={{ marginLeft: "17%", width: "100px" }}>OOR(Out of range(%) : {x.oor}</small>
                          <small style={{ float: "right", width: "100px" }} >Feature-imp(%) : {x.feature_imp}</small>
                        </Typography>
                      </AccordionSummary>

                      <AccordionDetails >
                        <Row className="tttt" >

                          <div style={{ display: "inline-flex" }}>
                            {x?.data.length && x.data.map((inlineGrapth, index) =>
                              <Col xl="3" className="" style={{ margin: "0 20px", width1: "100%" }}>
                                {/* {console.log(index,'index')} */}

                                <Plot
                                  style={{ marginTop: "-2.5%", borderRadius: "25px" }}
                                  data={inlineGrapth}
                                  layout={x.layout[index]}
                                  
                                  config={{
                                    showLink: false,
                                    displayModeBar: false,
                                    responsive: true
                                  }}
                                />
                              </Col>

                            )}
                          </div>
                        </Row>

                      </AccordionDetails>
                    </Accordion>
                  </div>)}

                </Col>
                <br />
                {/* </Card> */}
              </Col>
            </Row>
            </AccordionDetails>  
            </Accordion>
          </>
        }

      </Container>
      <ToastContainer />
    </>
  );
};


